import { VDialog, VBtn, VLayout, VAlert, VTooltip, VIcon, VSubheader, VListItem, VList, VBottomSheet, VListItemTitle, VMenu, VStepperStep, VStepper, VProgressCircular, VCheckbox, VTextField, VListItemGroup, VDivider, VSheet, VSwitch, VChip, VCol, VRow, VContainer, VTextarea, VSelect, VSnackbar, VCard, VStepperContent, VStepperItems, VBadge, VRadio, VRadioGroup, VBtnToggle, Intersect, VAutocomplete } from 'vuetify/lib';

//
//
//
//
//
//
//
//
//
//
//
var script$Y = {
  components: {
    VDialog: VDialog
  },

  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    offsetClass: function () {
      return this.useOffset ? 'offset' : '';
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": _vm.fullscreen,
      "value": true,
      "content-class": "VcModalWrapper " + _vm.contentClass + " " + _vm.offsetClass
    },
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        return _vm.$emit('onCloseButtonClicked');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('onEnterClicked');
      }],
      "click:outside": function ($event) {
        return _vm.$emit('onClickOutside');
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$Y = function (inject) {
  if (!inject) return;
  inject("data-v-2f9f1f74_0", {
    source: ".VcModalWrapper{position:relative;width:auto;background-color:var(--modal-bg-color);box-shadow:var(--modal-box-shadow)}@media screen and (min-width:960px){.VcModalWrapper{margin:0 24px}.VcModalWrapper.offset{left:var(--modal-desktop-offset)}#app[dir=rtl] .VcModalWrapper.offset{left:auto;right:var(--modal-desktop-offset)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Y = undefined;
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, createInjector, undefined, undefined);

var script$X = {
  name: "VcIcon",
  props: {
    dataQa: {
      type: String,
      default: 'VcIcon'
    }
  },
  render: function (createElement) {
    const props = {
      attrs: { ...this.$attrs,
        'data-qa': this.dataQa
      },
      on: this.$listeners
    };
    return createElement('v-icon', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$X = script$X;
/* template */

/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = undefined;
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

var script$W = {
  name: "VcButton",
  components: {
    VcIcon: __vue_component__$X,
    VBtn: VBtn
  },
  props: {
    label: {
      type: String,
      required: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    elevation: {
      type: Number,
      default: 0
    },
    xSmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      comment: "deprecated, you should use flavor",
      default: "secondary",
      validator: type => {
        return ["secondary", "white"].indexOf(type) > -1;
      }
    },
    flavor: {
      type: String,
      validator: type => {
        return ["secondary", "primary"].indexOf(type) > -1;
      },
      default: 'primary'
    },
    ghost: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    fab: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      required: false
    },
    ripple: {
      type: Boolean
    },
    href: {
      type: String,
      comment: "This param will change the <button> to <a> with link"
    },
    prependDefaultIcon: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: "vc-btn"
    }
  },
  computed: {
    buttonColor() {
      switch (this.flavor) {
        case "primary":
          // When the flavor is primary, the theme color is the value in secondary color
          return this.color;

        case "secondary":
          return this.outlined ? '--gray-darken-5' : '--neutral-lighten-2';
      }
    }

  }
};

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-btn', {
    class: "VcButton " + this.flavor + "__text",
    attrs: {
      "color": _vm.flavor ? _vm.buttonColor : _vm.color,
      "icon": _vm.icon,
      "fab": _vm.fab,
      "outlined": _vm.outlined,
      "text": _vm.ghost,
      "rounded": _vm.pill,
      "plain": _vm.plain,
      "x-small": _vm.xSmall,
      "small": _vm.small,
      "large": _vm.large,
      "x-large": _vm.xLarge,
      "ripple": _vm.ripple,
      "elevation": _vm.elevation,
      "width": _vm.width,
      "min-width": "0",
      "loading": _vm.loading,
      "block": _vm.block,
      "disabled": _vm.disabled,
      "href": _vm.href,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._t("prepend", function () {
    return [_vm.prependDefaultIcon ? _c('VcIcon', {
      staticClass: "prependDefaultIcon",
      attrs: {
        "small": ""
      }
    }, [_vm._v("$plus")]) : _vm._e()];
  }), _vm._v("\n  " + _vm._s(_vm.label || _vm.$slots.default && _vm.$slots.default[0].text || "") + "\n  "), _vm._t("append")], 2);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$W = function (inject) {
  if (!inject) return;
  inject("data-v-1b007814_0", {
    source: ".VcButton[data-v-1b007814]{letter-spacing:var(--letter-spacing)}.VcButton[data-v-1b007814]:disabled{background-color:var(--gray-lighten-2);color:var(--gray-darken-2)}.VcButton .prependDefaultIcon[data-v-1b007814]{margin-inline-end:var(--size-value3)}.VcButton .prependDefaultIcon[data-v-1b007814]  svg{fill:currentColor}.VcButton.secondary__text[data-v-1b007814]{color:var(--gray-darken-5)!important;border-color:var(--neutral-lighten-1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$W = "data-v-1b007814";
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, createInjector, undefined, undefined);

var script$V = {
  name: 'VcModalContainer',
  components: {
    VcButton: __vue_component__$W,
    VcModalWrapper: __vue_component__$Y,
    VcIcon: __vue_component__$X,
    VLayout: VLayout
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['sm', 'md', 'lg', 'xl', 'responsive'].includes(prop)
    },
    showHeaderDivider: {
      type: Boolean,
      default: false
    },
    showFooterDivider: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    flavor: {
      type: String,
      required: false,
      validator: prop => ['', 'confirm', 'notice', 'input', 'prominent'].includes(prop)
    }
  },
  computed: {
    displayCloseButton() {
      if (this.flavor === 'input' && !this.$vuetify.breakpoint.mdAndUp) return false;
      return this.showCloseButton;
    }

  }
};

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showDialog ? _c('VcModalWrapper', {
    attrs: {
      "useOffset": _vm.useOffset,
      "contentClass": _vm.size + " VcModalContainer " + (_vm.flavor ? _vm.flavor : 'unflavored')
    },
    on: {
      "click-outside": function ($event) {
        return _vm.$emit('onClickOutside');
      },
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      },
      "enterPressed": function ($event) {
        return _vm.$emit('onEnterClicked');
      }
    }
  }, [[_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('header', {
    class: {
      'showDivider': _vm.showHeaderDivider
    }
  }, [_vm._t("header"), _vm._v(" "), _vm.displayCloseButton ? _c('VcButton', {
    staticClass: "VcModalCloseButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('svg', {
          attrs: {
            "width": "14",
            "height": "14",
            "viewBox": "0 0 14 14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M12.3047 13.0138L13.0119 12.3066C13.1093 12.2091 13.1093 12.0507 13.0119 11.9532L8.05931 7.00064L13.0065 2.05349C13.104 1.95599 13.104 1.79754 13.0065 1.70007L12.2993 0.992855C12.2018 0.895382 12.0434 0.895382 11.9459 0.992855L6.99867 5.94L2.04911 0.99012C1.9516 0.892616 1.79316 0.892616 1.69568 0.99012L0.988167 1.6973C0.890663 1.79481 0.890663 1.95325 0.988167 2.05076L5.93803 7.00064L0.993702 11.9447C0.896198 12.0422 0.896198 12.2006 0.993702 12.2981L1.70088 13.0053C1.79839 13.1028 1.95683 13.1028 2.05434 13.0053L6.99867 8.06127L11.9512 13.0138C12.0487 13.1113 12.2072 13.1113 12.3047 13.0138Z",
            "fill": "black",
            "fill-opacity": "0.4"
          }
        })])];
      },
      proxy: true
    }], null, false, 4251314713)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "VcModalContainerContent"
  }, [_vm._t("content")], 2), _vm._v(" "), !!_vm.$slots.footer ? _c('footer', {
    class: {
      'showDivider': _vm.showFooterDivider
    }
  }, [_vm._t("footer")], 2) : _vm._e()])]], 2) : _vm._e();
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$V = function (inject) {
  if (!inject) return;
  inject("data-v-35c8f07c_0", {
    source: ".VcModalContainer{overflow-y:hidden;height:auto;min-height:100px;min-width:300px;display:flex}.VcModalContainer.sm{width:var(--modal-width-small)}.VcModalContainer.md{width:var(--modal-width-medium)}.VcModalContainer.lg{width:var(--modal-width-large)}.VcModalContainer.xl{width:var(--modal-width-x-large)}.VcModalContainer.responsive{width:100%;margin:0 24px}.VcModalContainer .VcModalContainerContent,.VcModalContainer footer,.VcModalContainer header{flex-shrink:0}.VcModalContainer header{display:flex;justify-content:space-between}.VcModalContainer header .VcModalCloseButton{position:absolute;z-index:1;inset-inline-end:5px;top:var(--size-value2)}.VcModalContainer header .VcModalCloseButton .VcIcon{font-size:22px}.VcModalContainer header.showDivider{border-bottom:1px solid rgba(0,0,0,.12)}.VcModalContainer .VcModalContainerContent{overflow-y:auto;overflow-x:hidden;height:calc(100% - 138px);line-height:var(--size-value6);flex-grow:1;font-size:var(--font-size-small);padding:0 var(--size-value6) var(--size-value6)}.VcModalContainer footer{padding:var(--size-value3) var(--size-value4) var(--size-value3);text-align:right}#app[dir=rtl] .VcModalContainer footer{text-align:left}.VcModalContainer footer.showDivider{border-top:1px solid rgba(0,0,0,.12)}@media screen and (min-width:960px){.VcModalContainer footer{padding:var(--size-value3) var(--size-value6) var(--size-value3)}}.VcModalContainer.notice header,.VcModalContainer.prominent header{font-weight:var(--font-weight-xl);font-size:var(--font-size-medium2);padding-bottom:0;padding-top:var(--size-value10)}.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{padding:0;min-height:168px;height:calc(100% - 497px)}@media screen and (min-width:960px){.VcModalContainer.notice .VcModalContainerContent,.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value2)}}.VcModalContainer.notice footer,.VcModalContainer.prominent footer{padding-top:var(--size-value3);padding-bottom:0}.VcModalContainer.notice.responsive .VcModalContainerContent,.VcModalContainer.notice.sm .VcModalContainerContent,.VcModalContainer.prominent.responsive .VcModalContainerContent,.VcModalContainer.prominent.sm .VcModalContainerContent{margin-left:var(--size-value6);padding-right:var(--size-value6)}.VcModalContainer.notice.md .VcModalContainerContent,.VcModalContainer.prominent.md .VcModalContainerContent{margin-left:var(--size-value10);padding-right:var(--size-value10)}.VcModalContainer.notice.lg header,.VcModalContainer.prominent.lg header{height:initial}.VcModalContainer.notice.lg .VcModalContainerContent,.VcModalContainer.prominent.lg .VcModalContainerContent{min-height:0;margin-left:var(--size-value16);padding-right:var(--size-value16)}.VcModalContainer.prominent .VcModalContainerContent{margin-bottom:var(--size-value6)}.VcModalContainer.input.responsive{height:100%;margin:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.VcModalContainer.input .VcModalContainerContent{height:auto;padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$V = undefined;
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, createInjector, undefined, undefined);

var script$U = {
  name: "VcLayout",
  render: function (createElement) {
    // `<v-layout><slot></slot></v-layout>`
    const props = {
      attrs: { ...this.$attrs
      },
      on: this.$listeners
    };
    return createElement('v-layout', props, this.$slots.default);
  }
};

/* script */
const __vue_script__$U = script$U;
/* template */

/* style */

const __vue_inject_styles__$U = undefined;
/* scoped */

const __vue_scope_id__$U = "data-v-0751575a";
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

var script$T = {
  name: "VcModalFooter",
  components: {
    VcLayout: __vue_component__$U,
    VcButton: __vue_component__$W
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    buttons: {
      type: Array,
      default: () => [{
        label: 'ok',
        event: 'onOkClicked',
        color: 'white'
      }, {
        label: 'cancel',
        event: 'onCancelClicked',
        color: 'secondary'
      }],
      validator: prop => prop.every(e => e.label && e.event)
    },
    dataQa: {
      type: String,
      default: 'vc-footer'
    }
  }
};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcModalFooter " + _vm.direction,
    attrs: {
      "column": _vm.direction === 'vertical',
      "justify-end": _vm.$vuetify.breakpoint.mdAndUp && _vm.direction === 'horizontal',
      "align-center": !_vm.$vuetify.breakpoint.mdAndUp || _vm.direction === 'vertical',
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.buttons, function (button) {
    return _c('VcButton', {
      key: button.event,
      staticClass: "VcFooterButton",
      attrs: {
        "color": button.color,
        "label": button.label,
        "loading": button.loading || false,
        "large": !_vm.$vuetify.breakpoint.mdAndUp,
        "data-qa": _vm.dataQa + "-" + button.label
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(button.event);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$T = function (inject) {
  if (!inject) return;
  inject("data-v-79ae858b_0", {
    source: ".VcModalFooter.vertical .VcFooterButton[data-v-79ae858b]{width:100%;margin-bottom:var(--size-value2)}.VcModalFooter.vertical .VcFooterButton[data-v-79ae858b]:last-of-type{margin-bottom:0}@media screen and (min-width:960px){.VcModalFooter.vertical .VcFooterButton[data-v-79ae858b]{width:auto}}.VcModalFooter.horizontal .VcFooterButton[data-v-79ae858b]{flex-basis:0;flex-grow:1}.VcModalFooter.horizontal .VcFooterButton[data-v-79ae858b]:first-of-type{margin-left:0}.VcModalFooter.horizontal .VcFooterButton[data-v-79ae858b]:last-of-type{margin-right:0}@media screen and (min-width:960px){.VcModalFooter.horizontal .VcFooterButton[data-v-79ae858b]{flex-basis:auto;flex-grow:0}}.VcModalFooter .VcFooterButton[data-v-79ae858b]{margin-left:var(--size-value1);margin-right:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$T = "data-v-79ae858b";
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, createInjector, undefined, undefined);

var script$S = {
  name: "VcModalHeader",
  components: {
    VcLayout: __vue_component__$U,
    VcIcon: __vue_component__$X,
    VcButton: __vue_component__$W
  },
  props: {
    topTitle: {
      Type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    subtitle: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    flavor: {
      type: String,
      default: 'confirm',
      validator: prop => ['confirm', 'input'].includes(prop)
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-header'
    }
  },
  computed: {
    isBackButtonDisplayed() {
      return this.flavor === 'input' && this.showBackButton && !this.$vuetify.breakpoint.mdAndUp;
    },

    isCloseButtonStyle() {
      return !this.closeButton && !this.isBackButtonDisplayed ? 'no-close-button' : '';
    }

  }
};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcHeader " + _vm.flavor + " " + _vm.isCloseButtonStyle,
    attrs: {
      "align-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.isBackButtonDisplayed ? _c('VcButton', {
    staticClass: "VcHeaderButton",
    attrs: {
      "icon": "",
      "fab": "",
      "small": "",
      "width": 24
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('svg', {
          attrs: {
            "width": "8",
            "height": "14",
            "viewBox": "0 0 8 14",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M7.45226 13.8605L7.67324 13.6396C7.81969 13.4931 7.81969 13.2557 7.67324 13.1092L1.56409 7.00006L7.67324 0.890882C7.81969 0.744459 7.81969 0.507003 7.67324 0.360549L7.45226 0.139602C7.30584 -0.0068206 7.06841 -0.0068206 6.92196 0.139602L0.326637 6.73489C0.180183 6.88135 0.180183 7.11877 0.326637 7.26526L6.92196 13.8605C7.06841 14.007 7.30584 14.007 7.45226 13.8605Z",
            "fill": "black",
            "fill-opacity": "0.4"
          }
        })])];
      },
      proxy: true
    }], null, false, 3344096172)
  }) : _vm._e(), _vm._v(" "), _vm._t("headerImage", function () {
    return [_vm.image ? _c('img', {
      staticClass: "VcHeaderImage",
      attrs: {
        "src": _vm.image
      }
    }) : _vm._e(), _vm._v(" "), _vm.icon ? _c('VcIcon', {
      staticClass: "VcHeaderIcon",
      attrs: {
        "color": "warning"
      }
    }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()];
  }), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_vm.topTitle ? _c('div', {
    staticClass: "VcHeaderTopTitle"
  }, [_vm._v(_vm._s(_vm.topTitle))]) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "justify-space-between": !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), !!_vm.description ? _c('div', {
    staticClass: "VcHeaderDescription"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]), _vm._v(" "), _vm.subtitle ? _c('div', {
    staticClass: "VcHeaderSubtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()], 1)], 1), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button",
    attrs: {
      "ripple": false,
      "data-qa": _vm.dataQa + "-close-button",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('vc-icon', {
          staticClass: "mobile-close-icon"
        }, [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 1696536375)
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$S = function (inject) {
  if (!inject) return;
  inject("data-v-0446c685_0", {
    source: ".VcHeader[data-v-0446c685]{padding:var(--size-value4);font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:var(--size-value7);letter-spacing:var(--letter-spacing)}@media screen and (min-width:960px){.VcHeader[data-v-0446c685]{padding:var(--size-value4) var(--size-value4) var(--size-value4) var(--size-value6)}}.VcHeader.no-close-button[data-v-0446c685]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small2);padding:var(--size-value4) var(--size-value6) var(--size-value0)}.VcHeader.no-close-button.input[data-v-0446c685]{padding-block-end:var(--size-value0)}.VcHeader .VcHeaderImage[data-v-0446c685]{width:var(--size-value8);margin-right:var(--size-value3);padding:5px;border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:var(--border-radius)}.VcHeader .VcHeaderTopTitle[data-v-0446c685]{font-size:11px;font-weight:var(--font-weight-medium);line-height:var(--size-value3);color:var(--gray-darken-3)}.VcHeader .VcHeaderTitleWithPadding[data-v-0446c685]{padding-left:var(--size-value6)}.VcHeader .VcHeaderDescription[data-v-0446c685]{font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium);line-height:var(--size-value4);color:var(--gray-darken-4)}.VcHeader .VcHeaderSubtitle[data-v-0446c685]{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium);color:var(--gray-darken-5);padding-left:var(--size-value2)}.VcHeader.confirm[data-v-0446c685]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:var(--size-value7);display:flex;align-items:flex-end;letter-spacing:var(--letter-spacing);color:var(--gray-darken-5);padding-inline:var(--size-value6) var(--size-value4)}@media screen and (min-width:960px){.VcHeader.confirm[data-v-0446c685]{font-weight:var(--font-weight-large2);padding-bottom:var(--size-value1);padding-top:var(--size-value6)}}.VcHeader.confirm .VcHeaderButton[data-v-0446c685],.VcHeader.input .VcHeaderButton[data-v-0446c685]{max-height:24px;margin-right:var(--size-value3)}.VcHeader.confirm .VcHeaderIcon[data-v-0446c685],.VcHeader.input .VcHeaderIcon[data-v-0446c685]{padding-right:var(--size-value3);font-size:var(--font-size-medium)}@media screen and (min-width:960px){.VcHeader.input[data-v-0446c685]{padding-bottom:var(--size-value3)}}.VcHeader .close-button[data-v-0446c685]{height:var(--size-value3);width:var(--size-value3);padding:unset}.VcHeader .close-button .mobile-close-icon[data-v-0446c685]{fill:var(--gray-darken-2);width:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$S = "data-v-0446c685";
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, createInjector, undefined, undefined);

var script$R = {
  name: "VcConfirmModal",
  components: {
    VcModalHeader: __vue_component__$S,
    VcLayout: __vue_component__$U,
    VcModalFooter: __vue_component__$T,
    VcIcon: __vue_component__$X,
    VcModalContainer: __vue_component__$V
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    contentText: {
      type: String,
      required: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['sm', 'md', 'lg'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showCloseButton": "",
      "useOffset": _vm.useOffset,
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive'
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "topTitle": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "confirm"
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_vm._t("content", function () {
          return [_vm._v(" " + _vm._s(_vm.contentText) + " ")];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "buttons": [{
                label: _vm.cancelButtonLabel || _vm.$dst("ds.modal.cancel"),
                event: "onCancelClicked",
                color: "white",
                loading: _vm.loading
              }, {
                label: _vm.okButtonLabel || _vm.$dst("ds.modal.ok"),
                event: "onOkClicked",
                color: "secondary",
                loading: _vm.loading
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = "data-v-5b1ba5c6";
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

var script$Q = {
  name: "VcForm",
  methods: {
    validate() {
      this.form.componentInstance.validate();
    }

  },
  render: function (createElement) {
    // `<v-form><slot></slot></v-form>`
    const props = {
      attrs: this.$attrs,
      on: this.$listeners
    };
    this.form = createElement('v-form', props, this.$slots.default);
    return this.form;
  }
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

/* style */

const __vue_inject_styles__$Q = undefined;
/* scoped */

const __vue_scope_id__$Q = "data-v-398cf17d";
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = undefined;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

var script$P = {
  name: "VcInputModal",
  components: {
    VcForm: __vue_component__$Q,
    VcLayout: __vue_component__$U,
    VcModalFooter: __vue_component__$T,
    VcIcon: __vue_component__$X,
    VcModalContainer: __vue_component__$V,
    VcModalHeader: __vue_component__$S
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    topTitle: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    headerIcon: {
      type: String,
      required: false
    },
    headerImage: {
      type: String,
      required: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-input-modal'
    }
  },
  data: () => ({
    mainValid: true,
    additionalValid: true
  }),
  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.mainValid && this.additionalValid
      });
    },

    validate() {
      this.$refs.mainForm.validate();
      this.$refs.additionalForm && this.$refs.additionalForm.validate();
    },

    onMainFormValueChanged(value) {
      this.mainValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    },

    onAdditionalFormValueChanged(value) {
      this.additionalValid = value;
      this.$emit('onValidationChanged', {
        valid: this.mainValid && this.additionalValid
      });
    }

  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showHeaderDivider": "",
      "showCloseButton": "",
      "flavor": "input",
      "useOffset": _vm.useOffset,
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive'
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._t("header", function () {
          return [_c('VcModalHeader', {
            attrs: {
              "topTitle": _vm.topTitle,
              "title": _vm.title,
              "subtitle": _vm.subtitle,
              "icon": _vm.headerIcon,
              "image": _vm.headerImage,
              "flavor": "input",
              "close-button": _vm.closeButton,
              "data-qa": _vm.dataQa + "-header",
              "show-back-button": _vm.showBackButton
            },
            on: {
              "onCloseButtonClicked": function ($event) {
                return _vm.$emit('onCloseButtonClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          staticClass: "VcInputForm-layout"
        }, [_c('VcForm', {
          ref: "mainForm",
          staticClass: "VcInputForm-main",
          attrs: {
            "value": _vm.mainValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onMainFormValueChanged
          }
        }, [_vm._t("content")], 2), _vm._v(" "), _vm.$slots.additional && _vm.size === 'lg' && _vm.$vuetify.breakpoint.mdAndUp ? _c('VcForm', {
          ref: "additionalForm",
          staticClass: "VcInputForm-additional",
          attrs: {
            "value": _vm.additionalValid,
            "lazy-validation": ""
          },
          on: {
            "input": _vm.onAdditionalFormValueChanged
          }
        }, [_vm._t("additional")], 2) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            attrs: {
              "buttons": [{
                label: _vm.cancelButtonLabel || _vm.$dst("ds.modal.cancel"),
                event: "onCancelClicked",
                color: "white"
              }, {
                label: _vm.okButtonLabel || _vm.$dst("ds.modal.ok"),
                event: "onOkClicked",
                color: "secondary"
              }]
            },
            on: {
              "onOkClicked": _vm.onOkClicked,
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = function (inject) {
  if (!inject) return;
  inject("data-v-66b94d97_0", {
    source: ".VcInputForm-layout .VcInputForm-main[data-v-66b94d97]{width:100%;max-width:100%;padding:var(--size-value6)}.VcInputForm-layout .VcInputForm-additional[data-v-66b94d97]{min-width:324px;padding:var(--size-value6);background:#f8f9fb;border-left:1px solid rgba(0,0,0,.12)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$P = "data-v-66b94d97";
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, createInjector, undefined, undefined);

var script$O = {
  name: "VcImage",
  components: {
    VcLayout: __vue_component__$U
  },
  props: {
    image: {
      type: [String, Object],
      required: true
    },
    dataQa: {
      type: String,
      default: 'VcImage'
    }
  }
};

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcImage",
    attrs: {
      "justify-content-center": "",
      "data-qa": _vm.dataQa
    }
  }, [_vm.image && typeof _vm.image === 'string' ? _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image
    }
  }) : _c(_vm.image, {
    tag: "component",
    staticClass: "image"
  })], 1);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = function (inject) {
  if (!inject) return;
  inject("data-v-46be532e_0", {
    source: ".VcImage[data-v-46be532e]{height:100%;justify-content:center}.VcImage[data-v-46be532e]  img{height:100%}.VcImage[data-v-46be532e]  svg{max-width:100%;height:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$O = "data-v-46be532e";
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, createInjector, undefined, undefined);

var script$N = {
  name: "VcNoticeModal",
  components: {
    VcImage: __vue_component__$O,
    VcLayout: __vue_component__$U,
    VcModalFooter: __vue_component__$T,
    VcModalContainer: __vue_component__$V
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    image: {
      type: [String, Object]
    },
    icon: {
      type: [String, Object],
      comment: 'deprecated'
    },
    titleText: {
      type: String,
      required: true
    },
    subtitleText: {
      type: String,
      required: true
    },
    contentText: {
      type: String,
      required: false
    },
    useOffset: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg',
      // required
      validator: prop => ['md', 'lg', 'sm'].includes(prop)
    },
    flavor: {
      type: String,
      default: 'notice',
      validator: prop => ['notice', 'prominent'].includes(prop)
    },
    okButtonLabel: {
      type: String,
      required: false
    },
    cancelButtonLabel: {
      type: String,
      required: false
    }
  },
  computed: {
    currentImage() {
      // for backward compatibility
      return this.image || this.icon;
    }

  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcModalContainer', {
    attrs: {
      "showFooterDivider": _vm.flavor === 'prominent',
      "flavor": _vm.flavor,
      "useOffset": _vm.useOffset,
      "showDialog": _vm.showDialog,
      "size": _vm.$vuetify.breakpoint.mdAndUp ? _vm.size : 'responsive',
      "showCloseButton": ""
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('onCloseButtonClicked');
      }
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('VcLayout', {
          class: "VcNoticeHeader " + _vm.flavor,
          attrs: {
            "column": "",
            "align-content-center": ""
          }
        }, [_c('VcImage', {
          staticClass: "VcNoticeImage",
          class: "" + _vm.size,
          attrs: {
            "image": _vm.currentImage
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "VcNoticeHeaderText"
        }, [_vm._v(_vm._s(_vm.titleText))])], 1), _vm._v(" "), _c('VcLayout', {
          class: "VcNoticeSubtitle " + _vm.flavor,
          attrs: {
            "column": ""
          }
        }, [_vm._v(_vm._s(_vm.subtitleText))]), _vm._v(" "), _vm._t("content", function () {
          return [_vm.contentText ? _c('VcLayout', {
            class: "VcNoticeContent " + _vm.size,
            attrs: {
              "column": ""
            }
          }, [_vm._v("\n        " + _vm._s(_vm.contentText) + "\n      ")]) : _vm._e()];
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c('VcModalFooter', {
            staticClass: "VcNoticeFooter",
            attrs: {
              "direction": "vertical",
              "buttons": [{
                label: _vm.okButtonLabel || _vm.$dst("ds.modal.ok"),
                event: "onOkClicked",
                color: "secondary"
              }, {
                label: _vm.cancelButtonLabel || _vm.$dst("ds.modal.cancel"),
                event: "onCancelClicked",
                color: "white"
              }]
            },
            on: {
              "onOkClicked": function ($event) {
                return _vm.$emit('onOkClicked');
              },
              "onCancelClicked": function ($event) {
                return _vm.$emit('onCancelClicked');
              }
            }
          })];
        })];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = function (inject) {
  if (!inject) return;
  inject("data-v-d8b2c82a_0", {
    source: ".VcNoticeImage[data-v-d8b2c82a]{margin-bottom:var(--size-value4)}.VcNoticeImage.md[data-v-d8b2c82a],.VcNoticeImage.responsive[data-v-d8b2c82a],.VcNoticeImage.sm[data-v-d8b2c82a]{height:160px}.VcNoticeImage.lg[data-v-d8b2c82a]{height:208px}.VcNoticeContent[data-v-d8b2c82a],.VcNoticeHeader[data-v-d8b2c82a],.VcNoticeSubtitle[data-v-d8b2c82a]{text-align:center;line-height:24px}.VcNoticeHeader[data-v-d8b2c82a]{text-align:center;align-items:center;font-size:18px;font-weight:600;line-height:28px}@media screen and (min-width:960px){.VcNoticeHeader[data-v-d8b2c82a]{font-size:24px;font-weight:800;line-height:var(--size-value10)}}.VcNoticeHeader .VcNoticeHeaderText[data-v-d8b2c82a]{padding-bottom:var(--size-value2)}.VcNoticeHeader.prominent .VcNoticeHeaderText[data-v-d8b2c82a]{font-size:18px;font-weight:600}.VcNoticeSubtitle[data-v-d8b2c82a]{font-size:15px;font-weight:var(--font-weight-medium);line-height:var(--size-value6)}@media screen and (min-width:960px){.VcNoticeSubtitle[data-v-d8b2c82a]{font-size:var(--font-size-small)}}.VcNoticeSubtitle.prominent[data-v-d8b2c82a]{font-size:15px}.VcNoticeContent[data-v-d8b2c82a]{background:#eafcf2;border:1px solid #cff8e1;box-sizing:border-box;border-radius:8px;padding:var(--size-value3) var(--size-value4);margin-top:var(--size-value4);line-height:20px;font-size:13px}@media screen and (min-width:960px){.VcNoticeContent[data-v-d8b2c82a]{line-height:21px;font-size:14px}}.VcNoticeFooter[data-v-d8b2c82a]{padding-bottom:var(--size-value10)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$N = "data-v-d8b2c82a";
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, createInjector, undefined, undefined);

var script$M = {
  name: "VcAlert",
  components: {
    VcIcon: __vue_component__$X,
    VcButton: __vue_component__$W,
    VcLayout: __vue_component__$U,
    VAlert: VAlert
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: prop => ['attention', 'warning', 'info', 'success'].includes(prop)
    },
    headerText: {
      type: String
    },
    bodyText: {
      type: String
    },
    buttonText: {
      type: String
    },
    isStripe: {
      type: Boolean,
      default: false
    },
    isInline: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    isInlineHeader: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-alert'
    }
  },
  computed: {
    getStripe() {
      return this.isStripe ? ' stripe' : '';
    },

    getInline() {
      return this.isInline ? ' inline' : '';
    },

    getClass() {
      return `vcita-alert-${this.type}${this.getStripe}${this.getInline}`;
    },

    getIcon() {
      if (this.isInline) {
        switch (this.type) {
          case 'warning':
            return '$warning_fill';

          case 'info':
            return '$info_fill';

          case 'success':
            return '$check_fill';

          default:
            return '$attention_fill';
        }
      }

      switch (this.type) {
        case 'warning':
          return '$warning';

        case 'info':
          return '$info';

        case 'success':
          return '$check_circle';

        default:
          return '$error';
      }
    },

    getBodyText() {
      if (this.isInlineHeader && this.headerText) {
        return `<span class="alert-header">${this.headerText}</span> ${this.bodyText}`;
      }

      return this.bodyText;
    }

  }
};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VAlert', {
    staticClass: "dialog-alert",
    class: _vm.getClass,
    attrs: {
      "data-qa": _vm.dataQa,
      "icon": _vm.getIcon
    }
  }, [_c('VcLayout', {
    staticClass: "alert-content",
    class: {
      'dialog-alert__close-btn': _vm.closeButton
    },
    attrs: {
      "align-start": "",
      "column": ""
    }
  }, [_vm.headerText && !_vm.isInlineHeader ? _c('span', {
    staticClass: "alert-header"
  }, [_vm._v("\n      " + _vm._s(_vm.headerText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.bodyText ? _c('span', {
    staticClass: "alert-body",
    domProps: {
      "innerHTML": _vm._s(_vm.getBodyText)
    }
  }) : _vm._e()]), _vm._v(" "), _vm.buttonText ? _c('VcButton', {
    staticClass: "action-button",
    attrs: {
      "plain": "",
      "data-qa": "alert-action-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$arrow_right")])];
      },
      proxy: true
    }], null, false, 3701565208)
  }, [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button",
    attrs: {
      "data-qa": "alert-close-btn",
      "fab": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeAlert');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 521807287)
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = function (inject) {
  if (!inject) return;
  inject("data-v-7847c9c0_0", {
    source: ".dialog-alert{padding:var(--size-value3);margin:var(--size-value0)}.dialog-alert__close-btn{margin-inline-end:var(--size-value7)}.dialog-alert .alert-content{padding-inline-end:var(--size-value9)}.dialog-alert .v-alert__icon{margin-inline-end:var(--size-value2);font-size:var(--size-value5);height:var(--size-value5);min-width:var(--size-value5)}.dialog-alert .close-button{position:absolute;width:var(--size-value6);height:var(--size-value6);top:var(--size-value3);right:var(--size-value3)}#app[dir=rtl] .dialog-alert .close-button{right:auto;left:var(--size-value3)}.dialog-alert .close-button .v-btn__content{opacity:unset}.dialog-alert .close-button:hover{background-color:rgba(0,0,0,.07)}.dialog-alert .close-button .v-icon{margin-right:var(--size-value0)}.dialog-alert .close-button .v-icon svg{fill:var(--gray-darken-2);width:var(--size-value4);height:var(--size-value4)}.dialog-alert.stripe.v-alert{border-radius:var(--size-value0);border-top:none;border-left:none;border-right:none}.dialog-alert.inline.v-alert{border-radius:var(--size-value0);border:none;padding:var(--size-value0);background-color:transparent}.dialog-alert.vcita-alert-attention{border:1px solid var(--red-lighten-2);background-color:var(--red-lighten-3)}.dialog-alert.vcita-alert-attention .v-icon svg.vc-attention-fill,.dialog-alert.vcita-alert-attention .v-icon svg.vc-notif{fill:var(--red)}.dialog-alert.vcita-alert-warning{border:1px solid var(--yellow-lighten-2);background-color:var(--yellow-lighten-3)}.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon svg.vc-notif,.dialog-alert.vcita-alert-warning .v-alert__wrapper .v-icon svg.vc-warning-fill{fill:var(--yellow)}.dialog-alert.vcita-alert-info{border:1px solid var(--blue-lighten-2);background-color:var(--blue-lighten-3)}.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon svg.vc-info-fill,.dialog-alert.vcita-alert-info .v-alert__wrapper .v-icon svg.vc-notif{fill:var(--blue)}.dialog-alert.vcita-alert-success{border:1px solid var(--green-lighten-2);background-color:var(--green-lighten-3)}.dialog-alert.vcita-alert-success .v-icon svg.vc-check-fill,.dialog-alert.vcita-alert-success .v-icon svg.vc-notif{fill:var(--green)}.dialog-alert .v-alert__wrapper .v-icon__component{height:var(--size-value4);width:var(--size-value4)}.dialog-alert .v-alert__wrapper .v-icon__component svg.vc-notif{font-size:var(--size-value4);height:var(--size-value4);min-width:var(--size-value4)}.dialog-alert .v-alert__wrapper .v-icon__component svg.arrow-right{fill:var(--blue)}.dialog-alert .alert-header{font-weight:700;font-size:var(--font-size-x-small);line-height:var(--size-value5);letter-spacing:var(--letter-spacing);margin-bottom:var(--size-value1);color:var(--gray-darken-5)}.dialog-alert .alert-header:after{content:\" \";padding-right:var(--size-value1)}.dialog-alert .alert-body{font-size:var(--font-size-x-small);line-height:var(--size-value5);letter-spacing:-.01em;color:var(--gray-darken-5)}.dialog-alert .alert-body a{color:-webkit-link}.dialog-alert .VcButton .v-icon{margin-right:initial;align-items:initial}.dialog-alert .VcButton.action-button{height:var(--size-value6);color:var(--blue)!important;font-weight:var(--font-weight-large);font-size:var(--font-size-x-small);line-height:var(--size-value6);margin-top:var(--size-value1);padding:var(--size-value0)}.dialog-alert .VcButton.action-button span.v-btn__content{opacity:unset!important}.dialog-alert .VcButton.action-button span.v-btn__content .v-icon:before{content:\" \";padding-right:var(--size-value1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$M = undefined;
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, createInjector, undefined, undefined);

var script$L = {
  name: "VcTooltip",
  components: {
    VcIcon: __vue_component__$X,
    VTooltip: VTooltip
  },
  props: {
    flavor: {
      type: String,
      default: 'information',
      validator: type => {
        return ['information', 'alert'].indexOf(type) > -1;
      }
    },
    header: {
      type: String,
      default: ''
    },
    content: {
      type: String
    },
    top: {
      type: Boolean,
      default: true
    },
    bottom: {
      type: Boolean,
      default: false
    },
    nudgeLeft: {
      type: Number
    },
    nudgeRight: {
      type: Number
    },
    dark: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-tooltip'
    }
  },
  computed: {
    enableHeader() {
      return this.header.length > 0;
    }

  }
};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_c('v-tooltip', {
    attrs: {
      "content-class": "vc-tooltip",
      "left": !_vm.$vuetify.rtl,
      "right": _vm.$vuetify.rtl,
      "top": _vm.top,
      "bottom": _vm.bottom,
      "nudge-left": _vm.nudgeLeft,
      "nudge-right": _vm.nudgeRight,
      "disabled": _vm.disabled,
      "data-qa": _vm.dataQa
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_vm._t("default", function () {
          return [_c('VcIcon', {
            staticClass: "default-activator-icon"
          }, [_vm._v("$info")])];
        }, null, attrs)], 2)];
      }
    }], null, true)
  }, [_vm._v(" "), _vm.dark ? _c('div', {
    staticClass: "dark-tooltip",
    attrs: {
      "data-qa": _vm.dataQa + "-dark-content"
    }
  }, [_vm.header || _vm.content ? _c('span', {
    staticClass: "inner-content",
    domProps: {
      "innerHTML": _vm._s(_vm.header + " " + _vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("content")], 2) : _c('div', {
    staticClass: "tooltip-wrapper",
    attrs: {
      "data-qa": _vm.dataQa + "-content"
    }
  }, [_vm.enableHeader ? _c('div', {
    staticClass: "tooltip-header",
    class: _vm.flavor
  }, [_vm._v("\n             " + _vm._s(_vm.header) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tooltip-content"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_vm.content ? _c('span', {
    staticClass: "inner-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("content")], 2)])])])], 1);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = function (inject) {
  if (!inject) return;
  inject("data-v-4def565c_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-tooltip{opacity:1!important;padding:0;border-radius:var(--border-radius)}.vc-tooltip .dark-tooltip{background-color:rgba(0,0,0,.97);font-size:var(--size-value3);font-weight:400;border-radius:var(--size-value1);padding:var(--size-value2)}.vc-tooltip .tooltip-wrapper{background:var(--modal-bg-color);box-shadow:0 5px 5px -3px rgba(0,0,0,.1),0 8px 10px 1px rgba(0,0,0,.06),0 3px 14px 2px rgba(0,0,0,.06);border-radius:var(--border-radius)}.vc-tooltip .tooltip-wrapper .tooltip-header{color:var(--gray-darken-5);font-size:var(--font-size-small2);border-radius:var(--border-radius) var(--border-radius) 0 0;font-weight:var(--font-weight-large);padding:var(--size-value3) var(--size-value4)}.vc-tooltip .tooltip-wrapper .tooltip-header.alert{background-color:var(--red-lighten-3)}.vc-tooltip .tooltip-wrapper .tooltip-header.information{background-color:var(--blue-lighten-3)}.vc-tooltip .tooltip-wrapper .tooltip-content{display:block;font-size:var(--font-size-x-small);padding:var(--size-value3) var(--size-value4) var(--size-value4)}.vc-tooltip .tooltip-wrapper .tooltip-content .content-text{color:var(--gray-darken-5);max-width:fit-content;min-width:250px;word-wrap:break-word}.vc-tooltip .inner-content{display:contents}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, createInjector, undefined, undefined);

var script$K = {
  name: "VcIconWithTooltip",
  components: {
    VcTooltip: __vue_component__$L,
    VIcon: VIcon
  },
  props: {
    icon: {
      type: String,
      default: 'information',
      validator: prop => ['information', 'question', 'attention', 'default'].includes(prop)
    },
    size: {
      type: Number,
      default: 12
    },
    dataQa: {
      type: String,
      default: 'vc-tooltip'
    }
  },

  data() {
    return {
      iconInUse: this.icon
    };
  },

  methods: {
    inHover() {
      switch (this.icon) {
        case 'information':
          this.iconInUse = 'info_fill';
          break;

        case 'question':
          this.iconInUse = 'question_fill';
          break;

        case 'attention':
          this.iconInUse = 'attention_fill';
          break;

        case 'default':
          this.iconInUse = 'default_hovering';
          break;
      }
    }

  },
  computed: {
    getIcon() {
      if (this.iconInUse === 'default' || this.iconInUse === 'default_hovering') {
        return '$information';
      }

      return `$${this.iconInUse}`;
    }

  }
};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTooltip', _vm._b({
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, 'VcTooltip', _vm.$attrs, false), [[_c('v-icon', {
    staticClass: "tooltip-icon",
    class: {
      'vc-default': _vm.iconInUse === 'default',
      'vc-default_hovering': _vm.iconInUse === 'default_hovering'
    },
    attrs: {
      "size": _vm.size,
      "data-qa": _vm.dataQa + "-icon"
    },
    on: {
      "mouseover": _vm.inHover,
      "mouseleave": function ($event) {
        _vm.iconInUse = _vm.icon;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.getIcon) + "\n    ")])]], 2);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = function (inject) {
  if (!inject) return;
  inject("data-v-7193d7d6_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.tooltip-icon{cursor:pointer}.tooltip-icon .vc-question{fill:rgba(0,0,0,.4)}.tooltip-icon .vc-question-fill{fill:var(--gray-darken-4)}.tooltip-icon .vc-info-fill,.tooltip-icon .vc-information{fill:var(--v-info-base)}.tooltip-icon .vc-attention,.tooltip-icon .vc-attention-fill{fill:var(--red)}.tooltip-icon.vc-default .vc-info-fill,.tooltip-icon.vc-default .vc-information{fill:rgba(0,0,0,.4)}.tooltip-icon.vc-default_hovering .vc-info-fill,.tooltip-icon.vc-default_hovering .vc-information{fill:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, createInjector, undefined, undefined);

var script$J = {
  components: {
    VcImage: __vue_component__$O,
    VIcon: VIcon,
    VTooltip: VTooltip
  },

  data() {
    return {
      icons: {
        flag: {
          backgroundColor: '#478FFF',
          size: '10',
          icon: '$flag'
        },
        customer: {
          backgroundColor: '#54D28C',
          size: '10',
          icon: '$customer'
        },
        inactive: {
          backgroundColor: '#586E8C',
          size: '10',
          icon: '$inactive'
        },
        vip: {
          backgroundColor: '#FF9718',
          size: '10',
          icon: '$vip'
        },
        confirmed: {
          backgroundColor: '#54D28C',
          size: '8',
          icon: '$success'
        }
      }
    };
  },

  name: "VcAvatar",
  props: {
    imagePath: {
      type: [String, Object]
    },
    name: {
      type: String
    },
    text: {
      type: String
    },
    colorId: {
      type: Number
    },
    size: {
      type: String,
      default: 'md'
    },
    badgeIcon: {
      type: String,
      default: ''
    },
    badgePosition: {
      type: String,
      default: 'right'
    },
    lightMode: {
      type: Boolean,
      default: false
    },
    lightModeTooltip: {
      type: String,
      default: ''
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcAvatar'
    }
  },
  computed: {
    setLightModeClass() {
      return this.lightMode && !this.imagePath ? "light-mode" : "";
    },

    setShowBorder() {
      return this.showBorder ? 'show-border' : '';
    },

    setdisabled() {
      return this.disabled ? 'vc-disabled' : '';
    },

    computedClasses() {
      return `${this.colorClass} ${this.size} ${this.setLightModeClass} ${this.setShowBorder} ${this.setdisabled}`;
    },

    computedBadgeClass() {
      return this.badgeIcon + " " + this.size + " " + this.badgePosition;
    },

    colorClass() {
      return !this.imagePath && this.colorId >= 0 ? `color-${this.colorId}` : '';
    },

    initials() {
      return this.getInitials(this.name);
    }

  },
  methods: {
    getInitials(name) {
      let split = name.trim().split(' ').filter(Boolean);
      let initials = '';

      if (split.length) {
        initials += split[0][0];

        if (split[1]) {
          initials += split[1][0];
        } else if (split[0][1]) {
          initials += split[0][1];
        }
      }

      return initials.toUpperCase();
    }

  }
};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "avatar-wrapper",
    class: _vm.computedClasses,
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        ref.attrs;
        return [_vm.imagePath ? _c('VcImage', _vm._g({
          staticClass: "avatar-image",
          attrs: {
            "data-qa": "avatarImage",
            "image": _vm.imagePath
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on)) : _vm._e(), _vm._v(" "), !_vm.imagePath && _vm.name || _vm.text ? _c('div', _vm._g({
          staticClass: "avatar-initials",
          attrs: {
            "data-qa": "avatar-initials"
          }
        }, _vm.lightMode && _vm.lightModeTooltip && on), [_vm._v("\n        " + _vm._s(_vm.text || _vm.initials) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.badgeIcon && _vm.icons[_vm.badgeIcon] ? _c('div', {
          staticClass: "badge d-flex justify-center align-center",
          class: _vm.computedBadgeClass,
          style: {
            backgroundColor: _vm.icons[_vm.badgeIcon].backgroundColor
          }
        }, [_c('v-icon', {
          attrs: {
            "data-qa": "avatarBadgeIcon",
            "size": _vm.icons[_vm.badgeIcon].size
          }
        }, [_vm._v(_vm._s(_vm.icons[_vm.badgeIcon].icon))])], 1) : _vm._e()];
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lightModeTooltip))])])], 1);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = function (inject) {
  if (!inject) return;
  inject("data-v-b135b8c4_0", {
    source: "[data-v-b135b8c4]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.avatar-wrapper[data-v-b135b8c4]{position:relative;border-radius:50%;text-align:center;color:var(--modal-bg-color)}.avatar-wrapper.show-border[data-v-b135b8c4]{border:1px solid var(--modal-bg-color)}.avatar-wrapper.vc-disabled[data-v-b135b8c4]{filter:grayscale(100%)}.avatar-wrapper.light-mode[data-v-b135b8c4]{border:1px solid rgba(0,0,0,.3);color:rgba(0,0,0,.3);background-color:var(--modal-bg-color)}.avatar-wrapper.x-sm[data-v-b135b8c4]{height:var(--avatar-x-sm);width:var(--avatar-x-sm);font-size:var(--font-size-xxx-small)}.avatar-wrapper.sm[data-v-b135b8c4]{height:var(--avatar-sm);width:var(--avatar-sm);font-size:var(--font-size-xx-small)}.avatar-wrapper.md[data-v-b135b8c4]{height:var(--avatar-md);width:var(--avatar-md);font-size:var(--font-size-small)}.avatar-wrapper.lg[data-v-b135b8c4]{height:var(--avatar-lg);width:var(--avatar-lg);font-size:var(--font-size-small3)}.avatar-wrapper .avatar-image[data-v-b135b8c4]{height:100%;width:100%;border-radius:50%;overflow:hidden}.avatar-wrapper .avatar-image[data-v-b135b8c4]  svg{height:100%}.avatar-wrapper .avatar-image[data-v-b135b8c4]  img{height:100%}.avatar-wrapper .avatar-initials[data-v-b135b8c4]{position:relative;top:50%;font-weight:var(--font-weight-medium2);transform:translateY(-50%)}.avatar-wrapper .badge[data-v-b135b8c4]{fill:#fff;position:absolute;--gap:0;height:var(--size-value4);width:var(--size-value4);border-radius:50%;bottom:calc(var(--gap) * -1);left:calc(var(--gap) * -1)}.avatar-wrapper .badge.x-sm[data-v-b135b8c4]{--gap:var(--size-value1)}.avatar-wrapper .badge.sm[data-v-b135b8c4]{--gap:var(--size-value1)}.avatar-wrapper .badge.md[data-v-b135b8c4]{--gap:2px}.avatar-wrapper .badge.lg[data-v-b135b8c4]{--gap:var(--size-value0)}.avatar-wrapper .badge.right[data-v-b135b8c4]{left:unset;right:calc(var(--gap) * -1)}.avatar-wrapper .badge.confirmed[data-v-b135b8c4]{border:2px var(--modal-bg-color) solid}.color-0[data-v-b135b8c4]{background-color:#fed62f}.color-1[data-v-b135b8c4]{background-color:#fec22e}.color-2[data-v-b135b8c4]{background-color:#feac2a}.color-3[data-v-b135b8c4]{background-color:#fe9a28}.color-4[data-v-b135b8c4]{background-color:#fd7024}.color-5[data-v-b135b8c4]{background-color:#fd5b32}.color-6[data-v-b135b8c4]{background-color:#f2483f}.color-7[data-v-b135b8c4]{background-color:#dc331b}.color-8[data-v-b135b8c4]{background-color:#d41419}.color-9[data-v-b135b8c4]{background-color:#e72866}.color-10[data-v-b135b8c4]{background-color:#c41c63}.color-11[data-v-b135b8c4]{background-color:#9b2bae}.color-12[data-v-b135b8c4]{background-color:#673bb5}.color-13[data-v-b135b8c4]{background-color:#7c4efc}.color-14[data-v-b135b8c4]{background-color:#4051b3}.color-15[data-v-b135b8c4]{background-color:#311b92}.color-16[data-v-b135b8c4]{background-color:#2d62fb}.color-17[data-v-b135b8c4]{background-color:#5c6bc0}.color-18[data-v-b135b8c4]{background-color:#17a8f1}.color-19[data-v-b135b8c4]{background-color:#17bbd2}.color-20[data-v-b135b8c4]{background-color:#14abbf}.color-21[data-v-b135b8c4]{background-color:#0f9587}.color-22[data-v-b135b8c4]{background-color:#16bea5}.color-23[data-v-b135b8c4]{background-color:#4eae53}.color-24[data-v-b135b8c4]{background-color:#3a8d3f}.color-25[data-v-b135b8c4]{background-color:#8cc250}.color-26[data-v-b135b8c4]{background-color:#66bb6a}.color-27[data-v-b135b8c4]{background-color:#880e4f}.color-28[data-v-b135b8c4]{background-color:#1565c0}.color-29[data-v-b135b8c4]{background-color:#1e88e5}.color-9999[data-v-b135b8c4]{background-color:#4675d9}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$J = "data-v-b135b8c4";
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, createInjector, undefined, undefined);

var script$I = {
  name: "VcBottomActions",
  components: {
    VcLayout: __vue_component__$U,
    VcButton: __vue_component__$W,
    VcIcon: __vue_component__$X,
    VcAvatar: __vue_component__$J,
    VSubheader: VSubheader,
    VListItem: VListItem,
    VList: VList,
    VBottomSheet: VBottomSheet
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event)
    },
    header: {
      Type: Boolean,
      default: false
    },
    title: {
      Type: String,
      default: undefined
    },
    client: {
      type: Object,
      default: undefined
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet'
    }
  },
  computed: {
    isNotAllItemsWithIcons() {
      return this.items.some(item => !item.icon);
    }

  }
};

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-bottom-sheet', {
    attrs: {
      "persistent": _vm.header,
      "value": _vm.value,
      "content-class": "vc-bottom-sheet"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.header ? _c('v-subheader', {
    staticClass: "subheader"
  }, [_vm.client ? _c('vc-avatar', _vm._b({
    staticClass: "avatar",
    attrs: {
      "size": "x-sm"
    }
  }, 'vc-avatar', _vm.client, false)) : _vm._e(), _vm._v(" "), _vm.title ? _c('span', {
    staticClass: "vc-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('vc-layout', {
    staticClass: "button-close-wrapper"
  }, [_c('vc-button', {
    staticClass: "close-button",
    attrs: {
      "ripple": false,
      "data-qa": "close-sheet-button",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('vc-icon', [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 3316324652)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('vc-layout', {
    staticClass: "items-wrapper",
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-list-item', {
      key: item.title,
      staticClass: "sheet-item",
      on: {
        "click": function ($event) {
          return _vm.$emit('action', item.event);
        }
      }
    }, [_c('vc-layout', {
      staticClass: "option-title",
      attrs: {
        "align-center": ""
      }
    }, [item.icon && !_vm.isNotAllItemsWithIcons ? _c('vc-icon', {
      staticClass: "icon-item"
    }, [_vm._v(_vm._s("$" + item.icon))]) : _vm._e(), _vm._v("\n          " + _vm._s(item.title) + "\n        ")], 1)], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = function (inject) {
  if (!inject) return;
  inject("data-v-51eeacd7_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-bottom-sheet{box-shadow:0 1px 10px rgba(0,0,0,.12),0 4px 5px rgba(0,0,0,.14),0 2px 4px -1px rgba(0,0,0,.2);margin:var(--size-value3) var(--size-value3) var(--size-value5)!important;border-radius:var(--modal-border-radius)!important}.vc-bottom-sheet .v-sheet.v-list{border-radius:var(--modal-border-radius);padding-top:var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .subheader{border-bottom:1px solid rgba(0,0,0,.12);padding:var(--size-value3) var(--size-value4);color:var(--gray-darken-5)}.vc-bottom-sheet .v-sheet.v-list .subheader .avatar{margin-inline-end:var(--size-value3)}.vc-bottom-sheet .v-sheet.v-list .subheader .vc-title{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper{flex-grow:1;justify-content:flex-end}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button{justify-content:flex-end;padding:var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button .v-btn__content{opacity:unset}.vc-bottom-sheet .v-sheet.v-list .subheader .button-close-wrapper .close-button .v-icon svg{fill:rgba(0,0,0,.4);width:var(--size-value4);height:var(--size-value4)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper{padding:var(--size-value1) var(--size-value0)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item{min-height:var(--size-value10)}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item .option-title{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);letter-spacing:-.2px}.vc-bottom-sheet .v-sheet.v-list .items-wrapper .sheet-item .option-title .icon-item{vertical-align:sub;margin-inline-end:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$I = undefined;
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, createInjector, undefined, undefined);

var script$H = {
  name: "VcActionList",
  components: {
    VcLayout: __vue_component__$U,
    VcButton: __vue_component__$W,
    VcIcon: __vue_component__$X,
    VListItemTitle: VListItemTitle,
    VListItem: VListItem,
    VList: VList,
    VMenu: VMenu
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event)
    },
    dataQa: {
      type: String,
      default: 'vc-action-list'
    }
  },
  computed: {
    isNotAllItemsWithIcons() {
      return this.items.some(item => !item.icon);
    }

  }
};

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "content-class": "vc-action-list",
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('vc-layout', {
    staticClass: "items-wrapper",
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-list-item', {
      key: item.title,
      staticClass: "sheet-item",
      on: {
        "click": function ($event) {
          return _vm.$emit('action', item.event);
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "option-title"
    }, [item.icon && !_vm.isNotAllItemsWithIcons ? _c('vc-icon', {
      staticClass: "icon-item",
      attrs: {
        "size": "20"
      }
    }, [_vm._v("\n            " + _vm._s(item.icon) + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(item.title) + "\n        ")], 1)], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = function (inject) {
  if (!inject) return;
  inject("data-v-500d77ad_0", {
    source: ":root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-action-list{box-shadow:0 1px 10px rgba(0,0,0,.12),0 4px 5px rgba(0,0,0,.14),0 2px 4px -1px rgba(0,0,0,.2);border-radius:var(--modal-border-radius)}.vc-action-list .v-list{border-radius:var(--modal-border-radius);padding:var(--size-value1) 0}.vc-action-list .v-list .items-wrapper .sheet-item{min-height:var(--size-value10)}.vc-action-list .v-list .items-wrapper .sheet-item .option-title{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);letter-spacing:-.2px}.vc-action-list .v-list .items-wrapper .sheet-item .option-title .icon-item{width:25px;vertical-align:sub;margin-inline-end:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, createInjector, undefined, undefined);

var script$G = {
  name: "VcActions",
  components: {
    VcIcon: __vue_component__$X,
    VcActionList: __vue_component__$H,
    VcBottomActions: __vue_component__$I
  },

  data() {
    return {
      showSheet: false
    };
  },

  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.title && e.event)
    },
    header: {
      Type: Boolean,
      default: false
    },
    title: {
      Type: String,
      default: undefined
    },
    client: {
      type: Object,
      default: undefined
    },
    dataQa: {
      type: String,
      default: 'vc-actions'
    }
  },
  computed: {
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    }

  },
  methods: {
    handleSheet(action) {
      this.showSheet = false;
      this.$emit('action', action);
    },

    handleCloseSheet() {
      this.showSheet = false;
      this.$emit('close');
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.isMobile ? 'VcBottomActions' : 'VcActionList', _vm._b({
    tag: "component",
    on: {
      "action": function ($event) {
        return _vm.handleSheet($event);
      },
      "close": function ($event) {
        return _vm.handleCloseSheet();
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_c('VcIcon', _vm._g(_vm._b({
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.showSheet = !_vm.showSheet;
            }
          }
        }, 'VcIcon', attrs, false), on), [_vm._v("\n      $three_dots\n    ")])];
      }
    }]),
    model: {
      value: _vm.showSheet,
      callback: function ($$v) {
        _vm.showSheet = $$v;
      },
      expression: "showSheet"
    }
  }, 'component', _vm.$props, false));
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$G = undefined;
/* scoped */

const __vue_scope_id__$G = undefined;
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$F = {
  components: {
    VStepperStep: VStepperStep,
    VStepper: VStepper
  },

  name: "VcStepsBar",

  model: {
    prop: "currentStep"
  },

  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      validator: steps => steps.every(step => step.name),
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    dataQa: {
      type: String,
      default: "vc-steps-bar"
    }
  },

  data() {
    return {
      lastCompleted: 0,
      FIRST_STEP: 1
    };
  },

  methods: {
    nextStep() {
      if (this.lastCompleted < this.currentStep) {
        this.lastCompleted = this.currentStep;
      }

      if (this.currentStep > this.steps.length) {
        this.shareStep(this.steps.length);
      }
    },

    shareStep(step) {
      this.$emit("input", step);
    }

  },

  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        if (newVal > oldVal) {
          this.nextStep();
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-stepper-container",
    attrs: {
      "data-qa": "vc-steps-bar"
    }
  }, [_c('v-stepper', {
    staticClass: "vc-stepper",
    attrs: {
      "vertical": "",
      "data-qa": _vm.dataQa
    },
    model: {
      value: _vm.currentStep,
      callback: function ($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm.title ? _c('div', {
    staticClass: "stepper-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l(_vm.steps, function (step, index) {
    return [_c('v-stepper-step', {
      key: "step-" + (index + 1),
      attrs: {
        "id": "step-" + (index + 1),
        "complete": _vm.lastCompleted > index + 1,
        "step": index + 1
      }
    }, [_vm._v("\n        " + _vm._s(step.title ? step.title : step.name) + "\n      ")])];
  })], 2)], 1);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = function (inject) {
  if (!inject) return;
  inject("data-v-d21a486c_0", {
    source: "[data-v-d21a486c]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-stepper-container[data-v-d21a486c]{height:100%;padding-block-start:var(--size-value4);padding-inline-start:var(--size-value10)}.vc-stepper.v-stepper[data-v-d21a486c]{box-shadow:none}.vc-stepper.v-stepper .stepper-title[data-v-d21a486c]{margin-block-end:var(--size-value6);font-weight:var(--font-weight-large2);font-size:var(--font-size-medium);letter-spacing:.03em;color:var(--gray-darken-5)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]{padding:var(--size-value0);width:fit-content;align-items:flex-start;margin-block-end:var(--size-value1)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]  .v-stepper__label{padding-inline-end:var(--size-value6);text-shadow:none;font-size:var(--font-size-small2);letter-spacing:.01em;line-height:var(--size-value6);padding-bottom:var(--size-value7)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]  span.v-stepper__step__step{height:var(--size-value5);min-width:var(--size-value5);width:var(--size-value5);margin-inline-end:var(--size-value3);margin-inline-start:var(--size-value0);margin-block:2px;font-size:var(--font-size-xx-small);font-weight:var(--font-weight-medium2)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]:not(.v-stepper__step--active):not(.v-stepper__step--complete)  span.v-stepper__step__step{background-color:var(--gray-lighten-2);color:var(--gray-darken-2)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]:not(.v-stepper__step--active):not(.v-stepper__step--complete)  .v-stepper__label{color:var(--gray-darken-4)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--active[data-v-d21a486c]:not(.v-stepper__step--complete)  span.v-stepper__step__step{background-color:var(--v-secondary-base)!important}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--active[data-v-d21a486c]:not(.v-stepper__step--complete)  .v-stepper__label{color:var(--gray-darken-5);font-weight:var(--font-weight-large)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-d21a486c]  span.v-stepper__step__step{background-color:var(--green)!important}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-d21a486c]  span.v-stepper__step__step i{font-size:var(--size-value3)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete[data-v-d21a486c]  .v-stepper__label{color:var(--gray-darken-5)}.vc-stepper.v-stepper .v-stepper__step.v-stepper__step--complete.v-stepper__step--active[data-v-d21a486c]  .v-stepper__label{font-weight:var(--font-weight-large)}.vc-stepper.v-stepper .v-stepper__step[data-v-d21a486c]:not(:last-child)::after{content:\"\";border-inline-start:2px solid var(--gray-lighten-1);position:absolute;top:0;margin-inline-start:9px;height:-webkit-fill-available;margin-top:var(--size-value7)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$F = "data-v-d21a486c";
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$E = {
  components: {
    VProgressCircular: VProgressCircular
  },

  name: "VcProgressCircular",

  model: {
    prop: 'currentStep'
  },

  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Number,
      required: true
    },
    showStages: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-progress-circular'
    }
  },

  data() {
    return {
      FIRST_STEP: 1,
      DIAMETER: 48,
      FILLING_COLOR: 'var(--green)'
    };
  },

  computed: {
    fillPercentages() {
      return this.currentStep * 100 / this.steps;
    }

  },

  methods: {
    shareStep(step) {
      this.$emit('input', step);
    }

  },

  watch: {
    currentStep: {
      handler(newVal) {
        if (newVal > this.steps) {
          this.shareStep(this.steps);
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  }
};

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-progress-circular', {
    staticClass: "vc-progress-circular",
    attrs: {
      "rotate": -90,
      "size": _vm.DIAMETER,
      "value": _vm.fillPercentages,
      "color": _vm.FILLING_COLOR,
      "data-qa": _vm.dataQa
    }
  }, [_vm.showStages ? _c('div', {
    staticClass: "vc-progress-counter"
  }, [_vm._v("\n    " + _vm._s(_vm.currentStep) + " / " + _vm._s(_vm.steps) + "\n  ")]) : _vm._e()]);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = function (inject) {
  if (!inject) return;
  inject("data-v-5c278fc2_0", {
    source: "[data-v-5c278fc2]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-progress-circular .vc-progress-counter[data-v-5c278fc2]{font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);color:var(--gray-darken-5)}.vc-progress-circular[data-v-5c278fc2]  .v-progress-circular__underlay{stroke:var(--neutral-lighten-1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$E = "data-v-5c278fc2";
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, createInjector, undefined, undefined);

var script$D = {
  name: "VcMobileWizardProgress",
  components: {
    VcLayout: __vue_component__$U,
    VcProgressCircular: __vue_component__$E
  },
  model: {
    prop: 'currentStep'
  },
  props: {
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: [Array],
      validator: steps => steps.every(step => step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-mobile-wizard-stepper'
    }
  },
  computed: {
    _currentStep: {
      get() {
        return this.currentStep;
      },

      set(step) {
        this.$emit('input', step);
      }

    },

    currentStepName() {
      var _this$steps;

      return (_this$steps = this.steps[this.currentStep - 1]) === null || _this$steps === void 0 ? void 0 : _this$steps.name;
    },

    nextStepName() {
      var _this$steps$this$curr;

      if (this.currentStep >= this.numOfSteps) {
        return;
      }

      return `${this.$dst("ds.progress_circular.next")} ${(_this$steps$this$curr = this.steps[this.currentStep]) === null || _this$steps$this$curr === void 0 ? void 0 : _this$steps$this$curr.name}`;
    },

    numOfSteps() {
      return this.steps.length;
    }

  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('vc-layout', {
    staticClass: "vc-mobile-wizard-progress",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('VcProgressCircular', {
    attrs: {
      "steps": _vm.numOfSteps,
      "data-qa": _vm.dataQa + "-progress"
    },
    model: {
      value: _vm._currentStep,
      callback: function ($$v) {
        _vm._currentStep = $$v;
      },
      expression: "_currentStep"
    }
  }), _vm._v(" "), _c('vc-layout', {
    staticClass: "titles-container",
    attrs: {
      "column": ""
    }
  }, [_vm.currentStepName ? _c('div', {
    staticClass: "current-step"
  }, [_vm._v(_vm._s(_vm.currentStepName))]) : _vm._e(), _vm._v(" "), _vm.nextStepName ? _c('div', {
    staticClass: "next-step"
  }, [_vm._v(_vm._s(_vm.nextStepName))]) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = function (inject) {
  if (!inject) return;
  inject("data-v-4fe04d36_0", {
    source: "[data-v-4fe04d36]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-mobile-wizard-progress[data-v-4fe04d36]{padding:var(--size-value4);background-color:var(--neutral-lighten-3);width:100%;max-height:84px}.vc-mobile-wizard-progress .titles-container[data-v-4fe04d36]{margin:var(--size-value0) var(--size-value4)}.vc-mobile-wizard-progress .titles-container .current-step[data-v-4fe04d36]{font-weight:var(--font-weight-large2);font-size:var(--font-size-small2)}.vc-mobile-wizard-progress .titles-container .next-step[data-v-4fe04d36]{font-size:var(--font-size-x-small);color:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$D = "data-v-4fe04d36";
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, createInjector, undefined, undefined);

var script$C = {
  name: 'VcCheckbox',
  components: {
    VcIcon: __vue_component__$X,
    VcAvatar: __vue_component__$J,
    VcTooltip: __vue_component__$L,
    VCheckbox: VCheckbox
  },
  computed: {
    selected: {
      get() {
        return this.checked;
      },

      set(val) {
        this.$emit('change', val);
      }

    }
  },
  props: {
    label: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    avatar: {
      type: Object,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: [Boolean, Array],
      default: false
    },
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    showAvatarBorder: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'VcCheckbox'
    }
  }
};

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-checkbox', {
    staticClass: "vc-checkbox d-flex align-center",
    attrs: {
      "hide-details": "true",
      "disabled": _vm.disabled,
      "ripple": false,
      "on-icon": "check",
      "off-icon": "",
      "indeterminate-icon": "$indeterminate",
      "indeterminate": _vm.indeterminate,
      "color": "white",
      "label": _vm.label,
      "value": _vm.value,
      "data-qa": _vm.dataQa
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_vm.avatar && _vm.label ? _c('VcAvatar', {
          staticClass: "ms-1 me-3",
          attrs: {
            "image-path": _vm.avatar.path,
            "name": _vm.avatar.name,
            "color-id": _vm.avatar.colorId,
            "disabled": _vm.disabled,
            "show-border": _vm.showAvatarBorder,
            "size": "x-sm"
          }
        }) : _vm._e(), _vm._v(" "), _vm.label ? _c('span', {
          staticClass: "checkbox-label"
        }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm.tooltip && _vm.label ? _c('VcTooltip', {
          attrs: {
            "dark": "",
            "content": _vm.tooltip,
            "bottom": ""
          }
        }, [_c('VcIcon', {
          staticClass: "tooltip-icon ms-2",
          attrs: {
            "size": "16"
          }
        }, [_vm._v("$info")])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  });
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = function (inject) {
  if (!inject) return;
  inject("data-v-347ec55e_0", {
    source: ".vc-checkbox[data-v-347ec55e]{font-family:var(--primary-font-family)}.vc-checkbox[data-v-347ec55e] .v-input__slot .v-input--selection-controls__input{width:var(--size-value4);height:var(--size-value4)}.vc-checkbox[data-v-347ec55e] .v-input__slot .v-input--selection-controls__input .v-icon{color:transparent;border:1px solid rgba(0,0,0,.2);box-sizing:border-box;border-radius:2px;font-size:var(--font-size-small);font-weight:700}.vc-checkbox[data-v-347ec55e] .checkbox-label{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.vc-checkbox[data-v-347ec55e]:not(.v-input--is-disabled) .checkbox-label{color:var(--gray-darken-5)}.vc-checkbox[data-v-347ec55e] .tooltip-icon{color:var(--gray-darken-3)}.vc-checkbox[data-v-347ec55e] .avatar-wrapper .avatar-initials{font-size:var(--font-size-xxx-small);font-weight:var(--font-weight-medium2)}.vc-checkbox[data-v-347ec55e].v-input--indeterminate:not(.v-input--is-disabled) .v-input--selection-controls__input .v-icon{background-color:var(--green);color:#fff}.vc-checkbox[data-v-347ec55e].v-input--is-label-active:not(.v-input--is-disabled) .v-input--selection-controls__input .v-icon{background-color:var(--green);color:#fff;border:none}.vc-checkbox[data-v-347ec55e]:not(.v-input--is-disabled):hover:not(:active) .v-input--selection-controls__input .v-icon{background-color:rgba(0,0,0,.03)}.vc-checkbox[data-v-347ec55e].v-input--indeterminate:not(.v-input--is-disabled):hover .v-input--selection-controls__input .v-icon,.vc-checkbox[data-v-347ec55e].v-input--is-label-active:not(.v-input--is-disabled):hover .v-input--selection-controls__input .v-icon{background-color:rgba(84,210,140,.76)}.vc-checkbox[data-v-347ec55e].v-input--indeterminate:not(.v-input--is-disabled):active .v-input--selection-controls__input .v-icon,.vc-checkbox[data-v-347ec55e].v-input--is-label-active:not(.v-input--is-disabled):active .v-input--selection-controls__input .v-icon{background-color:rgba(84,210,140,.5)}.vc-checkbox[data-v-347ec55e]:not(.v-input--is-label-active):not(.v-input--indeterminate):not(.v-input--is-disabled):active .v-input--selection-controls__input .v-icon{background:rgba(0,0,0,.12)}.vc-checkbox[data-v-347ec55e]:not(.v-input--is-disabled):focus .v-input--selection-controls__input .v-icon{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.vc-checkbox[data-v-347ec55e].v-input--is-disabled .v-input--selection-controls__input .v-icon{background:rgba(0,0,0,.07)}.vc-checkbox[data-v-347ec55e].v-input--is-disabled.v-input--is-label-active .v-input--selection-controls__input .v-icon{border:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$C = "data-v-347ec55e";
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);

var script$B = {
  name: "VcChecklistItem",
  components: {
    VcLayout: __vue_component__$U,
    VcCheckbox: __vue_component__$C,
    VcTooltip: __vue_component__$L
  },
  model: {
    prop: 'checked'
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    avatar: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'VcChecklistItem'
    }
  },
  computed: {
    getAvatar() {
      if (this.avatar && Object.keys(this.avatar).length) {
        return {
          name: this.label,
          ...this.avatar
        };
      }
    }

  },
  methods: {
    onChange(val) {
      this.$emit('change', {
        checked: val
      });
    }

  }
};

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTooltip', {
    staticClass: "VcChecklistItem-wrapper",
    attrs: {
      "content": _vm.tooltipContent,
      "disabled": !_vm.tooltipContent || !_vm.disabled,
      "dark": ""
    }
  }, [[_c('VcLayout', {
    staticClass: "VcChecklistItem",
    class: {
      'disabled': _vm.disabled
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('VcCheckbox', {
    attrs: {
      "avatar": _vm.getAvatar,
      "checked": _vm.checked,
      "data-qa": _vm.dataQa + "-checkbox",
      "disabled": _vm.disabled,
      "label": _vm.label,
      "show-avatar-border": false
    },
    on: {
      "change": _vm.onChange
    }
  })], 1)]], 2);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = function (inject) {
  if (!inject) return;
  inject("data-v-6ae9d122_0", {
    source: "[data-v-6ae9d122]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.VcChecklistItem-wrapper[data-v-6ae9d122]{width:100%}.VcChecklistItem-wrapper[hide=true][data-v-6ae9d122]{display:none}.VcChecklistItem-wrapper .VcChecklistItem.disabled[data-v-6ae9d122]{background-color:var(--gray-lighten-3)}.VcChecklistItem-wrapper .VcChecklistItem .vc-checkbox[data-v-6ae9d122]{flex:1 1 auto;padding:var(--size-value0);margin:var(--size-value0)}.VcChecklistItem-wrapper .VcChecklistItem .vc-checkbox[data-v-6ae9d122]  .v-input__control .v-input__slot{padding:var(--size-value2) var(--size-value4)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-6ae9d122]:hover{background-color:var(--gray-lighten-3)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-6ae9d122]:focus{box-shadow:0 0 0 2px var(--v-secondary-lighten1)}.VcChecklistItem-wrapper .VcChecklistItem[data-v-6ae9d122]:active{background-color:var(--v-secondary-lighten3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$B = "data-v-6ae9d122";
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, createInjector, undefined, undefined);

var script$A = {
  name: 'VcTextField',
  components: {
    VcIconWithTooltip: __vue_component__$K,
    VTextField: VTextField
  },
  props: {
    type: {
      type: String,
      default: 'text',
      validator: prop => ['text', 'number', 'search'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'vc-text-field'
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    counter: {
      type: [Number, Boolean],
      default: false
    },
    maxlength: {
      type: Number,
      default: 100,
      validator: prop => prop > 0
    },
    rules: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    tooltipHeader: {
      type: String,
      default: ''
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    tooltipNudgeLeft: {
      type: Number,
      default: 0
    },
    tooltipNudgeRight: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: ''
    },
    errorMessages: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto'
    },
    persistentHint: {
      type: Boolean,
      default: true
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    googleAddressAutoComplete: {
      type: Boolean,
      default: false
    },
    googleAddressCountryOptions: {
      type: Array,
      default: () => []
    }
  },

  mounted() {
    if (this.googleAddressAutoComplete) {
      var _window$google;

      const googleAddressScriptId = 'googleAddressScript';
      const existingScript = document.getElementById(googleAddressScriptId);
      const autoCompleteClass = (_window$google = window.google) === null || _window$google === void 0 ? void 0 : _window$google.maps.places.Autocomplete; // Script loading completed

      if (existingScript && autoCompleteClass) {
        this.initAutoComplete();
      } else {
        let googleAutocompleteScript = existingScript;

        if (!googleAutocompleteScript) {
          googleAutocompleteScript = document.createElement('script');
          googleAutocompleteScript.setAttribute('id', googleAddressScriptId);
          googleAutocompleteScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${this.$ds.googleAppKey}&channel=1&libraries=places`);
        }

        googleAutocompleteScript.addEventListener('load', this.initAutoComplete);
        document.body.appendChild(googleAutocompleteScript);
      }
    }
  },

  methods: {
    initAutoComplete() {
      let options = {
        fields: ['name', 'address_component'],
        types: ['address']
      };

      if (this.googleAddressCountryOptions.length > 0) {
        options['componentRestrictions'] = {
          country: this.googleAddressCountryOptions
        };
      }

      const input = this.$children[0].$el.getElementsByClassName('v-text-field__slot')[0].getElementsByTagName("input")[0]; // this deny google default placeholder to be added, and doesn't overrides placeholder prop.

      input.placeholder = '';
      this.autocomplete = new window.google.maps.places.Autocomplete(input, options);
      this.autocomplete.addListener('place_changed', this.emitGoogleSelectedPlace);
    },

    emitGoogleSelectedPlace() {
      let googlePlace = this.autocomplete.getPlace();
      let selectedPlace = {};
      selectedPlace['address'] = googlePlace.name;

      for (const component of googlePlace.address_components) {
        const componentType = component.types[0];

        switch (componentType) {
          case "postal_code":
            {
              selectedPlace['postcode'] = component.long_name;
              break;
            }

          case "administrative_area_level_1":
            {
              selectedPlace['state'] = component.long_name;
              selectedPlace['stateCode'] = component.short_name;
              break;
            }

          case "country":
            selectedPlace['country'] = component.long_name;
            selectedPlace['countryCode'] = component.short_name;
            break;

          case "locality":
            selectedPlace['city'] = component.long_name;
            break;

          case "sublocality_level_1":
            if (!selectedPlace['city']) {
              selectedPlace['city'] = component.long_name;
            }

            break;
        }
      }

      this.$emit('onPlaceSelected', { ...selectedPlace,
        googlePlace
      });
    }

  }
};

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', {
    staticClass: "VcTextInput",
    attrs: {
      "dense": "",
      "data-qa": _vm.dataQa,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "rules": _vm.rules,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "error": _vm.counter && !!_vm.maxlength && _vm.value.length > _vm.maxlength,
      "error-messages": _vm.errorMessages,
      "value": _vm.value,
      "hint": _vm.hint,
      "counter": _vm.counter,
      "maxlength": _vm.maxlength,
      "prefix": _vm.prefix,
      "persistent-hint": _vm.persistentHint,
      "single-line": _vm.singleLine,
      "hide-details": _vm.hideDetails
    },
    on: {
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_vm._t("prepend-inner")];
      },
      proxy: true
    }, {
      key: "append",
      fn: function () {
        return [_vm.tooltipContent ? _c('VcIconWithTooltip', {
          attrs: {
            "header": _vm.tooltipHeader,
            "content": _vm.tooltipContent,
            "nudge-left": _vm.tooltipNudgeLeft,
            "nudge-right": _vm.tooltipNudgeRight,
            "size": 15,
            "icon": 'question'
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = function (inject) {
  if (!inject) return;
  inject("data-v-347e8306_0", {
    source: ".VcTextInput.v-text-field[data-v-347e8306]{font-family:var(--primary-font-family)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot{padding:0 var(--size-value3);height:var(--size-value13);background:#fff;border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:6px}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot label{font-size:var(--font-size-small2);line-height:var(--size-value5);color:var(--gray-darken-3);font-weight:var(--font-weight-medium)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot .v-text-field__prefix{color:var(--gray-darken-5)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot input{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:var(--size-value5);color:var(--gray-darken-5);caret-color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot input::placeholder{font-weight:var(--font-weight-medium)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:after,.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:before{display:none}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:hover{border-color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:active,.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:focus,.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:focus-within{border:1px solid var(--v-secondary-base);box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:active input,.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:focus input,.VcTextInput.v-text-field[data-v-347e8306] .v-input__slot:focus-within input{color:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-347e8306].error--text .v-input__slot{border-color:var(--red);color:unset;box-shadow:unset;font-size:var(--font-size-xx-small);line-height:var(--size-value4)}.VcTextInput.v-text-field[data-v-347e8306].v-input--is-focused label,.VcTextInput.v-text-field[data-v-347e8306].v-input--is-label-active label{font-size:var(--font-size-small);line-height:1.17;letter-spacing:-.3px;color:var(--gray-darken-4)!important;transform:translateY(-100%) scale(.85);top:var(--size-value2)}.VcTextInput.v-text-field[data-v-347e8306].v-input--is-focused .v-text-field__slot,.VcTextInput.v-text-field[data-v-347e8306].v-input--is-label-active .v-text-field__slot{margin-bottom:-14px}.VcTextInput.v-text-field[data-v-347e8306].v-input--is-disabled .v-input__slot{background:var(--gray-lighten-3);border:1px solid var(--gray-lighten-1)}.VcTextInput.v-text-field[data-v-347e8306].v-input--is-disabled .v-input__slot input,.VcTextInput.v-text-field[data-v-347e8306].v-input--is-disabled .v-input__slot label{color:var(--gray-darken-2)}.VcTextInput.v-text-field[data-v-347e8306]:not(.v-input--is-label-active):not(.v-input--is-focused) input{padding:var(--size-value2) 0}.VcTextInput.v-text-field[data-v-347e8306] .v-messages__message{line-height:var(--size-value4)}.VcTextInput.v-text-field[data-v-347e8306] .v-input__append-inner{align-self:center;fill:var(--gray-darken-3)}.VcTextInput.v-text-field[data-v-347e8306].v-input--dense:not(.v-text-field--outlined) input{padding-block:var(--size-value2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$A = "data-v-347e8306";
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);

const throttle = require("lodash.throttle");

var script$z = {
  name: "VcSearchBar",
  components: {
    VcTextField: __vue_component__$A,
    VcIcon: __vue_component__$X
  },
  props: {
    size: {
      type: String,
      default: 'large',
      validator: size => ['medium', 'large'].includes(size)
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    throttleTime: {
      type: Number,
      default: 500,
      validator: throttleTime => throttleTime > 0
    },
    borderTopRadius: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-search-bar'
    }
  },
  computed: {
    getLabel() {
      return this.label || this.$dst('ds.search_bar.label');
    },

    getPlaceholder() {
      return this.placeholder || this.$dst('ds.search_bar.label');
    },

    getClasses() {
      return `${this.size}${this.borderTopRadius ? ' border-top-radius' : ''}`;
    }

  },

  data() {
    return {
      searchThrottled: throttle(search => {
        this.$emit('search', this.caseSensitive ? search : search.toLowerCase());
      }, this.throttleTime)
    };
  }

};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcTextField', {
    class: "vc-search-bar " + _vm.getClasses,
    attrs: {
      "data-qa": _vm.dataQa,
      "label": _vm.getLabel,
      "persistent-hint": false,
      "placeholder": _vm.getPlaceholder,
      "hide-details": "",
      "single-line": "",
      "type": "search"
    },
    on: {
      "input": _vm.searchThrottled
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('VcIcon', {
          staticClass: "vc-search-bar__magnify",
          attrs: {
            "small": ""
          }
        }, [_vm._v("$magnify_glass")])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = function (inject) {
  if (!inject) return;
  inject("data-v-aa7c74d0_0", {
    source: ".vc-search-bar.VcTextInput[data-v-aa7c74d0]{padding:var(--size-value0);margin:var(--size-value0)}.vc-search-bar.VcTextInput.border-top-radius[data-v-aa7c74d0]  .v-input__control .v-input__slot{border-radius:var(--border-radius) var(--border-radius) var(--size-value0) var(--size-value0)}.vc-search-bar.VcTextInput.v-input--has-state[data-v-aa7c74d0]  .v-input__slot .v-text-field__slot,.vc-search-bar.VcTextInput.v-input--is-focused[data-v-aa7c74d0]  .v-input__slot .v-text-field__slot,.vc-search-bar.VcTextInput.v-input--is-label-active[data-v-aa7c74d0]  .v-input__slot .v-text-field__slot{margin:0}.vc-search-bar.VcTextInput__magnify[data-v-aa7c74d0]{fill:var(--gray-darken-2)}.vc-search-bar.VcTextInput[data-v-aa7c74d0]:hover{border-color:var(--gray-darken-2)}.vc-search-bar.VcTextInput[data-v-aa7c74d0]:hover  .v-input__slot label{color:var(--gray-darken-2)}.vc-search-bar.VcTextInput.medium[data-v-aa7c74d0]  .v-input__control .v-input__slot{height:var(--size-value10)}.vc-search-bar.VcTextInput.medium[data-v-aa7c74d0]  .v-input__control .v-input__slot .v-input__prepend-inner{padding:var(--size-value3)}.vc-search-bar.VcTextInput[data-v-aa7c74d0]  .v-input__control .v-input__slot{padding:var(--size-value0)}.vc-search-bar.VcTextInput[data-v-aa7c74d0]  .v-input__control .v-input__slot .v-input__prepend-inner{padding:18px var(--size-value3);margin:var(--size-value0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$z = "data-v-aa7c74d0";
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, createInjector, undefined, undefined);

var script$y = {
  name: "VcListbox",
  components: {
    VcLayout: __vue_component__$U,
    VcSearchBar: __vue_component__$z,
    VcChecklistItem: __vue_component__$B,
    VcIcon: __vue_component__$X,
    VcTooltip: __vue_component__$L,
    VListItem: VListItem,
    VListItemGroup: VListItemGroup,
    VDivider: VDivider,
    VList: VList
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => item.label && item.identifier || item.identifier === 0)
    },
    addAnother: {
      type: Boolean,
      default: false
    },
    addSearch: {
      type: Boolean,
      default: false
    },
    addAnotherLabel: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ''
    },
    emptyListMsg: {
      type: String
    },
    dataQa: {
      type: String,
      default: 'VcListbox'
    }
  },
  data: () => ({
    search: ''
  }),
  computed: {
    getAddAnotherLabel() {
      return this.addAnotherLabel || this.$dst('ds.listbox.add');
    },

    confirmedArray() {
      return this.filteredItems.filter(item => item.checked);
    },

    filteredItems() {
      return this.items.map(item => ({ ...item,
        hide: !item.label.toLowerCase().includes(this.search)
      }));
    },

    listExist() {
      return this.filteredItems.some(item => !item.hide);
    },

    noItemsMsg() {
      return this.emptyListMsg || this.$dst('ds.listbox.empty_list');
    }

  },
  methods: {
    onSelection(selections) {
      const newSelections = selections.map(selected => ({ ...selected,
        checked: true
      }));
      this.$emit('change', newSelections);
    },

    onSearch(search) {
      this.search = search;
    },

    setDataQa(label) {
      return label.replace(/ /g, '-');
    }

  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.title ? _c('div', {
    staticClass: "vc-list-title",
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    staticClass: "VcListbox",
    class: {
      'with-search': _vm.addSearch,
      'with-add-another': _vm.addAnother
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.addSearch ? _c('VcSearchBar', {
    attrs: {
      "data-qa": _vm.dataQa + "-search",
      "border-top-radius": ""
    },
    on: {
      "search": _vm.onSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vc-overflow"
  }, [_vm.listExist ? _c('v-list-item-group', {
    attrs: {
      "value": _vm.confirmedArray,
      "multiple": ""
    },
    on: {
      "change": _vm.onSelection
    }
  }, _vm._l(_vm.filteredItems, function (item) {
    return _c('VcTooltip', {
      key: item.identifier,
      attrs: {
        "content": item.tooltipContent,
        "data-qa": _vm.dataQa + "-" + _vm.setDataQa(item.label) + "-tooltip",
        "disabled": !item.tooltipContent || !item.disabled,
        "dark": ""
      }
    }, [_c('v-list-item', {
      staticClass: "vc-list-item",
      attrs: {
        "disabled": item.disabled,
        "tabindex": item.label + "-" + item.identifier,
        "value": item
      }
    }, [_c('VcChecklistItem', _vm._b({
      attrs: {
        "data-qa": _vm.dataQa + "-" + _vm.setDataQa(item.label)
      }
    }, 'VcChecklistItem', item, false))], 1)], 1);
  }), 1) : _c('VcLayout', {
    staticClass: "VcListbox__empty",
    attrs: {
      "data-qa": _vm.dataQa + "-empty",
      "align-center": "",
      "justify-center": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.noItemsMsg) + "\n      ")])], 1), _vm._v(" "), _vm.addAnother ? _c('div', {
    attrs: {
      "data-qa": _vm.dataQa + "-increase"
    }
  }, [_c('v-divider', {
    staticClass: "divider"
  }), _vm._v(" "), _c('v-list-item', {
    staticClass: "last-item",
    attrs: {
      "align-baseline": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('addNew');
      }
    }
  }, [_c('VcIcon', {
    staticClass: "add-another-icon",
    attrs: {
      "dense": ""
    }
  }, [_vm._v("$plus")]), _vm._v(" "), _c('span', {
    staticClass: "add-another-label"
  }, [_vm._v(_vm._s(_vm.getAddAnotherLabel))])], 1)], 1) : _vm._e()], 1)], 1);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = function (inject) {
  if (!inject) return;
  inject("data-v-3e86f8c2_0", {
    source: "[data-v-3e86f8c2]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-list-title[data-v-3e86f8c2]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:var(--size-value5);margin-block-end:var(--size-value3)}.VcListbox[data-v-3e86f8c2]{padding-block:var(--size-value1);margin-block:var(--size-value1);border:1px solid var(--gray-lighten-1);box-sizing:border-box;border-radius:var(--border-radius);box-shadow:none!important}.VcListbox.with-search[data-v-3e86f8c2]{border:none}.VcListbox.with-search .vc-overflow[data-v-3e86f8c2]{border-inline:var(--border-frame);border-block-end:var(--border-frame);border-radius:0 0 var(--border-radius) var(--border-radius)}.VcListbox.with-search.with-add-another .vc-overflow[data-v-3e86f8c2]{border-inline:var(--border-frame);border-block-end:unset;border-radius:unset}.VcListbox.with-search.with-add-another .last-item[data-v-3e86f8c2]{border-inline:var(--border-frame);border-block-end:var(--border-frame);border-radius:0 0 var(--border-radius) var(--border-radius)}.VcListbox .vc-overflow[data-v-3e86f8c2]{overflow:auto;height:160px}.VcListbox .vc-overflow .vc-list-item[data-v-3e86f8c2]{padding:var(--size-value0);min-height:unset}.VcListbox .vc-overflow .vc-list-item[data-v-3e86f8c2]:before{opacity:0}.VcListbox .divider[data-v-3e86f8c2]{border-color:var(--gray-lighten-1)}.VcListbox .last-item[data-v-3e86f8c2]{cursor:pointer;min-height:var(--size-value10);padding-block:var(--size-value1) var(--size-value2)}.VcListbox .last-item[data-v-3e86f8c2]:hover{background-color:var(--gray-lighten-3)}.VcListbox .last-item .add-another-label[data-v-3e86f8c2]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-5)}.VcListbox .last-item .add-another-icon[data-v-3e86f8c2]{margin-inline-end:var(--size-value3);cursor:pointer}.VcListbox .last-item .add-another-icon[data-v-3e86f8c2]  .v-icon__component{height:unset;width:unset}.VcListbox .last-item .add-another-icon[data-v-3e86f8c2]  .v-icon__component svg{width:var(--size-value3)}.VcListbox__empty[data-v-3e86f8c2]{height:100%;font-weight:var(--font-weight-medium2);font-size:var(--font-size-xx-small);color:var(--gray-darken-4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$y = "data-v-3e86f8c2";
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, createInjector, undefined, undefined);

var script$x = {
  name: "VcBottomSheet",
  components: {
    VcLayout: __vue_component__$U,
    VSheet: VSheet,
    VBottomSheet: VBottomSheet
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet'
    }
  }
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-bottom-sheet', {
    attrs: {
      "value": _vm.value,
      "persistent": _vm.persistent,
      "data-qa": _vm.dataQa,
      "content-class": "VcBottomSheet"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (activatorObj) {
        return [_vm._t("activator", null, null, activatorObj)];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-sheet', {
    staticClass: "vc-sheet",
    attrs: {
      "data-qa": _vm.dataQa + "-sheet"
    }
  }, [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = function (inject) {
  if (!inject) return;
  inject("data-v-d837dcb8_0", {
    source: "[data-v-d837dcb8]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.VcBottomSheet .vc-sheet[data-v-d837dcb8]{max-height:92vh;border-radius:var(--modal-border-radius) var(--modal-border-radius) 0 0;display:flex;box-shadow:var(--modal-box-shadow)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$x = "data-v-d837dcb8";
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, createInjector, undefined, undefined);

var script$w = {
  components: {
    VcIcon: __vue_component__$X,
    VSwitch: VSwitch
  },
  name: "VcSwitch",
  props: {
    value: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    ripple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    },
    labelPosition: {
      type: String,
      default: 'after',
      validator: prop => ['before', 'after'].includes(prop)
    }
  },
  methods: {
    onChange: function (value) {
      this.$emit('input', value);
    }
  }
};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "switchContainer",
    class: {
      'with-icon': _vm.icon
    }
  }, [_c('v-switch', {
    staticClass: "VcSwitch",
    class: {
      'is-active': _vm.value,
      'with-icon': _vm.icon,
      'pre-label': _vm.labelPosition === 'before'
    },
    attrs: {
      "inset": "",
      "hide-details": "",
      "label": _vm.label,
      "ripple": _vm.ripple,
      "input-value": _vm.value,
      "color": _vm.color,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.onChange
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_vm._t("label")];
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm.icon && _vm.value ? _c('VcIcon', {
    staticClass: "VcSwitchIcon VcSwitchIconV",
    attrs: {
      "size": "10"
    }
  }, [_vm._v("$check_button")]) : _vm._e(), _vm._v(" "), _vm.icon && !_vm.value ? _c('VcIcon', {
    staticClass: "VcSwitchIcon VcSwitchIconX",
    attrs: {
      "size": "10"
    }
  }, [_vm._v("$close_button")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-422626ac_0", {
    source: ".switchContainer .VcSwitch[data-v-422626ac]{padding:0;margin:0}.switchContainer .VcSwitch[data-v-422626ac]  label{font-size:var(--font-size-small);font-weight:var(--font-weight-medium);line-height:var(--size-value6);color:var(--neutral-lighten-1)}.switchContainer .VcSwitch[data-v-422626ac]  input{height:var(--size-value5)}.switchContainer .VcSwitch[data-v-422626ac]  .v-input--selection-controls__input{margin-left:0;margin-right:var(--size-value3);height:var(--size-value5);width:var(--size-value8)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-422626ac]  .v-input--selection-controls__input{margin-left:var(--size-value3)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-422626ac]  .v-input--selection-controls__input{margin-right:0}.switchContainer .VcSwitch[data-v-422626ac]  .v-input--switch__track{top:0;left:0}#app[dir=rtl] .switchContainer .VcSwitch[data-v-422626ac]  .v-input--switch__track{left:auto;right:0}.switchContainer .VcSwitch[data-v-422626ac]  .v-input--selection-controls__ripple{left:-10px;height:25px;width:25px}#app[dir=rtl] .switchContainer .VcSwitch[data-v-422626ac]  .v-input--selection-controls__ripple{left:auto;right:-10px}.switchContainer .VcSwitch[data-v-422626ac]  .v-input--switch__thumb{height:14px;width:14px;background-color:#fff;top:calc(50% - 7px);transform:translateX(3px)!important;box-shadow:var(--shadow-5)}#app[dir=rtl] .switchContainer .VcSwitch[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(-3px)!important}.switchContainer .VcSwitch.v-input--is-disabled[data-v-422626ac] {opacity:1}.switchContainer .VcSwitch.v-input--is-disabled[data-v-422626ac]  .v-input--switch__track{color:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.v-input--is-disabled[data-v-422626ac]  .v-input--switch__thumb{background-color:var(--gray)!important;box-shadow:none}.switchContainer .VcSwitch.is-active[data-v-422626ac]  .v-input--switch__track{opacity:1;background-color:currentColor}.switchContainer .VcSwitch.is-active[data-v-422626ac]  .v-input--selection-controls__ripple{transform:translateX(14px)!important}#app[dir=rtl] .switchContainer .VcSwitch.is-active[data-v-422626ac]  .v-input--selection-controls__ripple{transform:translateX(-14px)!important}.switchContainer .VcSwitch.is-active[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(17px)!important}#app[dir=rtl] .switchContainer .VcSwitch.is-active[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(-17px)!important}.switchContainer .VcSwitch.pre-label[data-v-422626ac]  label{order:-1;flex:unset;margin-inline-end:var(--size-value2)}.switchContainer .VcSwitch.pre-label[data-v-422626ac]  .v-input--selection-controls__input{margin:unset!important}.switchContainer .VcSwitch.with-icon[data-v-422626ac]  input{height:var(--size-value6)}.switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--selection-controls__input{margin-left:0;margin-right:var(--size-value3);height:var(--size-value6);width:var(--size-value12)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--selection-controls__input{margin-left:var(--size-value3)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--selection-controls__input{margin-right:0}.switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--switch__track{top:0;left:0;height:var(--size-value6);width:var(--size-value12)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--switch__track{left:auto;right:0}.switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--selection-controls__ripple{left:-9px;height:29px;width:29px;top:calc(50% - 21.5px)}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--selection-controls__ripple{left:auto;right:-9px}.switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--switch__thumb{height:18px;width:18px;top:calc(50% - 9px);transform:translateX(3.5px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(-3.5px)!important}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-422626ac] {opacity:1}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-422626ac]  .v-input--switch__track{color:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.with-icon.v-input--is-disabled[data-v-422626ac]  .v-input--switch__thumb{background-color:var(--gray)!important;box-shadow:none}.switchContainer .VcSwitch.with-icon.v-input--is-disabled+.VcSwitchIcon[data-v-422626ac]{fill:var(--gray-lighten-2)!important}.switchContainer .VcSwitch.with-icon.is-active[data-v-422626ac]  .v-input--switch__track{opacity:1;background-color:currentColor}.switchContainer .VcSwitch.with-icon.is-active[data-v-422626ac]  .v-input--selection-controls__ripple{transform:translateX(23.5px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon.is-active[data-v-422626ac]  .v-input--selection-controls__ripple{transform:translateX(-23.5px)!important}.switchContainer .VcSwitch.with-icon.is-active[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(26px)!important}#app[dir=rtl] .switchContainer .VcSwitch.with-icon.is-active[data-v-422626ac]  .v-input--switch__thumb{transform:translateX(-26px)!important}.switchContainer .VcSwitchIcon[data-v-422626ac]{cursor:pointer;pointer-events:none;margin:17px;left:-10px}.switchContainer .VcSwitchIconV[data-v-422626ac]{top:-33px;transform:translateX(23px);fill:var(--v-secondary-base)}.switchContainer .VcSwitchIconX[data-v-422626ac]{top:-34px;transform:translate(0,0);fill:var(--neutral-lighten-1)}.switchContainer.with-icon[data-v-422626ac]{height:var(--size-value6)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$w = "data-v-422626ac";
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

var script$v = {
  name: "VcInputBottomSheet",
  components: {
    VcBottomSheet: __vue_component__$x,
    VcModalHeader: __vue_component__$S,
    VcLayout: __vue_component__$U,
    VcModalFooter: __vue_component__$T,
    VcForm: __vue_component__$Q,
    VcSwitch: __vue_component__$w
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      Type: String
    },
    okButtonLabel: {
      type: String
    },
    cancelButtonLabel: {
      type: String
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    showHeaderDivider: {
      type: Boolean,
      default: true
    },
    showFooterDivider: {
      type: Boolean,
      default: true
    },
    persistent: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet-input'
    },
    showHeaderToggle: {
      type: Boolean,
      default: false
    },
    toggleInitialValue: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      toggleValue: this.toggleInitialValue,
      validForm: true
    };
  },

  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    validate() {
      this.$refs.mainForm.validate();
    },

    onMainFormValueChanged(value) {
      this.validForm = value;
      this.$emit('onValidationChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    onHeaderToggleChanged() {
      this.$emit('onDisabledChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    }

  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcBottomSheet', {
    attrs: {
      "value": _vm.value,
      "data-qa": _vm.dataQa,
      "persistent": _vm.persistent
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), [_c('VcLayout', {
    staticClass: "VcInputBottomSheet",
    attrs: {
      "column": ""
    }
  }, [!!_vm.title ? _c('VcModalHeader', {
    staticClass: "vc-bottom-sheet__header",
    class: {
      'showDivider': _vm.showHeaderDivider
    },
    attrs: {
      "close-button": _vm.closeButton,
      "data-qa": _vm.dataQa + "-header",
      "show-back-button": false,
      "title": _vm.title,
      "flavor": "input"
    },
    on: {
      "onCloseButtonClicked": function ($event) {
        return _vm.$emit('input', false);
      }
    },
    scopedSlots: _vm._u([{
      key: "headerImage",
      fn: function () {
        return [_vm.showHeaderToggle ? _c('VcSwitch', {
          attrs: {
            "color": "secondary",
            "data-qa": _vm.dataQa + "-switch"
          },
          on: {
            "input": _vm.onHeaderToggleChanged
          },
          model: {
            value: _vm.toggleValue,
            callback: function ($$v) {
              _vm.toggleValue = $$v;
            },
            expression: "toggleValue"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 4191315885)
  }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    staticClass: "vc-bottom-sheet__content",
    attrs: {
      "column": ""
    }
  }, [_c('VcForm', {
    ref: "mainForm",
    staticClass: "VcContent",
    attrs: {
      "value": _vm.validForm,
      "lazy-validation": ""
    },
    on: {
      "input": _vm.onMainFormValueChanged,
      "submit": function (data) {
        return _vm.$emit('submit', data);
      }
    }
  }, [_vm._t("default", null, {
    "disabled": !_vm.toggleValue
  })], 2)], 1), _vm._v(" "), _vm.footer ? _c('VcModalFooter', {
    staticClass: "vc-bottom-sheet__footer",
    class: {
      'showDivider': _vm.showHeaderDivider
    },
    attrs: {
      "buttons": [{
        label: _vm.cancelButtonLabel || _vm.$dst("ds.modal.cancel"),
        event: "onCancelClicked",
        color: "white"
      }, {
        label: _vm.okButtonLabel || _vm.$dst("ds.modal.ok"),
        event: "onOkClicked",
        color: "secondary"
      }],
      "data-qa": _vm.dataQa + "-footer"
    },
    on: {
      "onCancelClicked": function ($event) {
        return _vm.$emit('onCancelClicked');
      },
      "onOkClicked": _vm.onOkClicked
    }
  }) : _vm._e()], 1)]], 2);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-e1c1f348_0", {
    source: "[data-v-e1c1f348]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.VcInputBottomSheet .vc-bottom-sheet__header.showDivider[data-v-e1c1f348]{border-bottom:1px solid var(--gray-lighten-1)}.VcInputBottomSheet .vc-bottom-sheet__footer[data-v-e1c1f348]{padding:var(--size-value3) var(--size-value4)}.VcInputBottomSheet .vc-bottom-sheet__footer.showDivider[data-v-e1c1f348]{border-top:1px solid var(--gray-lighten-1);display:flex}.VcInputBottomSheet .vc-bottom-sheet__content[data-v-e1c1f348]{padding:var(--size-value6) var(--size-value4);overflow-y:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$v = "data-v-e1c1f348";
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$u = {
  components: {
    VMenu: VMenu
  },

  name: "VcPopover",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    closeOnClick: {
      type: Boolean,
      default: true
    },
    top: {
      type: Number
    },
    right: {
      type: Number
    },
    bottom: {
      type: Number
    },
    left: {
      type: Number
    },
    dataQa: {
      type: String,
      default: 'vc-popover'
    }
  }
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "close-on-click": _vm.closeOnClick,
      "close-on-content-click": false,
      "data-qa": _vm.dataQa,
      "value": _vm.value,
      "content-class": "vc-popover",
      "nudge-top": _vm.top,
      "nudge-right": _vm.right,
      "nudge-bottom": _vm.bottom,
      "nudge-left": _vm.left
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = function (inject) {
  if (!inject) return;
  inject("data-v-da6757e6_0", {
    source: "[data-v-da6757e6]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-popover[data-v-da6757e6]{background-color:var(--modal-bg-color);width:var(--popover-width);max-height:var(--popover-max-height);display:flex;box-shadow:var(--modal-box-shadow);border-radius:var(--popover-border-radius)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$u = "data-v-da6757e6";
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);

var script$t = {
  name: "VcInputPopover",
  components: {
    VcModalHeader: __vue_component__$S,
    VcLayout: __vue_component__$U,
    VcModalFooter: __vue_component__$T,
    VcForm: __vue_component__$Q,
    VcPopover: __vue_component__$u,
    VcSwitch: __vue_component__$w
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      Type: String
    },
    okButtonLabel: {
      type: String
    },
    cancelButtonLabel: {
      type: String
    },
    footer: {
      type: Boolean,
      default: true
    },
    top: {
      type: Number
    },
    right: {
      type: Number
    },
    bottom: {
      type: Number
    },
    left: {
      type: Number
    },
    dataQa: {
      type: String,
      default: 'vc-input-popover'
    },
    showHeaderToggle: {
      type: Boolean,
      default: false
    },
    toggleInitialValue: {
      type: Boolean,
      default: true
    },
    closeOnClick: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      validForm: true,
      toggleValue: this.toggleInitialValue
    };
  },

  methods: {
    onOkClicked() {
      this.validate();
      this.$emit('onOkClicked', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    validate() {
      this.$refs.mainForm.validate();
    },

    onMainFormValueChanged(value) {
      this.validForm = value;
      this.$emit('onValidationChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    },

    onHeaderToggleChanged() {
      this.$emit('onDisabledChanged', {
        valid: this.validForm,
        disabled: !this.toggleValue
      });
    }

  }
};

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcPopover', {
    attrs: {
      "close-on-click": _vm.validForm && _vm.closeOnClick,
      "value": _vm.value,
      "top": _vm.top,
      "right": _vm.right,
      "bottom": _vm.bottom,
      "left": _vm.left,
      "data-qa": _vm.dataQa + "-bottom-sheet"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', val);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        var on = ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true)
  }, [_vm._v(" "), [_c('VcLayout', {
    attrs: {
      "data-qa": _vm.dataQa + "-layout",
      "column": ""
    }
  }, [!!_vm.title ? _c('VcModalHeader', {
    staticClass: "vc-popover-header",
    attrs: {
      "data-qa": _vm.dataQa + "-header",
      "show-back-button": false,
      "title": _vm.title,
      "flavor": "input"
    },
    scopedSlots: _vm._u([{
      key: "headerImage",
      fn: function () {
        return [_vm.showHeaderToggle ? _c('VcSwitch', {
          attrs: {
            "color": "secondary",
            "data-qa": _vm.dataQa + "-switch"
          },
          on: {
            "input": _vm.onHeaderToggleChanged
          },
          model: {
            value: _vm.toggleValue,
            callback: function ($$v) {
              _vm.toggleValue = $$v;
            },
            expression: "toggleValue"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 4191315885)
  }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    staticClass: "vc-popover-content",
    attrs: {
      "column": ""
    }
  }, [_c('VcForm', {
    ref: "mainForm",
    staticClass: "VcContent",
    attrs: {
      "value": _vm.validForm,
      "lazy-validation": ""
    },
    on: {
      "input": _vm.onMainFormValueChanged,
      "submit": function (data) {
        return _vm.$emit('submit', data);
      }
    }
  }, [_vm._t("default", null, {
    "disabled": !_vm.toggleValue
  })], 2)], 1), _vm._v(" "), _vm.footer ? _c('VcModalFooter', {
    staticClass: "vc-popover-footer",
    attrs: {
      "buttons": [{
        label: _vm.cancelButtonLabel || _vm.$dst("ds.modal.cancel"),
        event: "onCancelClicked",
        color: "white"
      }, {
        label: _vm.okButtonLabel || _vm.$dst("ds.modal.done"),
        event: "onOkClicked",
        color: "secondary"
      }]
    },
    on: {
      "onCancelClicked": function ($event) {
        return _vm.$emit('onCancelClicked');
      },
      "onOkClicked": _vm.onOkClicked
    }
  }) : _vm._e()], 1)]], 2);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = function (inject) {
  if (!inject) return;
  inject("data-v-97aa8f28_0", {
    source: "[data-v-97aa8f28]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-popover[data-v-97aa8f28]{width:var(--popover-width);max-height:var(--popover-max-height);display:flex;box-shadow:var(--modal-box-shadow)}.vc-popover .vc-popover-content[data-v-97aa8f28]{padding:var(--size-value4) var(--size-value6);overflow-y:auto}.vc-popover .vc-popover-footer[data-v-97aa8f28]{padding:var(--size-value3) var(--size-value6)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$t = "data-v-97aa8f28";
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);

var script$s = {
  name: "VcChip",
  components: {
    VcIcon: __vue_component__$X,
    VcAvatar: __vue_component__$J,
    VChip: VChip
  },
  props: {
    label: {
      type: String,
      required: true
    },
    avatar: {
      type: Object,
      validator: avatar => avatar.imagePath || avatar.colorId
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-chip'
    }
  }
};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-chip', {
    staticClass: "VcChip",
    class: {
      'vc-invalid': _vm.invalid,
      'vc-avatar': !!_vm.avatar
    },
    attrs: {
      "close": _vm.closeButton,
      "ripple": "",
      "close-icon": "$close",
      "disabled": _vm.disabled,
      "data-qa": _vm.dataQa
    },
    on: {
      "click:close": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [!!_vm.avatar ? _c('div', {
    staticClass: "vc-avatar-wrapper"
  }, [!_vm.invalid ? _c('VcAvatar', _vm._b({
    attrs: {
      "name": _vm.label,
      "show-border": false,
      "size": "x-sm"
    }
  }, 'VcAvatar', _vm.avatar, false)) : _c('VcIcon', {
    attrs: {
      "data-qa": _vm.dataQa + "-invalid-icon"
    }
  }, [_vm._v("$attention_fill")])], 1) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.label) + "\n")]);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = function (inject) {
  if (!inject) return;
  inject("data-v-d8233608_0", {
    source: "[data-v-d8233608]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.VcChip[data-v-d8233608]{max-width:fit-content;border:1px solid var(--neutral-lighten-1)}.VcChip.v-chip[data-v-d8233608]{background-color:var(--modal-bg-color)}.VcChip.v-chip[data-v-d8233608]  .v-chip__content{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-5)}.VcChip.v-chip[data-v-d8233608]  .v-chip__content .vc-avatar-wrapper{margin-inline-end:var(--size-value2)}.VcChip.v-chip[data-v-d8233608]  .v-chip__content .vc-avatar-wrapper .vc-attention-fill{fill:var(--yellow)}.VcChip.v-chip[data-v-d8233608]  .v-chip__content .v-chip__close{direction:inherit;margin-inline:var(--size-value1) var(--size-value0);color:var(--gray)}.VcChip.v-chip[data-v-d8233608]  .v-chip__content .v-chip__close:hover{opacity:unset}.VcChip.v-chip.vc-avatar[data-v-d8233608]{padding-inline:var(--size-value1) var(--size-value3)}.VcChip.v-chip--disabled[data-v-d8233608]{background-color:var(--gray-lighten-2);border:1px solid var(--gray-lighten-2)}.VcChip.v-chip--disabled[data-v-d8233608]  .v-chip__content{color:var(--gray-darken-1)}.VcChip.vc-invalid[data-v-d8233608]{background-color:var(--yellow-lighten-3);border:1px solid var(--yellow)}.VcChip.vc-invalid[data-v-d8233608]:hover{background-color:var(--yellow-lighten-2)}.VcChip[data-v-d8233608]:hover{background-color:var(--gray-lighten-3)}.VcChip[data-v-d8233608]:hover:before{opacity:0}.VcChip[data-v-d8233608]:focus{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcChip[data-v-d8233608]:focus:before{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$s = "data-v-d8233608";
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$r = {
  components: {
    VCol: VCol,
    VRow: VRow,
    VContainer: VContainer
  },

  name: "VcButtonGroup",

  props: {
    buttons: {
      type: Array,
      required: true,
      validator: function (buttons) {
        return buttons.length >= 4 && buttons.length <= 9 && buttons.every(button => !!button.id && !!button.label);
      }
    },
    selected: String,
    direction: {
      type: String,
      default: 'vertical',
      validator: prop => ['horizontal', 'vertical'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcButtonGroup'
    }
  },

  model: {
    prop: 'selected',
    event: 'change'
  },

  created() {
    this.buttonSelected = this.selected;
  },

  data() {
    return {
      buttonSelected: false
    };
  },

  computed: {
    rows() {
      let rows = [];
      let numOfRows = Math.ceil(this.buttons.length / this.cols);

      for (let row = 0; row < numOfRows; row++) {
        const sliceStart = row * this.cols;
        const sliceEnd = row * this.cols + this.cols;
        const buttonsRow = this.buttons.slice(sliceStart, sliceEnd);
        rows.push(buttonsRow);
      }

      return rows;
    },

    cols() {
      switch (this.buttons.length) {
        case 5:
        case 6:
          return this.direction === 'horizontal' ? 3 : 2;

        case 7:
        case 8:
          return this.direction === 'horizontal' ? 4 : 2;

        case 9:
          return 3;
      }

      return 2;
    }

  },

  methods: {
    onSelected: function (id) {
      this.$emit('change', id);
    }
  }
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', {
    staticClass: "VcButtonGroup",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, _vm._l(_vm.rows, function (row, rowIdx) {
    return _c('v-row', {
      key: "row-" + rowIdx,
      staticClass: "button-group-row",
      attrs: {
        "data-qa": "row"
      }
    }, _vm._l(row, function (button, itemIdx) {
      return _c('v-col', {
        key: button.id,
        staticClass: "button-item d-flex align-center justify-center",
        class: {
          'selected': button.id === _vm.selected,
          'top': rowIdx === 0,
          'left': itemIdx === 0,
          'bottom': rowIdx === _vm.rows.length - 1,
          'right': itemIdx === row.length - 1,
          'disabled': button.disabled
        },
        attrs: {
          "cols": Math.floor(12 / _vm.cols),
          "data-qa": "item-" + _vm.buttons.indexOf(button)
        },
        on: {
          "click": function ($event) {
            return _vm.onSelected(button.id);
          }
        }
      }, [_c('div', {
        staticClass: "button-label"
      }, [_vm._v("\n        " + _vm._s(button.label) + "\n      ")])]);
    }), 1);
  }), 1);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-284ef818_0", {
    source: ".VcButtonGroup[data-v-284ef818]{font-weight:var(--font-weight-medium2);font-size:13px}.VcButtonGroup .button-group-row[data-v-284ef818]{margin:0}.VcButtonGroup .button-item[data-v-284ef818]{cursor:pointer;transition:.3s background-color,color ease-out;min-height:40px;border-color:#d6dbe6;border-style:solid;border-width:0;color:rgba(0,0,0,.62);border-right-width:1px;border-bottom-width:1px;padding:0 12px}.VcButtonGroup .button-item .button-label[data-v-284ef818]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.VcButtonGroup .button-item.left[data-v-284ef818]{border-left-width:1px}.VcButtonGroup .button-item.top[data-v-284ef818]{border-top-width:1px}.VcButtonGroup .button-item.bottom[data-v-284ef818]:not(.top):not(.selected){border-top-width:0}.VcButtonGroup .button-item.top.left[data-v-284ef818]{border-top-left-radius:6px}.VcButtonGroup .button-item.top.right[data-v-284ef818]{border-top-right-radius:6px}.VcButtonGroup .button-item.bottom.left[data-v-284ef818]{border-bottom-left-radius:6px}.VcButtonGroup .button-item.bottom.right[data-v-284ef818]{border-bottom-right-radius:6px}.VcButtonGroup .button-item[data-v-284ef818]:hover{background-color:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-284ef818]:focus{box-shadow:0 0 0 3px var(--v-secondary-lighten1)}.VcButtonGroup .button-item.selected[data-v-284ef818]{border:2px solid var(--v-secondary-base);font-weight:600}.VcButtonGroup .button-item.selected[data-v-284ef818]:hover{background:rgba(0,0,0,.03)}.VcButtonGroup .button-item[data-v-284ef818]:active{background:rgba(0,0,0,.12)}.VcButtonGroup .button-item.disabled[data-v-284ef818]{background:rgba(0,0,0,.07);color:rgba(0,0,0,.4);pointer-events:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$r = "data-v-284ef818";
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
var script$q = {
  components: {
    VProgressCircular: VProgressCircular
  },

  name: "VcLoader",

  props: {
    value: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "primary"
    },
    size: {
      type: Number,
      required: false
    },
    width: {
      type: Number,
      required: false
    }
  }
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-progress-circular', {
    attrs: {
      "value": _vm.value,
      "color": _vm.color,
      "size": _vm.size,
      "width": _vm.width,
      "indeterminate": ""
    }
  });
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

var script$p = {
  components: {
    VcIcon: __vue_component__$X,
    VcSwitch: __vue_component__$w,
    VContainer: VContainer
  },
  name: 'VcListEntity',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcListEntity'
    }
  }
};

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "listEntity",
    attrs: {
      "id": "container",
      "data-qa": _vm.dataQa
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-space-between align-center sl-row",
    class: {
      'margin-start': _vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', {
    staticClass: "justify-start d-flex align-center"
  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
    staticClass: "sl-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('VcSwitch', {
    attrs: {
      "disabled": _vm.disabled,
      "ripple": false,
      "value": _vm.value,
      "color": "secondary"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', Boolean(val));
      }
    }
  })], 1)])])], 1);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = function (inject) {
  if (!inject) return;
  inject("data-v-03298204_0", {
    source: ".listEntity .sl-title{font-size:var(--font-size-x-small);line-height:var(--size-value4);font-weight:var(--font-weight-medium2);margin:0 8px}.listEntity .sl-row{min-width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

var script$o = {
  components: {
    VcImage: __vue_component__$O,
    VcIcon: __vue_component__$X,
    VcSwitch: __vue_component__$w,
    VContainer: VContainer
  },
  name: "VcExpansionCard",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    toLogo: {
      type: String,
      required: false,
      default: ""
    },
    fromLogo: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: "VcExpansionCard"
    }
  }
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "expansionCard",
    class: {
      'is-active': _vm.value
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-container', {
    staticClass: "expansion-card-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "\n        expansionCardTitle\n        d-flex\n        flex-wrap\n        justify-space-between\n        align-center\n      "
  }, [_c('div', {
    staticClass: "logo-area justify-start d-flex align-center"
  }, [_c('VcImage', {
    staticClass: "VcLogoImage",
    attrs: {
      "image": _vm.fromLogo
    }
  }), _vm._v(" "), _c('VcIcon', {
    attrs: {
      "size": "12"
    }
  }, [_vm._v("$chevron_right")]), _vm._v(" "), _c('VcImage', {
    staticClass: "VcLogoImage",
    attrs: {
      "image": _vm.toLogo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-end",
    class: {
      'order-2': _vm.$vuetify.breakpoint.mdAndUp
    },
    staticStyle: {
      "width": "initial"
    }
  }, [_c('VcSwitch', {
    attrs: {
      "disabled": _vm.disabled,
      "ripple": false,
      "icon": "",
      "value": _vm.value,
      "color": "secondary"
    },
    on: {
      "input": function (val) {
        return _vm.$emit('input', Boolean(val));
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-wrap ec-text",
    class: {
      'order-1 justify-start': _vm.$vuetify.breakpoint.mdAndUp,
      'full-width': !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('div', {
    staticClass: "ec-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])]), _vm._v(" "), _vm.value ? _c('div', {
    staticClass: "default-slot-content"
  }, [_vm._t("default")], 2) : _vm._e()])], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = function (inject) {
  if (!inject) return;
  inject("data-v-5f907c3e_0", {
    source: ".expansionCard[data-v-5f907c3e]{border-radius:var(--border-radius);border:1px solid;border-color:var(--gray-lighten-1)!important;margin:var(--size-value5) 0}.expansionCard.is-active[data-v-5f907c3e]{border-color:var(--v-secondary-base)!important}.expansionCard .ec-title[data-v-5f907c3e]{font-size:var(--font-size-small2);line-height:var(--size-value6);margin:var(--size-value3) 0}@media screen and (min-width:960px){.expansionCard .ec-title[data-v-5f907c3e]{padding-inline-start:35px}}.expansionCard .VcLogoImage[data-v-5f907c3e]{width:var(--size-value7);height:var(--size-value7);margin:0 6px;box-sizing:border-box;border-radius:6px}.expansionCard .ec-text.full-width[data-v-5f907c3e]{width:100%}.expansionCard .ec-text.order-1[data-v-5f907c3e]{flex-grow:1}.expansionCard .expansion-card-container[data-v-5f907c3e]{padding:var(--size-value4)}@media screen and (min-width:960px){.expansionCard .expansion-card-container[data-v-5f907c3e]{padding:var(--size-value4) var(--size-value6)}}.expansionCard .default-slot-content[data-v-5f907c3e]{max-height:10000px;transition:max-height;transition-duration:.3s;overflow:hidden}.expansionCard .default-slot-content.hidden[data-v-5f907c3e]{max-height:0}@media screen and (min-width:960px){.expansionCard .default-slot-content[data-v-5f907c3e]{padding-inline-start:108px}}.expansionCardTitle[data-v-5f907c3e]{min-width:100%}.logo-area[data-v-5f907c3e]{min-width:92px}",
    map: undefined,
    media: undefined
  }), inject("data-v-5f907c3e_1", {
    source: ".expansionCard .vc-chevron-right{fill:var(--gray-darken-1)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$o = "data-v-5f907c3e";
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$n = {
  components: {
    VTextarea: VTextarea
  },

  name: 'VcTextArea',

  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    rules: {
      type: Array
    },
    dataQa: {
      type: String,
      default: 'vc-text-area'
    },
    counter: {
      type: [Boolean, Number, String],
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    messages: {
      type: [String, Boolean],
      default: ''
    },
    autoGrow: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1
    },
    noResize: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String],
      default: ''
    }
  }
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-textarea', {
    staticClass: "VcTextArea",
    class: {
      'no-label': !_vm.label
    },
    attrs: {
      "dense": "",
      "primary": "",
      "messages": _vm.messages,
      "rows": _vm.rows,
      "label": _vm.label,
      "rules": _vm.rules,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "hide-details": "auto",
      "disabled": _vm.disabled,
      "counter": _vm.counter,
      "data-qa": _vm.dataQa,
      "auto-grow": _vm.autoGrow,
      "no-resize": _vm.noResize,
      "height": _vm.height
    },
    on: {
      "input": function (data) {
        return _vm.$emit('input', data);
      }
    }
  });
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-4db277ef_0", {
    source: "[data-v-4db277ef].VcTextArea.v-text-field .v-text-field__slot:first-child{margin-inline-start:12px;margin-top:3px;height:100%}[data-v-4db277ef].VcTextArea.v-text-field.v-input--is-focused label,[data-v-4db277ef].VcTextArea.v-text-field.v-input--is-label-active label{font-size:12px;color:rgba(0,0,0,.62)!important;transform:translateY(-18px) scale(.85)}[data-v-4db277ef].VcTextArea.v-text-field.v-input--is-focused .v-input__slot{border-color:var(--v-secondary-base);box-shadow:0 0 0 3px var(--v-secondary-lighten1);transition:box-shadow .1s!important}[data-v-4db277ef].VcTextArea.v-text-field:not(.v-text-field--outlined) .v-text-field__slot{transition:margin-bottom .1s}[data-v-4db277ef].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-focused label,[data-v-4db277ef].VcTextArea.v-text-field:not(.v-text-field--outlined).v-input--is-label-active label{font-size:12px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.17;letter-spacing:-.3px;color:rgba(0,0,0,.62)!important;transform:translateY(-100%) scale(.85);top:24px}[data-v-4db277ef].VcTextArea.v-text-field .v-input__slot{border-radius:6px;background-color:#fff!important;position:relative!important;border:solid 1px rgba(0,0,0,.12);transition:border-color .1s!important;caret-color:var(--gray-darken-3)}[data-v-4db277ef].VcTextArea.v-text-field .v-input__slot:hover:not(.v-input--is-focused.v-input__slot):not(.error--text.v-input__slot){border-color:#757575}[data-v-4db277ef].VcTextArea.v-text-field .v-input__slot:after,[data-v-4db277ef].VcTextArea.v-text-field .v-input__slot:before{display:none}[data-v-4db277ef].VcTextArea.v-text-field textarea{font-size:15px!important;font-weight:500;line-height:1.5;margin-top:20px}[data-v-4db277ef].VcTextArea.v-text-field.no-label textarea{margin-top:var(--size-value2)}[data-v-4db277ef].VcTextArea.v-text-field .v-text-field__prefix{color:rgba(0,0,0,.54)!important}[data-v-4db277ef].VcTextArea.v-text-field.error--text .v-input__slot{border:1px solid var(--v-danger-base);box-shadow:none}[data-v-4db277ef].VcTextArea.v-text-field.v-input--is-disabled .v-input__slot{background-color:rgba(0,0,0,.03)!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$n = "data-v-4db277ef";
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var script$m = {
  name: 'VcSelectField',
  components: {
    VcIconWithTooltip: __vue_component__$K,
    VcIcon: __vue_component__$X,
    VSelect: VSelect
  },

  data() {
    return {
      openMenu: false
    };
  },

  props: {
    dataQa: {
      type: String,
      default: 'vc-select-field'
    },
    preSelection: {
      type: Object,
      required: false
    },
    rules: {
      type: Array
    },
    label: {
      type: String,
      default: ''
    },
    tooltipHeader: {
      type: String,
      default: ''
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    messages: {
      type: [String, Array],
      default: ''
    },
    errorMessages: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipNudgeLeft: {
      type: Number,
      default: 0
    },
    tooltipNudgeRight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    menuProps() {
      return {
        'offset-y': true,
        'contentClass': 'vc-select-field-menu'
      };
    }

  },
  methods: {
    selectionChanged(selection) {
      this.$emit('selection-changed', selection);
    }

  }
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', {
    staticClass: "VcSelectField",
    class: {
      'with-tooltip': _vm.tooltipContent
    },
    attrs: {
      "dense": "",
      "outlined": "",
      "return-object": "",
      "hide-details": "auto",
      "label": _vm.label,
      "items": _vm.items,
      "rules": _vm.rules,
      "data-qa": _vm.dataQa,
      "messages": _vm.messages,
      "error-messages": _vm.errorMessages,
      "disabled": _vm.disabled,
      "value": _vm.preSelection,
      "menuProps": _vm.menuProps,
      "placeholder": _vm.placeholder
    },
    on: {
      "change": _vm.selectionChanged
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('div', {
          staticClass: "dropdown-arrow d-flex align-center justify-center"
        }, [_c('VcIcon', {
          staticClass: "icon",
          attrs: {
            "size": "9"
          }
        }, [_vm._v("$caret_down")])], 1), _vm._v(" "), _vm.tooltipContent ? _c('div', {
          staticClass: "tooltip d-flex align-center"
        }, [_c('VcIconWithTooltip', {
          attrs: {
            "header": _vm.tooltipHeader,
            "content": _vm.tooltipContent,
            "nudge-left": _vm.tooltipNudgeLeft,
            "nudge-right": _vm.tooltipNudgeRight,
            "size": 15,
            "icon": 'question'
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-1413447c_0", {
    source: "[data-v-1413447c]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.VcSelectField[data-v-1413447c]{border-radius:var(--border-radius)}.VcSelectField[data-v-1413447c] .icon{fill:var(--gray-darken-2)}.VcSelectField[data-v-1413447c] fieldset{height:var(--select-field-height);background:var(--modal-bg-color);border-color:var(--gray-lighten-1);transition:border-color .1s}.VcSelectField[data-v-1413447c] .v-label--active{transform:translateY(-8px) scale(.75)!important}.VcSelectField[data-v-1413447c] .v-label{color:var(--gray-darken-3)!important}.VcSelectField[data-v-1413447c] .v-select__slot label+div{position:absolute;top:10px}.VcSelectField[data-v-1413447c]:hover fieldset{border-color:var(--gray-darken-3)}.VcSelectField[data-v-1413447c].v-input--is-disabled fieldset{background-color:var(--gray-lighten-3)}.VcSelectField[data-v-1413447c].v-input--is-focused fieldset{border:1px solid var(--v-secondary-base)!important;transition:outline .1s,border-color .1s;outline:var(--v-secondary-lighten1) solid 3px}.VcSelectField[data-v-1413447c].v-input--is-focused fieldset input{color:var(--gray-darken-3)}.VcSelectField[data-v-1413447c].error--text fieldset{border:1px solid var(--red);transition:border-color .1s}.VcSelectField[data-v-1413447c] .v-text-field__details{padding-inline-start:0}.VcSelectField[data-v-1413447c] .v-text-field__details .v-messages__message{margin-top:10px}.VcSelectField[data-v-1413447c] legend{display:none}.VcSelectField[data-v-1413447c] .v-select__selection--comma{font-size:15px;font-weight:500}.VcSelectField[data-v-1413447c].with-tooltip .v-select__selection{max-width:75%}.VcSelectField[data-v-1413447c] .v-input__append-inner{align-content:center;align-items:center;margin-top:5px!important;height:75%}.VcSelectField[data-v-1413447c] .dropdown-arrow{width:var(--size-value5);height:var(--size-value5)}.VcSelectField[data-v-1413447c] .tooltip{padding-inline-start:var(--size-value3);margin-inline-start:var(--size-value3);border-inline-start:1px solid var(--gray-lighten-1);height:100%}",
    map: undefined,
    media: undefined
  }), inject("data-v-1413447c_1", {
    source: ".vc-select-field-menu{margin-top:14px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$m = "data-v-1413447c";
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var script$l = {
  name: 'VcToast',
  components: {
    VcAlert: __vue_component__$M,
    VSnackbar: VSnackbar
  },
  props: {
    value: {
      type: Boolean
    },
    timeout: {
      type: Number,
      required: false
    }
  },
  computed: {
    computedTimeout() {
      return this.timeout || this.$ds.toastTimeout || 3000;
    }

  }
};

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-snackbar', {
    attrs: {
      "value": _vm.value || false,
      "timeout": _vm.computedTimeout,
      "bottom": "",
      "left": !_vm.$vuetify.rtl,
      "right": _vm.$vuetify.rtl
    }
  }, [_c('VcAlert', _vm._b({
    attrs: {
      "is-stripe": false
    }
  }, 'VcAlert', _vm.$attrs, false))], 1);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = function (inject) {
  if (!inject) return;
  inject("data-v-2d3e5bbe_0", {
    source: "[data-v-2d3e5bbe] .v-snack__action{display:none}[data-v-2d3e5bbe] .v-snack__wrapper.theme--dark{background-color:unset}[data-v-2d3e5bbe] .v-alert{margin-bottom:0}[data-v-2d3e5bbe] .v-sheet.v-snack__wrapper:not(.v-sheet--outlined){box-shadow:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$l = "data-v-2d3e5bbe";
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
var script$k = {
  components: {
    VCard: VCard
  },

  name: "VcCard",

  props: {
    dataQa: {
      type: String,
      default: 'VcCard'
    },
    elevation: {
      type: Boolean,
      default: true
    },
    dashColor: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "VcCard rounded",
    class: {
      'elevation': _vm.elevation,
      'dash': _vm.dashColor
    },
    attrs: {
      "tile": "",
      "outlined": !_vm.elevation,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.dashColor ? _c('hr', {
    staticClass: "VcCard__dash",
    style: {
      'background-color': _vm.dashColor
    },
    attrs: {
      "data-qa": "dash"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = function (inject) {
  if (!inject) return;
  inject("data-v-11425092_0", {
    source: ".VcCard[data-v-11425092]{position:relative;padding:16px 24px;border:1px solid var(--gray-lighten-1);box-sizing:border-box;box-shadow:none;overflow:hidden;transition:box-shadow .4s}.VcCard.elevation[data-v-11425092]{border:0;box-shadow:var(--shadow-2)}.VcCard.elevation[data-v-11425092]:hover{box-shadow:var(--shadow-5)}.VcCard.dash[data-v-11425092]{border-top:0}.VcCard__dash[data-v-11425092]{position:absolute;top:0;left:-5px;width:110%;border:0;height:5px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$k = "data-v-11425092";
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$j = {
  name: "FilterPanel",
  components: {
    VcLayout: __vue_component__$U,
    VcIcon: __vue_component__$X,
    VcButton: __vue_component__$W,
    VcLoader: __vue_component__$q
  },
  props: {
    title: {
      type: String,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcFilterPanel'
    }
  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcFilterPanel",
    attrs: {
      "column": "",
      "align-content-space-between": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    staticClass: "VcFilterPanel-container",
    attrs: {
      "column": ""
    }
  }, [_c('VcLayout', {
    staticClass: "VcFilterPanel-label-container"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("header")], 2)]), _vm._v(" "), _c('VcButton', {
    staticClass: "VcFilterPanel-close-button",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("$close_button")])];
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcFilterPanel-content-wrapper",
    attrs: {
      "column": ""
    }
  }, [_vm.isLoading ? _c('VcLoader', {
    staticClass: "filter-loader"
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)], 1);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = function (inject) {
  if (!inject) return;
  inject("data-v-44aac954_0", {
    source: ".VcFilterPanel[data-v-44aac954]{height:100%;max-width:280px;background-color:#fff;min-height:150px;box-shadow:0 5px 7px rgba(0,0,0,.26)}@media screen and (min-width:960px){.VcFilterPanel[data-v-44aac954]{max-width:265px}}.VcFilterPanel .filter-loader[data-v-44aac954]{margin:var(--size-value8) auto auto auto}.VcFilterPanel .VcFilterPanel-container[data-v-44aac954]{padding-bottom:53px;max-height:100%;overflow:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none}.VcFilterPanel .VcFilterPanel-container[data-v-44aac954]::-webkit-scrollbar{width:0;height:0}.VcFilterPanel .VcFilterPanel-container.column[data-v-44aac954]{position:relative}.VcFilterPanel .VcFilterPanel-container .VcFilterPanel-label-container[data-v-44aac954]{flex:0 0 56px}.VcFilterPanel .filter[data-v-44aac954]{min-width:100%;border-bottom:1px solid var(--gray);padding-left:var(--size-value6);padding-right:0;line-height:var(--size-value14);background-color:var(--neutral-lighten-3)}#app[dir=rtl] .VcFilterPanel .filter[data-v-44aac954]{padding-left:0}#app[dir=rtl] .VcFilterPanel .filter[data-v-44aac954]{padding-right:var(--size-value6)}.VcFilterPanel .filter .filter-label[data-v-44aac954]{font-size:var(--font-size-small2);font-weight:var(--font-weight-large);color:var(--gray-darken-5)}.VcFilterPanel .VcFilterPanel-content-wrapper[data-v-44aac954]{flex-grow:1}.VcFilterPanel .VcFilterPanel-close-button[data-v-44aac954]{position:absolute;width:var(--size-value6);height:var(--size-value6);top:var(--size-value4);right:var(--size-value4)}#app[dir=rtl] .VcFilterPanel .VcFilterPanel-close-button[data-v-44aac954]{right:auto;left:var(--size-value4)}.VcFilterPanel .VcFilterPanel-close-button .v-btn__content[data-v-44aac954]{opacity:unset}.VcFilterPanel .VcFilterPanel-close-button[data-v-44aac954]:hover{background-color:rgba(0,0,0,.07)}.VcFilterPanel .VcFilterPanel-close-button .v-icon[data-v-44aac954]{margin-right:var(--size-value0)}.VcFilterPanel .VcFilterPanel-close-button .v-icon svg[data-v-44aac954]{fill:var(--gray-darken-2);width:var(--size-value4);height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$j = "data-v-44aac954";
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

//
//
//
//
//
//
var script$i = {
  components: {
    VLayout: VLayout
  },

  name: "VcFocusArea",

  props: {
    dataQa: {
      type: String,
      default: 'VcFocusArea'
    }
  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-layout', {
    staticClass: "VcFocusArea",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = function (inject) {
  if (!inject) return;
  inject("data-v-e2463588_0", {
    source: ".VcFocusArea[data-v-e2463588]{padding:var(--size-value4);background-color:var(--gray-lighten-3);border-radius:6px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$i = "data-v-e2463588";
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

const VcLinkIcons = ['', 'copy', 'trash', 'left'];
var script$h = {
  name: "VcLink",
  components: {
    VcIcon: __vue_component__$X
  },
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    secondary: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      required: false,
      validator: prop => VcLinkIcons.includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcLink'
    },
    target: {
      type: String,
      default: '_blank',
      validator: prop => ['_blank', '_self', '_parent', '_top', '_system'].includes(prop)
    }
  },
  computed: {
    getIcon() {
      switch (this.prependIcon) {
        case 'copy':
          return '$copy';

        case 'trash':
          return '$trash';

        case 'left':
        default:
          return '$chevron_left';
      }
    }

  }
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a', {
    staticClass: "VcLink",
    class: {
      'link-secondary': _vm.secondary
    },
    attrs: {
      "href": _vm.url,
      "target": _vm.target,
      "data-qa": _vm.dataQa
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [!!_vm.prependIcon ? _c('VcIcon', {
    staticClass: "prepend-icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.getIcon))]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))])], 1);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = function (inject) {
  if (!inject) return;
  inject("data-v-65e5dd72_0", {
    source: ".VcLink[data-v-65e5dd72]{display:flex;align-items:center;font-size:var(--font-size-x-small);font-weight:var(--font-weight-medium2);padding-top:var(--size-value1);text-decoration:none;color:var(--blue)}.VcLink.link-secondary[data-v-65e5dd72]{color:var(--gray-darken-4)}.VcLink.link-secondary.VcLink[data-v-65e5dd72]  svg path{fill:var(--gray-darken-4)}.VcLink:hover label[data-v-65e5dd72]{text-decoration:underline;cursor:pointer}.VcLink .prepend-icon[data-v-65e5dd72]{padding-inline-end:var(--size-value1)}.VcLink .prepend-icon[data-v-65e5dd72]  svg path{fill:var(--blue)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$h = "data-v-65e5dd72";
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

var script$g = {
  name: "ListItem",
  components: {
    VcLayout: __vue_component__$U,
    VcCheckbox: __vue_component__$C,
    VcActions: __vue_component__$G
  },
  props: {
    showSelect: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(e => e.title && e.event)
    },
    value: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcListItem'
    }
  },
  methods: {
    onSelectClicked(newValue) {
      this.$emit('onSelectClicked', newValue);
    }

  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcListItem",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.showSelect ? _c('VcCheckbox', {
    staticClass: "selected-checkbox shrink mr-0 mt-0",
    attrs: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onSelectClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('VcLayout', {
    attrs: {
      "data-qa": "VcListItem-content"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "right-area"
  }, [_vm._t("further-actions"), _vm._v(" "), _vm.actions.length > 0 ? _c('VcActions', {
    attrs: {
      "items": _vm.actions
    },
    on: {
      "action": function (item) {
        return _vm.$emit(item);
      }
    }
  }) : _c('div', {
    staticClass: "placeholder"
  })], 2)], 1);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = function (inject) {
  if (!inject) return;
  inject("data-v-0a8bbb3a_0", {
    source: ".VcListItem[data-v-0a8bbb3a]{flex-grow:0;padding:var(--size-value6) 0}@media screen and (min-width:960px){.VcListItem[data-v-0a8bbb3a]{padding:var(--size-value6) var(--size-value5)}}.VcListItem .selected-checkbox[data-v-0a8bbb3a]{padding-right:var(--size-value1)}.VcListItem .right-area[data-v-0a8bbb3a]{justify-content:flex-end;transition:opacity .3s;flex-grow:0;align-items:center}@media screen and (min-width:960px){.VcListItem .right-area[data-v-0a8bbb3a]{opacity:0}}.VcListItem .right-area .three-dots[data-v-0a8bbb3a]{border-radius:1000px;min-width:unset;padding:0}@media screen and (min-width:960px){.VcListItem .right-area .placeholder[data-v-0a8bbb3a]{min-width:14px}}.VcListItem:hover .right-area[data-v-0a8bbb3a]{opacity:1}.VcListItem .v-btn:not(.v-btn--round).v-size--default[data-v-0a8bbb3a]{padding:0;min-width:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$g = "data-v-0a8bbb3a";
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var script$f = {
  name: "VcGroupHeader",
  components: {
    VcLayout: __vue_component__$U
  },
  props: {
    title: {
      type: String,
      required: true
    },
    summaryText: {
      type: String,
      default: ''
    },
    dataQa: {
      type: String,
      default: 'VcGroupHeader'
    }
  }
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcGroupHeader",
    attrs: {
      "justify-space-between": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.summaryText))])]);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-5cb0ff3e_0", {
    source: ".VcGroupHeader[data-v-5cb0ff3e]{width:100%;height:var(--size-value10);flex-grow:0;color:var(--gray-darken-3);background-color:var(--neutral-lighten-3);font-size:var(--font-size-small);font-weight:500;line-height:var(--size-value10);padding:0 var(--size-value5);border-bottom:1px solid var(--gray-lighten-1)}@media screen and (min-width:960px){.VcGroupHeader[data-v-5cb0ff3e]{font-size:var(--font-size-xx-small)}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$f = "data-v-5cb0ff3e";
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

//
//
//
//
var script$e = {
  name: 'VcSvg',
  props: ['svg']
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  });
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$d = {
  name: 'VcEmptyState',
  components: {
    VcImage: __vue_component__$O,
    VcSvg: __vue_component__$e,
    VcButton: __vue_component__$W,
    VcLayout: __vue_component__$U,
    VcLink: __vue_component__$h
  },
  props: {
    size: {
      type: String,
      default: 'md',
      validator: prop => ['sm', 'md', 'lg'].includes(prop)
    },
    image: {
      type: [String, Object],
      comment: 'This is the standard way to pass the image, the icon and svg props are for backward compatibility'
    },
    icon: {
      type: [String, Object],
      comment: 'url to some image, deprecated'
    },
    svg: {
      type: [String, Object],
      comment: 'using the svgImage design system object, deprecated'
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    button: {
      type: String,
      required: false
    },
    outlinedButton: {
      type: Boolean,
      required: false
    },
    linkLabel: {
      type: String,
      required: false
    },
    linkUrl: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      default: 'VcEmptyState'
    }
  },
  computed: {
    currentImage() {
      // for backward compatibility
      return this.image || this.icon || this.svg;
    },

    buttonFlavor() {
      return this.outlinedButton ? 'secondary' : 'primary';
    }

  }
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    class: "VcEmptyState " + _vm.size,
    attrs: {
      "column": "",
      "data-qa": _vm.dataQa
    }
  }, [_c('VcLayout', {
    attrs: {
      "column": ""
    }
  }, [_vm.currentImage ? _c('VcImage', {
    staticClass: "VcEmptyStateImage",
    attrs: {
      "image": _vm.currentImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "VcEmptyStateTitle"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), _c('VcLayout', {
    staticClass: "VcEmptyStateSubtitle",
    attrs: {
      "column": ""
    }
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _vm._t("buttonArea", function () {
    return [_vm.button || _vm.linkLabel && _vm.linkUrl ? _c('VcLayout', {
      attrs: {
        "column": "",
        "align-center": ""
      }
    }, [_vm.button ? _c('VcButton', {
      staticClass: "VcEmptyStateButton",
      attrs: {
        "small": "",
        "pill": "",
        "block": false,
        "outlined": _vm.outlinedButton,
        "flavor": _vm.buttonFlavor
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click');
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.button) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkLabel && _vm.linkUrl ? _c('VcLink', {
      attrs: {
        "url": _vm.linkUrl,
        "label": _vm.linkLabel
      }
    }) : _vm._e()], 1) : _vm._e()];
  })], 2);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-07491186_0", {
    source: ".VcEmptyState[data-v-07491186],.VcEmptyStateSubtitle[data-v-07491186]{text-align:center;line-height:var(--size-value6)}.VcEmptyState[data-v-07491186]{text-align:center}.VcEmptyState .VcEmptyStateImage[data-v-07491186]{margin-bottom:var(--size-value4);height:160px}.VcEmptyState .VcEmptyStateTitle[data-v-07491186]{font-weight:var(--font-weight-xl);line-height:22px;padding-bottom:var(--size-value1);font-size:var(--font-size-small2)}.VcEmptyState .VcEmptyStateSubtitle[data-v-07491186]{font-size:var(--font-size-x-small)}.VcEmptyState .VcEmptyStateButton[data-v-07491186]{margin-top:var(--size-value4)}.sm .VcEmptyStateImage[data-v-07491186]{height:48px;margin-bottom:var(--size-value8)}.sm .VcEmptyStateImage[data-v-07491186]  svg{width:48px}.lg .VcEmptyStateImage[data-v-07491186]{height:280px;margin-bottom:var(--size-value8)}.lg .VcEmptyStateImage[data-v-07491186]  svg{width:280px}.lg .VcEmptyStateTitle[data-v-07491186]{font-weight:var(--font-weight-large);line-height:22px;padding-bottom:var(--size-value2);font-size:var(--font-size-medium1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$d = "data-v-07491186";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var script$c = {
  name: "VcBanner",
  components: {
    VcImage: __vue_component__$O,
    VcButton: __vue_component__$W,
    VcIcon: __vue_component__$X,
    VcLink: __vue_component__$h,
    VcSvg: __vue_component__$e
  },
  props: {
    dataQa: {
      type: String,
      default: 'VcBanner'
    },
    image: {
      type: [String, Object],
      required: false
    },
    backgroundColor: {
      type: String,
      default: "#F8F9FB"
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    note: {
      type: String
    },
    linkUrl: {
      type: String,
      default: ''
    },
    linkLabel: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String
    },
    closeButton: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "banner",
    staticClass: "VcBanner d-flex justify-space-between flex-column flex-sm-row",
    style: {
      backgroundColor: _vm.backgroundColor
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "text-container px-6 pt-10 pt-sm-6 "
  }, [_c('div', {
    staticClass: "banner-title pb-2 pb-sm-4 pb-md-2 "
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.subtitle ? _c('div', {
    staticClass: "banner-subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm.buttonLabel || _vm.linkLabel ? _c('div', {
    staticClass: "cta-container py-6 py-sm-7 d-flex flex justify-start flex-wrap"
  }, [_vm.buttonLabel ? _c('VcButton', {
    staticClass: "primary-cta",
    attrs: {
      "pill": "",
      "large": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onAction');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonLabel) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.linkLabel && _vm.linkUrl ? _c('VcLink', {
    staticClass: "secondary-cta pt-6 pt-sm-0",
    attrs: {
      "url": _vm.linkUrl,
      "label": _vm.linkLabel
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.note || _vm.$slots.note ? _c('div', {
    staticClass: "banner-note py-4 pt-sm-9"
  }, [_vm._t("note", function () {
    return [_vm._v("\n        " + _vm._s(_vm.note) + "\n      ")];
  })], 2) : _vm._e()]), _vm._v(" "), _vm.image ? _c('div', {
    staticClass: "images-container d-flex align-self-end"
  }, [_c('VcSvg', {
    staticClass: "background-stain",
    attrs: {
      "svg": _vm.$svgImages.background_stain
    }
  }), _vm._v(" "), _c('VcImage', {
    staticClass: "banner-image pb-0",
    attrs: {
      "image": _vm.image
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.closeButton ? _c('VcButton', {
    staticClass: "close-button mt-6 me-1",
    attrs: {
      "icon": "",
      "data-qa": _vm.dataQa + "-close-btn",
      "fab": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('closeBanner');
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function () {
        return [_c('VcIcon', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("$close_button")])];
      },
      proxy: true
    }], null, false, 796317393)
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-b6def40c_0", {
    source: ".VcBanner[data-v-b6def40c]{min-height:188px;box-sizing:border-box;overflow:hidden;border-radius:var(--size-value2);border:1px solid var(--neutral-lighten-2);position:relative}.VcBanner .images-container[data-v-b6def40c]{position:relative;height:100%}.VcBanner .images-container .background-stain[data-v-b6def40c]{position:absolute;opacity:15%;margin:0 auto;overflow:hidden;top:-80px;height:calc(100% + 110px);transform:scale(.7);left:-335px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-b6def40c]{left:auto;right:-335px}@media screen and (min-width:600px){.VcBanner .images-container .background-stain[data-v-b6def40c]{transform:scale(1);top:-206px;height:calc(100% + 206px);left:-64px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-b6def40c]{left:auto;right:-64px}}@media screen and (min-width:960px){.VcBanner .images-container .background-stain[data-v-b6def40c]{top:-176px;height:calc(100% + 176px);left:-50px}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-b6def40c]{left:auto;right:-50px}}#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-b6def40c]{transform:scale(-.7,.7)}@media screen and (min-width:600px){#app[dir=rtl] .VcBanner .images-container .background-stain[data-v-b6def40c]{transform:scaleX(-1)}}.VcBanner .images-container .background-stain[data-v-b6def40c]  #background_stain{fill:var(--v-secondary-base)}.VcBanner .images-container .banner-image[data-v-b6def40c]{margin:auto 0 0;position:relative;width:200px;height:95px}@media screen and (min-width:600px){.VcBanner .images-container .banner-image[data-v-b6def40c]{width:300px;height:142.5px}}@media screen and (min-width:960px){.VcBanner .images-container .banner-image[data-v-b6def40c]{width:400px;height:190px}}.VcBanner .text-container[data-v-b6def40c]{flex:0 0 60%;color:var(--gray-darken-5);z-index:1}.VcBanner .text-container .banner-title[data-v-b6def40c]{font-weight:var(--font-weight-large2);font-size:var(--font-size-medium2);line-height:var(--size-value8)}@media screen and (min-width:960px){.VcBanner .text-container .banner-title[data-v-b6def40c]{flex:0 0 100%}}.VcBanner .text-container .banner-subtitle[data-v-b6def40c]{font-size:var(--font-size-small2);line-height:var(--size-value5);font-weight:var(--font-weight-medium2)}.VcBanner .text-container .banner-note[data-v-b6def40c]{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium)}.VcBanner .cta-container .primary-cta[data-v-b6def40c]{line-height:var(--size-value12);font-weight:var(--font-weight-large2);margin-inline-end:var(--size-value6)}.VcBanner .cta-container .secondary-cta[data-v-b6def40c]{font-size:var(--font-size-small2);font-weight:var(--font-weight-large);flex:0 0 100%}@media screen and (min-width:600px){.VcBanner .cta-container .secondary-cta[data-v-b6def40c]{flex:none}}.VcBanner .close-button[data-v-b6def40c]{position:absolute;width:var(--size-value3);height:var(--size-value3);right:var(--size-value4)}#app[dir=rtl] .VcBanner .close-button[data-v-b6def40c]{right:auto;left:var(--size-value4)}.VcBanner .close-button[data-v-b6def40c]  .v-btn__content{opacity:unset}.VcBanner .close-button[data-v-b6def40c]  .v-icon{margin-right:var(--size-value0)}.VcBanner .close-button[data-v-b6def40c]  .v-icon svg{fill:var(--gray-darken-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$c = "data-v-b6def40c";
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

var script$b = {
  name: "VcWizardCtaContainer",
  components: {
    VcButton: __vue_component__$W,
    VcLayout: __vue_component__$U
  },
  props: {
    isBackDisplayed: {
      type: Boolean,
      required: true
    },
    isNextButtonDisabled: {
      type: Boolean,
      required: true
    },
    backButtonLabel: {
      type: String,
      required: true
    },
    nextButtonLabel: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "wizard-cta-container",
    attrs: {
      "align-center": "",
      "justify-end": ""
    }
  }, [_vm.isBackDisplayed ? _c('vc-button', {
    staticClass: "wizard-cta-button back-button",
    attrs: {
      "color": "white",
      "pill": true,
      "data-qa": (_vm.dataQa ? _vm.dataQa + '-' : '') + "wizard-back-button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onBackPressed');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.backButtonLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('vc-button', {
    staticClass: "wizard-cta-button next-button",
    attrs: {
      "pill": true,
      "data-qa": (_vm.dataQa ? _vm.dataQa + '-' : '') + "wizard-next-button",
      "disabled": _vm.isNextButtonDisabled
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('moveForward');
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.nextButtonLabel) + "\n  ")])], 1);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-d0bdc5fc_0", {
    source: "[data-v-d0bdc5fc]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.wizard-cta-container[data-v-d0bdc5fc]{background-color:#fff;position:sticky;bottom:0;left:0;width:100%;height:var(--size-value18);max-height:var(--size-value18);padding:var(--size-value3) var(--size-value0);border-top:1px solid var(--gray-lighten-1)}@media screen and (min-width:960px){.wizard-cta-container[data-v-d0bdc5fc]{border-top:revert;position:static;width:100%;transform:revert;height:var(--size-value20);max-height:var(--size-value20);padding-bottom:var(--size-value6)}}.wizard-cta-button[data-v-d0bdc5fc]{flex:1;min-height:var(--size-value12)}@media screen and (min-width:960px){.wizard-cta-button[data-v-d0bdc5fc]{flex:revert;min-height:var(--size-value10)}}.wizard-cta-button+.wizard-cta-button[data-v-d0bdc5fc]{margin-inline-start:var(--size-value3)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$b = "data-v-d0bdc5fc";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

var script$a = {
  name: "VcStepperContent",
  model: {
    prop: 'currentStep'
  },
  props: {
    wizardData: {
      type: Object,
      required: true
    },
    currentStep: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      validator: steps => steps.every(step => step.component && step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-content-wizard'
    }
  },
  components: {
    VcLayout: __vue_component__$U,
    VcLoader: __vue_component__$q,
    VStepperContent: VStepperContent,
    VStepperItems: VStepperItems,
    VStepper: VStepper
  },

  data() {
    return {
      lastCompleted: 0,
      isLoading: true,
      LOADER_SIZE: 48,
      LOADER_COLOR: 'secondary',
      FIRST_STEP: 1
    };
  },

  mounted() {
    this.$nextTick(() => this.isLoading = false);
  },

  updated() {
    this.isLoading = false;
  },

  computed: {
    getStepName() {
      var _this$steps;

      return (_this$steps = this.steps[this.currentStep - 1]) === null || _this$steps === void 0 ? void 0 : _this$steps.name;
    },

    getStepDescription() {
      var _this$steps2;

      return (_this$steps2 = this.steps[this.currentStep - 1]) === null || _this$steps2 === void 0 ? void 0 : _this$steps2.description;
    }

  },
  methods: {
    nextStep() {
      if (this.lastCompleted < this.currentStep) {
        this.lastCompleted = this.currentStep;
      }

      if (this.currentStep > this.steps.length) {
        this.shareStep(this.steps.length);
      }
    },

    getStepQa(idx) {
      return `${this.dataQa}-step-${idx}`;
    },

    shareStep(step) {
      this.$emit('input', step);
    }

  },
  watch: {
    currentStep: {
      handler(newVal, oldVal) {
        this.isLoading = true;

        if (newVal > oldVal) {
          this.nextStep();
        }

        if (newVal < this.FIRST_STEP) {
          this.shareStep(this.FIRST_STEP);
        }
      }

    }
  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('vc-layout', {
    staticClass: "stepper-content-wrapper",
    attrs: {
      "column": "",
      "justify-start": ""
    }
  }, [!_vm.isLoading ? _c('VcLayout', {
    staticClass: "stepper-header",
    attrs: {
      "column": ""
    }
  }, [_c('div', {
    staticClass: "content-stepper-title"
  }, [_vm._v(_vm._s(_vm.getStepName))]), _vm._v(" "), _c('div', {
    staticClass: "content-stepper-description",
    domProps: {
      "innerHTML": _vm._s(_vm.getStepDescription)
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-stepper', {
    staticClass: "vc-stepper-content",
    attrs: {
      "data-qa": _vm.dataQa
    },
    model: {
      value: _vm.currentStep,
      callback: function ($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_c('v-stepper-items', _vm._l(_vm.steps, function (step, index) {
    return _c('v-stepper-content', {
      key: "step-" + index,
      attrs: {
        "step": index + 1
      }
    }, [_vm.currentStep === index + 1 ? _c('VcLayout', {
      staticClass: "layout-content",
      attrs: {
        "column": "",
        "justify-center": _vm.isLoading
      }
    }, [_c('VcLoader', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isLoading,
        expression: "isLoading"
      }],
      attrs: {
        "size": _vm.LOADER_SIZE,
        "color": _vm.LOADER_COLOR
      }
    }), _vm._v(" "), _vm._t("alert-" + (index + 1)), _vm._v(" "), _c(step.component, _vm._g(_vm._b({
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isLoading,
        expression: "!isLoading"
      }],
      tag: "component",
      attrs: {
        "data-qa": _vm.getStepQa(index)
      },
      on: {
        "submit": function (data) {
          return _vm.$emit('submit', data);
        },
        "moveForward": function ($event) {
          return _vm.$emit('moveForward');
        }
      }
    }, 'component', Object.assign({}, _vm.wizardData, step.props), false), step.event))], 2) : _vm._e()], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-c4dba744_0", {
    source: "[data-v-c4dba744]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.stepper-content-wrapper[data-v-c4dba744]{height:100%;width:100%;padding-bottom:var(--size-value6)}@media screen and (min-width:960px){.stepper-content-wrapper[data-v-c4dba744]{padding-bottom:var(--size-value0)}}.layout-content[data-v-c4dba744]{padding:var(--size-value0) var(--size-value4)}@media screen and (min-width:960px){.layout-content[data-v-c4dba744]{padding:revert;padding-block-start:var(--size-value3)}}.stepper-header[data-v-c4dba744]{flex:0;margin-block-end:var(--size-value4);padding:var(--size-value0)}@media screen and (min-width:960px){.stepper-header[data-v-c4dba744]{padding:revert;flex:revert;padding-block-start:var(--size-value3)}}.stepper-header .content-stepper-title[data-v-c4dba744]{letter-spacing:.01em;font-size:var(--font-size-medium);font-weight:var(--font-weight-large);line-height:var(--size-value8);color:var(--gray-darken-5)}@media screen and (min-width:960px){.stepper-header .content-stepper-title[data-v-c4dba744]{font-size:var(--font-size-medium2)}}.stepper-header .content-stepper-description[data-v-c4dba744]{font-size:var(--font-size-x-small);line-height:var(--size-value5);color:var(--gray-darken-4)}.stepper-header .content-stepper-description[data-v-c4dba744]  a{color:var(--blue)}.vc-stepper-content.v-stepper[data-v-c4dba744]{width:100%;box-shadow:none;height:100%;overflow:auto}.vc-stepper-content.v-stepper[data-v-c4dba744]  .v-stepper__items .v-stepper__content{padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$a = "data-v-c4dba744";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

var script$9 = {
  name: "VcWizard",
  components: {
    VcStepsBar: __vue_component__$F,
    VcStepperContent: __vue_component__$a,
    VcMobileWizardProgress: __vue_component__$D,
    VcWizardCtaContainer: __vue_component__$b,
    VLayout: VLayout
  },
  props: {
    size: {
      type: String,
      default: 'md',
      validator: size => ['md', 'lg'].indexOf(size) !== -1
    },
    initialWizardData: {
      type: Object,
      default: () => ({})
    },
    steps: {
      type: [Array],
      validator: steps => steps.every(step => step.name),
      required: true
    },
    dataQa: {
      type: String,
      default: 'wizard'
    },
    title: {
      type: String,
      default: ''
    },
    currentStep: {
      type: Number,
      default: 1
    }
  },
  model: {
    prop: 'currentStep',
    event: 'indexChanged'
  },

  data() {
    return {
      wizardSteps: [],
      wizardStepsData: {}
    };
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.wizardSteps = this.steps.slice();
    },

    goBackOneStep() {
      this.wizardStepsData[this.currentStepComputed] = undefined;
      this.$set(this.wizardStepsData, this.currentStepComputed, undefined);
      this.$emit('indexChanged', this.currentStepComputed - 1);
    },

    handleSubmit(data) {
      const stepData = data.stepData || {};
      const wizardData = data.wizardData || {};
      const newStepData = { ...this.currentStepObj,
        ...stepData
      };
      const newWizardStepData = { ...this.wizardStepsData[this.currentStepComputed],
        ...wizardData
      };
      this.$set(this.wizardStepsData, this.currentStepComputed, newWizardStepData);
      this.wizardSteps.splice(this.currentStepComputed - 1, 1, newStepData);
    },

    goForwardOneStep() {
      if (this.currentStepComputed < this.wizardSteps.length) {
        this.$emit('indexChanged', this.currentStepComputed + 1);
      } else {
        this.$emit('submit', this.wizardData);
      }
    }

  },
  computed: {
    wizardData() {
      return Object.keys(this.wizardStepsData).sort().reduce((acc, currentValue) => {
        Object.assign(acc, this.wizardStepsData[currentValue]);
        return acc;
      }, { ...this.initialWizardData
      });
    },

    currentStepObj() {
      return this.wizardSteps[this.currentStepComputed - 1];
    },

    isBackDisplayed() {
      return this.currentStepObj.isBackDisplayed !== undefined ? this.currentStepObj.isBackDisplayed : this.currentStepComputed > 1;
    },

    isNextButtonDisabled() {
      if (this.currentStepObj.nextStepEnabledRules) {
        return this.currentStepObj.nextStepEnabledRules.every(rule => !rule(this.wizardData));
      } else {
        return this.currentStepObj.isNextButtonDisabled !== undefined ? this.currentStepObj.isNextButtonDisabled : false;
      }
    },

    currentStepComputed() {
      return Math.min(this.currentStep, this.steps.length);
    }

  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-layout', {
    staticClass: "vc-wizard",
    class: ["wizard-size-" + _vm.size],
    attrs: {
      "column": "",
      "align-start": "",
      "justify-start": ""
    }
  }, [!_vm.$vuetify.breakpoint.mdAndUp ? _c('VcMobileWizardProgress', {
    attrs: {
      "dataQa": _vm.dataQa,
      "currentStep": _vm.currentStepComputed,
      "steps": _vm.wizardSteps
    }
  }) : _c('VcStepsBar', {
    attrs: {
      "currentStep": _vm.currentStepComputed,
      "steps": _vm.wizardSteps,
      "title": _vm.title,
      "dataQa": _vm.dataQa
    }
  }), _vm._v(" "), _c('VcStepperContent', {
    attrs: {
      "wizardData": _vm.wizardData,
      "currentStep": _vm.currentStepComputed,
      "steps": _vm.wizardSteps,
      "dataQa": _vm.dataQa
    },
    on: {
      "submit": _vm.handleSubmit,
      "moveForward": _vm.goForwardOneStep
    }
  }), _vm._v(" "), _c('VcWizardCtaContainer', {
    attrs: {
      "isBackDisplayed": _vm.isBackDisplayed,
      "isNextButtonDisabled": _vm.isNextButtonDisabled,
      "backButtonLabel": _vm.currentStepObj.backButtonLabel || _vm.$dst('ds.wizard.back'),
      "nextButtonLabel": _vm.currentStepObj.nextButtonLabel || _vm.$dst('ds.wizard.next'),
      "dataQa": _vm.dataQa
    },
    on: {
      "onBackPressed": _vm.goBackOneStep,
      "moveForward": _vm.goForwardOneStep
    }
  })], 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-10873292_0", {
    source: "[data-v-10873292]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-wizard[data-v-10873292]{height:100%}@media screen and (min-width:960px){.vc-wizard[data-v-10873292]{display:grid;grid-template-columns:minmax(250px,1fr) 3fr;grid-template-rows:1fr 80px;grid-row-gap:0}.vc-wizard.wizard-size-md[data-v-10873292]{grid-column-gap:var(--size-value10);padding-inline-end:var(--size-value10)}.vc-wizard.wizard-size-lg[data-v-10873292]{grid-column-gap:var(--size-value20);padding-inline-end:var(--size-value20)}}.vc-stepper-container[data-v-10873292]{grid-area:1/1/3/2;border-inline-end:1px solid #e0e0e0;max-height:calc(100% - 24px)}.wizard-cta-container[data-v-10873292]{grid-area:2/2/3/3}.stepper-content-wrapper[data-v-10873292]{grid-area:1/2/2/3}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$9 = "data-v-10873292";
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$8 = {
  name: 'VcBadge',
  components: {
    VBadge: VBadge
  },
  props: {
    left: {
      type: Boolean,
      required: false
    },
    badgeText: {
      type: [String, Number],
      required: false
    },
    badgeIcon: {
      type: String,
      required: false
    },
    offsetX: {
      type: Number,
      default: 18
    },
    offsetY: {
      type: Number
    },
    dataQa: {
      type: String,
      default: 'VcBadge'
    }
  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "VcBadge",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-badge', {
    attrs: {
      "color": "var(--red)",
      "overlap": "",
      "offset-x": _vm.offsetX,
      "offset-y": _vm.offsetY || _vm.offsetX,
      "icon": _vm.badgeIcon,
      "value": !!this.badgeIcon || !!this.badgeText,
      "left": _vm.left,
      "content": _vm.badgeText
    }
  }, [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-4edabf76_0", {
    source: "[data-v-4edabf76] .v-icon__component{height:12px;width:12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = "data-v-4edabf76";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

var script$7 = {
  name: "VcUpsellBlock",
  components: {
    VcImage: __vue_component__$O,
    VcLink: __vue_component__$h,
    VcButton: __vue_component__$W,
    VcLayout: __vue_component__$U,
    VcIcon: __vue_component__$X
  },
  props: {
    titleText: {
      type: String,
      default: ""
    },
    subtitleText: {
      type: String,
      default: ""
    },
    bulletsText: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: [String, Object],
      default: ''
    },
    linkUrl: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'page',
      validator: prop => ['page', 'dialog'].includes(prop)
    },
    dataQa: {
      type: String,
      default: 'VcUpsellBlock'
    },
    icon: {
      type: String,
      default: ''
    },
    linkTarget: {
      type: String,
      default: '_blank'
    }
  },
  computed: {
    isDialog() {
      return this.mode === 'dialog';
    }

  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "VcUpsellBlock justify-space-between align-md-center",
    class: {
      'dialog': _vm.isDialog
    },
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "text-container flex-column pa-6 pb-0"
  }, [_c('div', {
    staticClass: "title-text mb-4"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "sub-text mb-6"
  }, [_vm._v(_vm._s(_vm.subtitleText))]), _vm._v(" "), _vm._l(_vm.bulletsText, function (item, index) {
    return _vm.bulletsText.length > 0 ? _c('div', {
      key: index,
      staticClass: "bullets-text d-flex mb-3"
    }, [_vm.icon ? _c('div', {
      staticClass: "align-self-start bullets-icon"
    }, [_c('VcIcon', {
      attrs: {
        "size": "16"
      }
    }, [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "bullets-span"
    }, [_vm._v(_vm._s(item))])]) : _vm._e();
  }), _vm._v(" "), _vm.linkText || _vm.buttonText ? _c('div', {
    staticClass: "cta-container d-flex mt-md-6",
    class: _vm.isDialog ? 'cta-container-dialog' : ''
  }, [_vm.buttonText ? _c('VcButton', {
    staticClass: "primary-cta",
    attrs: {
      "pill": true
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('buttonClick');
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(), _vm._v(" "), _vm.linkText ? _c('VcLink', {
    staticClass: "secondary-cta justify-center",
    attrs: {
      "target": _vm.linkTarget,
      "url": _vm.linkUrl,
      "label": _vm.linkText
    }
  }) : _vm._e()], 1) : _vm._e()], 2), _vm._v(" "), _c('VcLayout', {
    staticClass: "images-container"
  }, [_c('VcImage', {
    staticClass: "upsell-image",
    attrs: {
      "image": _vm.imageUrl
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-3e23f57f_0", {
    source: ".VcUpsellBlock[data-v-3e23f57f]{flex-flow:row wrap;width:100%;height:100vh;max-width:960px;margin:auto;overflow-x:hidden;font-style:normal}@media screen and (min-width:960px){.VcUpsellBlock[data-v-3e23f57f]{overflow-x:visible}}.VcUpsellBlock[data-v-3e23f57f]:before{content:\"\";position:absolute;-webkit-mask-image:url(\"data:image/svg+xml,%3Csvg width='1387' height='1787' viewBox='0 0 1387 1787' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath id='background_stain' d='M965.208 1786.79L1240.04 1427.2C1388.67 1251.5 1443.75 1042.72 1314.06 863.507L768.194 165.405C638.503 -13.8061 388.739 -53.6307 210.377 76.6778L164.621 109.767C-13.7407 240.369 -53.3766 491.322 76.3144 670.533L649.578 1404.65L965.208 1786.79Z' fill='%230093B8'/%3E%3C/svg%3E\");background-color:var(--v-secondary-base);opacity:15%;inset:70% 0 0 0}@media screen and (min-width:960px){.VcUpsellBlock[data-v-3e23f57f]:before{inset:0;inset-inline-start:50%}}#app[dir=rtl] .VcUpsellBlock[data-v-3e23f57f]:before{transform:scaleX(-1)}.VcUpsellBlock.dialog[data-v-3e23f57f]{height:100%;padding-top:8px}@media screen and (min-width:960px){.VcUpsellBlock.dialog[data-v-3e23f57f]{padding-top:70px;padding-bottom:46px}}@media screen and (min-width:960px){.VcUpsellBlock.dialog[data-v-3e23f57f]:before{top:-10%}}.VcUpsellBlock .text-container[data-v-3e23f57f]{flex:0 0 100%;margin:0 auto}@media screen and (min-width:960px){.VcUpsellBlock .text-container[data-v-3e23f57f]{flex:0 0 55%;max-width:444px;overflow:hidden}}.VcUpsellBlock .text-container .title-text[data-v-3e23f57f]{font-weight:var(--font-weight-large2);font-size:var(--font-size-medium2);line-height:32px;letter-spacing:.01em}@media screen and (min-width:960px){.VcUpsellBlock .text-container .title-text[data-v-3e23f57f]{font-size:var(--font-size-large);line-height:40px}}.VcUpsellBlock .text-container .sub-text[data-v-3e23f57f]{font-weight:var(--font-weight-large);font-size:var(--font-size-medium);line-height:28px;letter-spacing:var(--letter-spacing)}.VcUpsellBlock .text-container .bullets-text[data-v-3e23f57f]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:20px}.VcUpsellBlock .text-container .bullets-text .bullets-icon[data-v-3e23f57f]{margin-inline-end:12px}.VcUpsellBlock .text-container .bullets-text .bullets-span[data-v-3e23f57f]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-small2);line-height:20px;color:#000}.VcUpsellBlock .text-container .cta-container[data-v-3e23f57f]{flex:1 1 auto;flex-flow:row wrap;align-items:center;margin:32px auto 0}.VcUpsellBlock .text-container .cta-container .primary-cta[data-v-3e23f57f]{flex:0 0 100%;width:auto;margin:0 auto;max-width:214px;line-height:48px;min-height:48px;font-weight:var(--font-weight-large);font-size:var(--font-size-small2)}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container .primary-cta[data-v-3e23f57f]{flex:0 0 45%;margin:0;height:48px}}.VcUpsellBlock .text-container .cta-container .primary-cta .v-btn__content[data-v-3e23f57f]{flex-flow:row wrap;width:100%;white-space:break-spaces}.VcUpsellBlock .text-container .cta-container .secondary-cta[data-v-3e23f57f]{flex:0 0 100%;text-align:center;font-weight:var(--font-weight-large);font-size:var(--font-size-small2);line-height:48px;height:48px;color:var(--gray-darken-5);margin:0;text-decoration:none}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container .secondary-cta[data-v-3e23f57f]{flex:0 0 45%;color:var(--blue);font-weight:var(--font-weight-large2)}}.VcUpsellBlock .text-container .cta-container-dialog[data-v-3e23f57f]{width:100%;z-index:1;position:absolute;justify-content:space-between;background:#fff;bottom:0;left:0;right:0;margin:0;height:72px;padding:0 24px}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog[data-v-3e23f57f]{position:static;justify-content:flex-start;padding:0}}.VcUpsellBlock .text-container .cta-container-dialog .primary-cta[data-v-3e23f57f]{flex:0 0 55%;margin:0;order:2}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog .primary-cta[data-v-3e23f57f]{flex:0 0 45%;order:0}}.VcUpsellBlock .text-container .cta-container-dialog .secondary-cta[data-v-3e23f57f]{flex:1 0 35%;padding-top:0}@media screen and (min-width:960px){.VcUpsellBlock .text-container .cta-container-dialog .secondary-cta[data-v-3e23f57f]{flex:0 0 45%}}.VcUpsellBlock .images-container[data-v-3e23f57f]{position:relative;flex:1 0 100%;margin:0 auto;min-height:40%;height:auto;overflow:hidden}@media screen and (min-width:960px){.VcUpsellBlock .images-container[data-v-3e23f57f]{flex:0 0 45%;overflow:visible}}.VcUpsellBlock .images-container .upsell-image[data-v-3e23f57f]{position:absolute;width:320px;height:380px;right:0;left:0;margin:0 auto}@media screen and (min-width:960px){.VcUpsellBlock .images-container .upsell-image[data-v-3e23f57f]{height:580px;width:466px;top:0;bottom:0;margin:auto}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$7 = "data-v-3e23f57f";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

var script$6 = {
  name: "VcDropzone",
  components: {
    VcLayout: __vue_component__$U
  },
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    supportedFileTypes: {
      type: Array,
      default: () => []
    },
    supportedFileSizeMb: {
      type: Number,
      default: 0
    },
    validatorFn: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'vc-dropzone'
    }
  },

  data() {
    return {
      isHovered: false,
      isActive: false
    };
  },

  methods: {
    hover(hovered) {
      this.isHovered = hovered;
    },

    activate(active) {
      this.isActive = active;
    },

    _typeValidate(fileType) {
      return this.supportedFileTypes.includes(fileType.toLowerCase());
    },

    _sizeValidate(fileSize) {
      return this._mbToBytes(this.supportedFileSizeMb) >= fileSize;
    },

    _mbToBytes(mb) {
      return mb * 1048576;
    },

    addFiles(name, filelist) {
      const validatedFiles = [...filelist].map(file => {
        const validatedFile = {
          file
        };

        if (this.validatorFn) {
          validatedFile.externalValidated = this.validatorFn(file);
        }

        if (this.supportedFileSizeMb) {
          validatedFile.sizeValidated = this._sizeValidate(file.size);
        }

        if (this.supportedFileTypes.length) {
          validatedFile.typeValidated = this._typeValidate(file.name.toLowerCase().split('.').pop());
        }

        return validatedFile;
      });
      this.$refs.dropzone.value = null;
      return validatedFiles;
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('VcLayout', {
    staticClass: "dropzone__wrap",
    class: {
      'dropzone__wrap--hovered': _vm.isHovered,
      'dropzone__wrap--active': _vm.isActive,
      'dropzone__wrap--disabled': _vm.disabled
    },
    attrs: {
      "align-center": "",
      "justify-center": "",
      "data-qa": _vm.dataQa + "--wrap"
    }
  }, [_c('label', {
    staticClass: "dropzone__label",
    attrs: {
      "data-qa": _vm.dataQa + "--label"
    }
  }, [_c('input', {
    ref: "dropzone",
    staticClass: "dropzone__input",
    attrs: {
      "type": "file",
      "accept": "*/*",
      "multiple": "",
      "data-qa": _vm.dataQa + "--input",
      "disabled": _vm.disabled
    },
    on: {
      "change": function ($event) {
        _vm.$emit('onFilesValidated', {
          validatedFiles: _vm.addFiles('vc-dropzone', $event.target.files)
        });
      },
      "dragleave": function ($event) {
        return _vm.activate(false);
      },
      "dragenter": function ($event) {
        return _vm.activate(true);
      },
      "mouseenter": function ($event) {
        return _vm.hover(true);
      },
      "mouseleave": function ($event) {
        return _vm.hover(false);
      }
    }
  }), _vm._v(" "), _vm._t("default", function () {
    return [_vm.title ? _c('span', {
      staticClass: "dropzone__title",
      attrs: {
        "data-qa": _vm.dataQa + "--label-title"
      }
    }, [_vm._v(_vm._s(_vm.title || _vm.$dst('ds.dropzone.default_title')))]) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('span', {
      staticClass: "dropzone__subtitle",
      attrs: {
        "data-qa": _vm.dataQa + "--label-subtitle"
      }
    }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()];
  })], 2)]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-7efc8e1b_0", {
    source: "[data-v-7efc8e1b]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.dropzone__wrap[data-v-7efc8e1b]{position:relative;border:1px dashed var(--gray-darken-1);padding:var(--size-value3);min-height:var(--size-value18);width:100%;border-radius:var(--border-radius);background-color:var(--gray-lighten-4);transition:background-color .1s ease-out,border-color .1s ease-out}.dropzone__wrap--hovered[data-v-7efc8e1b]{background-color:var(--gray-lighten-4);border-color:var(--gray-darken-1)}.dropzone__wrap--active[data-v-7efc8e1b]{background-color:var(--modal-bg-color);border-color:var(--dropzone-active-border-color);filter:drop-shadow(0 0 2px var(--dropzone-active-second-border-color))}.dropzone__wrap--disabled[data-v-7efc8e1b]{background-color:var(--gray-lighten-4);border-color:var(--gray)}.dropzone__input[data-v-7efc8e1b]{width:100%;height:100%;position:absolute;opacity:0;left:0;top:0;cursor:pointer}.dropzone__wrap--disabled .dropzone__input[data-v-7efc8e1b]{cursor:default}.dropzone__label[data-v-7efc8e1b]{display:flex;flex-direction:column;text-align:center}.dropzone__wrap--hovered .dropzone__label[data-v-7efc8e1b]{color:var(--gray-darken-5)}.dropzone__subtitle[data-v-7efc8e1b],.dropzone__title[data-v-7efc8e1b]{color:var(--blue);font-size:var(--font-size-x-small)}.dropzone__wrap--disabled .dropzone__subtitle[data-v-7efc8e1b],.dropzone__wrap--disabled .dropzone__title[data-v-7efc8e1b]{color:var(--gray-darken-2)}.dropzone__title[data-v-7efc8e1b]{font-weight:var(--font-weight-medium2)}.dropzone__subtitle[data-v-7efc8e1b]{font-weight:var(--font-weight-light)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-7efc8e1b";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

var script$5 = {
  name: "VcRadio",
  components: {
    VcTooltip: __vue_component__$L,
    VcIcon: __vue_component__$X,
    VRadio: VRadio
  },
  props: {
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    tooltipProps: {
      type: Object
    },
    dataQa: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-radio', {
    staticClass: "vc-radio",
    attrs: {
      "color": 'var(--green)',
      "value": _vm.value
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', _vm.value);
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "label-container",
          attrs: {
            "data-qa": _vm.dataQa || "radio-" + _vm.value
          }
        }, [_vm.icon ? _c('vc-icon', {
          staticClass: "radio-icon"
        }, [_vm._v("\n        " + _vm._s(_vm.icon) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._t("label", function () {
          return [_vm.label ? _c('span', {
            staticClass: "radio-label"
          }, [_vm._v("\n          " + _vm._s(_vm.label) + "\n        ")]) : _vm._e()];
        }), _vm._v(" "), _vm.tooltipProps ? _c('vc-tooltip', _vm._b({
          staticClass: "radio-tooltip",
          scopedSlots: _vm._u([{
            key: "content",
            fn: function () {
              return [_vm._t("tooltip-content")];
            },
            proxy: true
          }], null, true)
        }, 'vc-tooltip', _vm.tooltipProps, false)) : _vm._e()], 2)];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-729dbbdc_0", {
    source: ".label-container[data-v-729dbbdc]{margin-inline-start:var(--size-value2)}.radio-label[data-v-729dbbdc]{color:var(--gray-darken-5);font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small)}.radio-icon[data-v-729dbbdc]{margin-inline-start:var(--size-value2);font-size:var(--size-value4)}.radio-icon[data-v-729dbbdc]  .v-icon__component{height:var(--size-value4);width:var(--size-value4)}.radio-tooltip[data-v-729dbbdc]{height:var(--size-value5);margin-inline-start:var(--size-value2)}.radio-tooltip[data-v-729dbbdc]  .v-icon__component{width:var(--size-value4)}.vc-radio[data-v-729dbbdc]{margin:0;margin-bottom:auto}.vc-radio.v-input--radio-group--column[data-v-729dbbdc]  .v-radio:not(:last-child):not(:only-child){margin-bottom:var(--size-value4)}.vc-radio[data-v-729dbbdc]  .v-input--selection-controls__ripple{inset-inline-start:-9px;top:calc(50% - 17px);width:var(--size-value5);height:var(--size-value5)}.vc-radio[data-v-729dbbdc]  .v-input--selection-controls__input{margin:0;padding:0;margin-bottom:auto;height:var(--size-value5);width:var(--size-value4)}.vc-radio[data-v-729dbbdc]  .v-input--selection-controls__input .v-icon{font-size:var(--font-size-medium)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-729dbbdc";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var script$4 = {
  name: "VcRadioGroup",
  components: {
    VcRadio: __vue_component__$5,
    VRadioGroup: VRadioGroup
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    items: {
      type: Array,
      required: true,

      validator(val) {
        return val.every(item => item.value) && val.length > 1;
      }

    },
    value: {
      type: String,
      required: true
    },
    dataQa: {
      type: String,
      default: 'vc-radio-group'
    },
    title: {
      type: String,
      default: ''
    }
  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm.title ? _c('div', {
    staticClass: "vc-title"
  }, [_vm._t("title", function () {
    return [_vm._v(_vm._s(_vm.title))];
  })], 2) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    staticClass: "vc-radio-buttons",
    attrs: {
      "value": _vm.value,
      "hide-details": "auto"
    },
    on: {
      "change": function (val) {
        return _vm.$emit('change', val);
      }
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('VcRadio', _vm._b({
      key: item.value,
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_vm._t("label-" + item.value)];
        },
        proxy: true
      }, {
        key: "tooltip-content",
        fn: function () {
          return [_vm._t("tooltip-content-" + item.value)];
        },
        proxy: true
      }], null, true)
    }, 'VcRadio', item, false));
  }), 1)], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-0bf8cc5c_0", {
    source: ".vc-radio-buttons[data-v-0bf8cc5c]{margin:0;padding:0}.vc-radio-buttons.v-input--radio-group--column[data-v-0bf8cc5c]  .v-radio:not(:last-child):not(:only-child){margin-bottom:var(--size-value4)}.vc-title[data-v-0bf8cc5c]{color:var(--gray-darken-5);margin-bottom:var(--size-value2);font-weight:var(--font-weight-large);font-size:var(--size-value3);line-height:var(--size-value4)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-0bf8cc5c";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var script$3 = {
  name: "VcSegmentedControl",
  components: {
    VcIcon: __vue_component__$X,
    VBtn: VBtn,
    VBtnToggle: VBtnToggle
  },
  props: {
    items: {
      type: Array,
      required: true,
      validator: prop => prop.every(e => e.label)
    },
    value: {
      type: Number,
      required: true
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'VcSegmentedControl'
    }
  },
  methods: {
    getDataQaForItem(item) {
      const index = this.items.indexOf(item);
      return `${this.dataQa}-item-${item.id || index}`;
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-btn-toggle', {
    staticClass: "button-group",
    attrs: {
      "value": _vm.value,
      "mandatory": _vm.mandatory,
      "data-qa": _vm.dataQa
    },
    on: {
      "change": function (value) {
        return _vm.$emit('change', value);
      }
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('v-btn', {
      key: item.id,
      attrs: {
        "id": item.id,
        "disabled": !!item.disabled,
        "data-qa": _vm.getDataQaForItem(item)
      }
    }, [item.icon ? _c('vc-icon', {
      staticClass: "item-icon",
      attrs: {
        "size": "16"
      }
    }, [_vm._v("\n      " + _vm._s(item.icon) + "\n    ")]) : _vm._e(), _vm._v("\n    " + _vm._s(item.label) + "\n  ")], 1);
  }), 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-ebfb67c4_0", {
    source: "[data-v-ebfb67c4]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]{border-radius:var(--border-radius);width:100%;max-width:100%;font-family:var(--primary-font-family)}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:first-child{border-bottom-left-radius:inherit;border-top-left-radius:inherit}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0;border-bottom-right-radius:inherit;border-top-right-radius:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:last-child{border-bottom-right-radius:inherit;border-top-right-radius:inherit}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:last-child{border-bottom-right-radius:0;border-top-right-radius:0;border-bottom-left-radius:inherit;border-top-left-radius:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:not(:first-child){border-left-width:0}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4] >button.v-btn:not(:first-child){border-left-width:1px;border-right-width:0}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn{flex:1;height:auto;padding-top:var(--size-value3);padding-bottom:var(--size-value3);font-family:var(--primary-font-family);font-size:var(--font-size-x-small);line-height:var(--size-value4);text-transform:none;letter-spacing:normal}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn:before{background-color:inherit}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn:not(.v-item--active){background:var(--gray-lighten-3);color:var(--gray-darken-4)}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn.v-item--active{box-shadow:var(--shadow-4);background:var(--modal-bg-color);color:var(--gray-darken-5)}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn:hover{background:var(--gray-lighten-4)}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn.v-btn--disabled{background:var(--gray-lighten-2);color:var(--gray-darken-2)}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn span{max-width:100%;white-space:initial}div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn .item-icon{padding-left:var(--size-value0);padding-right:var(--size-value1)}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn .item-icon{padding-left:var(--size-value1)}#app[dir=rtl] div.button-group.v-item-group.v-btn-toggle[data-v-ebfb67c4]  button.v-btn .item-icon{padding-right:var(--size-value0)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-ebfb67c4";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

const FORMATS = {
  DOCUMENT: ['doc', 'docx'],
  IMAGE: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
  PDF: ['pdf'],
  SPREADSHEET: ['xls', 'csv'],
  SLIDESHOW: ['ppt', 'pptx'],
  ARCHIVE: ['zip', 'rar'],
  AUDIO: ['mp3', 'wav'],
  VIDEO: ['avi', 'mp4', 'mkv', 'mov']
};
var script$2 = {
  name: "VcDocItem",
  components: {
    VcButton: __vue_component__$W,
    VcIcon: __vue_component__$X
  },
  props: {
    title: {
      type: String,
      required: true
    },
    uid: {
      type: String,
      required: true
    },
    isSignable: {
      type: Boolean,
      default: false
    },
    trimSignable: {
      type: Boolean,
      default: false
    },
    allowActions: {
      type: Boolean,
      default: true
    },
    dataQa: {
      type: String,
      default: 'vc-doc-item'
    },
    actions: {
      type: Array,
      validator: prop => prop.every(a => a.type && a.icon),
      default: () => [{
        type: 'onRemove',
        icon: 'trash'
      }]
    },
    uploaded: {
      type: Boolean,
      default: false
    },
    corrupted: {
      type: Boolean,
      default: false
    },
    corruptedLabel: {
      type: String,
      required: false
    }
  },
  computed: {
    extension() {
      return this.title.indexOf('.') !== -1 ? this.title.split('.').pop() : 'general';
    },

    docIcon() {
      const {
        DOCUMENT,
        IMAGE,
        PDF,
        SPREADSHEET,
        SLIDESHOW,
        ARCHIVE,
        AUDIO,
        VIDEO
      } = FORMATS;
      if (DOCUMENT.includes(this.extension)) return 'document';
      if (IMAGE.includes(this.extension)) return 'image';
      if (PDF.includes(this.extension)) return 'pdf';
      if (SPREADSHEET.includes(this.extension)) return 'sheet';
      if (SLIDESHOW.includes(this.extension)) return 'slideshow';
      if (ARCHIVE.includes(this.extension)) return 'archive';
      if (AUDIO.includes(this.extension)) return 'audio';
      if (VIDEO.includes(this.extension)) return 'video';
      return 'general';
    },

    flag() {
      if (this.corrupted) return '$corrupted_flag';else if (this.uploaded) return '$uploaded_flag';else return '';
    },

    corruptedLabelText() {
      return this.corruptedLabel || this.$dst('ds.document.corrupted');
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-doc-item",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "details__doc-icon",
    attrs: {
      "data-qa": _vm.dataQa + "-doc-icon"
    }
  }, [_c('VcIcon', {
    attrs: {
      "size": "24"
    }
  }, [_vm._v("\n        $doc_" + _vm._s(_vm.docIcon) + "\n      ")]), _vm._v(" "), _vm.uploaded || _vm.corrupted ? _c('VcIcon', {
    staticClass: "v-icon--flag",
    attrs: {
      "size": "16",
      "data-qa": _vm.dataQa + "-corrupted-label"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.flag) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      'title--corrupted': _vm.corrupted
    },
    attrs: {
      "data-qa": _vm.dataQa + "-title"
    }
  }, [_c('span', {
    staticClass: "title__header"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _vm.corrupted ? _c('span', {
    staticClass: "title__corrupted"
  }, [_vm._v("\n        " + _vm._s(_vm.corruptedLabelText) + "\n      ")]) : _vm._e()]), _vm._v(" "), _vm.isSignable ? _c('div', {
    staticClass: "signature",
    class: {
      'signature--trimmed': _vm.trimSignable
    },
    attrs: {
      "data-qa": _vm.dataQa + "-signature"
    }
  }, [_c('VcIcon', {
    staticClass: "signature__icon",
    attrs: {
      "size": "14"
    }
  }, [_vm._v("\n        $union\n      ")]), _vm._v(" "), !_vm.trimSignable ? _c('span', {
    staticClass: "signature__text"
  }, [_vm._v("\n        " + _vm._s(_vm.$dst('ds.document.signature')) + "\n      ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _vm.allowActions ? _c('div', {
    staticClass: "actions",
    attrs: {
      "data-qa": _vm.dataQa + "-actions"
    }
  }, _vm._l(_vm.actions, function (action) {
    return _c('VcButton', {
      attrs: {
        "icon": "",
        "data-qa": _vm.dataQa + "-action"
      },
      on: {
        "click": function ($event) {
          return _vm.$emit(action.type, _vm.uid);
        }
      },
      scopedSlots: _vm._u([{
        key: "prepend",
        fn: function () {
          return [_c('VcIcon', {
            attrs: {
              "size": "16"
            }
          }, [_vm._v("$" + _vm._s(action.icon))])];
        },
        proxy: true
      }], null, true)
    });
  }), 1) : _vm._e()]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-6c669e8b_0", {
    source: "[data-v-6c669e8b]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-doc-item[data-v-6c669e8b]{display:flex;align-items:center;padding:0 var(--size-value4);height:48px}.vc-doc-item .actions[data-v-6c669e8b]{display:flex;margin-inline-start:var(--size-value2)}.vc-doc-item .actions button[data-v-6c669e8b]{opacity:.4}.vc-doc-item .actions button[data-v-6c669e8b]:hover{opacity:1}.details[data-v-6c669e8b]{font-family:var(--primary-font-family);display:flex;flex-direction:row;align-items:center;width:100%;min-width:0}.details__doc-icon[data-v-6c669e8b]{position:relative}.details__doc-icon .v-icon[data-v-6c669e8b]{margin-inline-end:var(--size-value4)}.details__doc-icon .v-icon--flag[data-v-6c669e8b]{position:absolute;bottom:calc(-1 * var(--size-value1));inset-inline-end:calc(-1 * var(--size-value1))}.title[data-v-6c669e8b]{padding-inline-end:var(--size-value3);line-height:18px;display:flex;overflow:hidden}.title--corrupted[data-v-6c669e8b]{flex-direction:column}.title__corrupted[data-v-6c669e8b],.title__header[data-v-6c669e8b]{font-weight:var(--font-weight-medium2);font-size:var(--font-size-x-small);color:var(--gray-darken-5);white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.title__corrupted[data-v-6c669e8b]{color:var(--red)}.signature[data-v-6c669e8b]{display:flex;flex-direction:row;align-items:center;margin-inline-start:auto}.signature--trimmed[data-v-6c669e8b]{margin-inline-start:0}.signature__icon[data-v-6c669e8b]{color:var(--gray-darken-5);margin-inline-end:var(--size-value2)}.signature__text[data-v-6c669e8b]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small);color:var(--gray-darken-5);white-space:nowrap}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-6c669e8b";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
//
//
//
//
//
var script$1 = {
  name: "VcTimeSince",
  props: {
    timestamp: {
      required: true,
      type: Number,
      validator: prop => Date.now() > prop
    },
    dataQa: {
      type: String,
      default: 'vc-time-since'
    }
  },
  computed: {
    timeSince() {
      const years = 31536000;
      const months = 2592000;
      const days = 86400;
      const hours = 3600;
      const minutes = 60;
      const seconds = Math.floor((new Date() - this.timestamp) / 1000);
      let interval = seconds / years;

      if (interval > 1) {
        return `${this.$dst("ds.time_since.years", {
          years: Math.floor(interval)
        })}`;
      }

      interval = seconds / months;

      if (interval > 1) {
        return `${this.$dst("ds.time_since.months", {
          months: Math.floor(interval)
        })}`;
      }

      interval = seconds / days;

      if (Math.floor(interval) === 1) {
        return `${this.$dst("ds.time_since.yesterday")}`;
      }

      if (interval > 1) {
        return `${this.$dst("ds.time_since.days", {
          days: Math.floor(interval)
        })}`;
      }

      interval = seconds / hours;

      if (interval > 1) {
        return `${this.$dst("ds.time_since.hours", {
          hours: Math.floor(interval)
        })}`;
      }

      interval = seconds / minutes;

      if (interval > 1) {
        return `${this.$dst("ds.time_since.minutes", {
          minutes: Math.floor(interval)
        })}`;
      }

      return `${this.$dst("ds.time_since.now")}`;
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_vm._v("\n " + _vm._s(_vm.timeSince) + "\n")]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var script = {
  directives: {
    Intersect: Intersect
  },

  name: 'VcSearchPicker',

  components: {
    VcIcon: __vue_component__$X,
    VcCheckbox: __vue_component__$C,
    VcLoader: __vue_component__$q,
    VAutocomplete: VAutocomplete
  },

  model: {
    prop: 'selectedItems',
    event: 'onSelectionChange'
  },

  props: {
    items: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(item => item.text && item.value)
    },
    selectedItems: {
      type: Array,
      default: () => [],
      validator: prop => prop.every(item => typeof item === 'string')
    },
    noDataText: {
      type: String,
      required: false
    },
    errorLabelText: {
      type: String,
      required: false
    },
    placeholderBlurText: {
      type: String,
      required: false
    },
    placeholderFocus: {
      type: String,
      default: ''
    },
    showInnerIcon: {
      type: Boolean,
      default: true
    },
    iconType: {
      type: String,
      default: 'magnify_glass'
    },
    dataQa: {
      type: String,
      default: 'vc-search-picker'
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      focused: false,
      searchInput: ''
    };
  },

  computed: {
    placeholder() {
      return this.focused ? this.placeholderFocus : this.placeholderBlur;
    },

    menuProps() {
      return {
        value: this.focused,
        contentClass: 'vc-select-field-menu'
      };
    },

    noData() {
      return this.noDataText || this.$dst('ds.multi_select.no_data');
    },

    errorLabel() {
      return this.errorLabelText || this.$dst('ds.multi_select.error_label');
    },

    placeholderBlur() {
      return this.placeholderBlurText || this.$dst('ds.multi_select.placeholder');
    }

  },

  methods: {
    toggleMenu() {
      this.$emit('onMenuToggled', {
        isOpen: !this.focused
      });
      this.focused = !this.focused;
    },

    itemsIntersection(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.$emit('onScrollEnd');
      }
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vc-search-picker",
    attrs: {
      "data-qa": _vm.dataQa
    }
  }, [_c('v-autocomplete', {
    staticClass: "autocomplete",
    class: {
      'autocomplete--open': _vm.focused,
      'autocomplete--error': _vm.error,
      'autocomplete--has-items': _vm.selectedItems.length,
      'autocomplete--search-content': _vm.searchInput && _vm.searchInput.length
    },
    attrs: {
      "value": _vm.selectedItems,
      "items": _vm.items,
      "placeholder": _vm.placeholder,
      "no-data-text": _vm.noData,
      "menu-props": _vm.menuProps,
      "search-input": _vm.searchInput,
      "multiple": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": [function ($event) {
        _vm.searchInput = $event;
      }, function (text) {
        return text && text.length && _vm.$emit('onSearchInput', text);
      }],
      "change": function (newVal) {
        return _vm.$emit('onSelectionChange', newVal);
      },
      "click:append": _vm.toggleMenu,
      "blur": function ($event) {
        _vm.focused = false;

        _vm.$emit('onMenuToggled', {
          isOpen: false
        });
      }
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.toggleMenu.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_vm.showInnerIcon ? _c('VcIcon', {
          attrs: {
            "size": "16"
          }
        }, [_vm._v("$" + _vm._s(_vm.iconType))]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c('VcCheckbox', {
          attrs: {
            "checked": _vm.selectedItems.includes(data.item.value)
          }
        }), _vm._v(" "), _vm._t("customItem", function () {
          return [_c('div', [_vm._v(_vm._s(data.item.text))])];
        }, {
          "item": data.item
        })];
      }
    }, {
      key: "selection",
      fn: function () {
        return [_c('span', {
          staticClass: "placeholder-text"
        }, [_vm._v(_vm._s(_vm.placeholder))])];
      },
      proxy: true
    }, {
      key: "append-item",
      fn: function () {
        return [_vm.loading ? _c('VcLoader', {
          staticClass: "spinner",
          attrs: {
            "size": 20,
            "width": 2,
            "data-qa": "spinner"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          directives: [{
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.itemsIntersection,
            expression: "itemsIntersection"
          }]
        })];
      },
      proxy: true
    }], null, true)
  }), _vm._v(" "), _vm.error ? _c('span', {
    staticClass: "vc-search-picker__error-label",
    attrs: {
      "data-qa": "error-label"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorLabel) + "\n  ")]) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-de7056da_0", {
    source: "[data-v-de7056da]:root{--primary-font-family:Montserrat;--font-size-xxx-small:9px;--font-size-xx-small:12px;--font-size-x-small:13px;--font-size-small:14px;--font-size-small2:15px;--font-size-small3:17px;--font-size-medium:18px;--font-size-medium1:22px;--font-size-medium2:24px;--font-size-large:28px;--font-weight-light:300;--font-weight-medium:400;--font-weight-medium2:500;--font-weight-large:600;--font-weight-large2:700;--font-weight-xl:800;--letter-spacing:0.003em;--size-value0:0px;--size-value1:4px;--size-value2:8px;--size-value3:12px;--size-value4:16px;--size-value5:20px;--size-value6:24px;--size-value7:28px;--size-value8:32px;--size-value9:36px;--size-value10:40px;--size-value11:44px;--size-value12:48px;--size-value13:52px;--size-value14:56px;--size-value15:60px;--size-value16:64px;--size-value17:68px;--size-value18:72px;--size-value19:76px;--size-value20:80px;--border-radius:6px;--border-frame:1px solid #e0e0e0;--border-focused-frame:1px solid var(--v-secondary-base);--shadow-focused-frame:0px 0px 0px 3px var(--v-secondary-lighten1);--popover-width:360px;--popover-max-height:464px;--popover-border-radius:10px;--modal-desktop-offset:-112px;--modal-bg-color:#ffffff;--modal-box-shadow:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--modal-border-radius:10px;--modal-width-small:384px;--modal-width-medium:576px;--modal-width-large:816px;--modal-width-x-large:972px;--avatar-x-sm:24px;--avatar-sm:32px;--avatar-md:40px;--avatar-lg:48px;--dropzone-active-border-color:#1e93b7;--dropzone-active-second-border-color:#95cddb;--select-field-height:52px;--search-picker-border-color:#1e93b7;--search-picker-second-border-color:#95cddb;--select-field-height:52px;--gray-darken-5:#212121;--gray-darken-4:#616161;--gray-darken-3:#757575;--gray-darken-2:#999999;--gray-darken-1:#b3b3b3;--gray:#cccccc;--gray-lighten-1:#e0e0e0;--gray-lighten-2:#ededed;--gray-lighten-3:#f7f7f7;--gray-lighten-4:#fafafa;--neutral:#586E8C;--neutral-lighten-1:#D6DBE6;--neutral-lighten-2:#EAEDF2;--neutral-lighten-3:#F8F9FB;--red:#F2514A;--red-lighten-1:#F79792;--red-lighten-2:#FBCBC9;--red-lighten-3:#FDE8E7;--yellow:#FFC511;--yellow-lighten-1:#FFDC70;--yellow-lighten-2:#FFEDB8;--yellow-lighten-3:#FFF7E0;--green:#54D28C;--green-lighten-1:#98E4BA;--green-lighten-2:#CFF8E1;--green-lighten-3:#EAFCF2;--blue:#478FFF;--blue-lighten-1:#91BCFF;--blue-lighten-2:#C8DDFF;--blue-lighten-3:#E7F0FF;--orange:#FF8F00;--orange-lighten-1:#FCB965;--orange-lighten-2:#FAD9B0;--orange-lighten-3:#F9EBDA;--shadow-1:0px 1px 4px rgba(0, 0, 0, 0.11);--shadow-2:0px 2px 5px rgba(0, 0, 0, 0.1),0px 2px 2px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.06);--shadow-3:0px 3px 2px rgba(0, 0, 0, 0.101961);--shadow-4:0px 1px 1px rgba(0, 0, 0, 0.06),0px 3px 8px rgba(0, 0, 0, 0.15);--shadow-5:0px 4px 18px rgba(0, 0, 0, 0.1);--shadow-6:0px 1px 10px rgba(0, 0, 0, 0.12),0px 4px 7px rgba(0, 0, 0, 0.14),0px 2px 4px -1px rgba(0, 0, 0, 0.2);--shadow-7:0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px rgba(0, 0, 0, 0.14),0px 1px 18px rgba(0, 0, 0, 0.12);--shadow-8:0px 5px 7px 3px rgba(0, 0, 0, 0.26);--shadow-9:0px 7px 8px -4px rgba(0, 0, 0, 0.2),2px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px rgba(0, 0, 0, 0.12);--shadow-10:0px 4px 8px #cccccc}.vc-search-picker[data-v-de7056da]{position:relative}.vc-search-picker__error-label[data-v-de7056da]{font-weight:var(--font-weight-medium);font-size:var(--font-size-xx-small);color:var(--red)}.vc-search-picker[data-v-de7056da]  .v-input__slot{border:1px solid var(--gray-lighten-1);border-radius:var(--border-radius);height:var(--size-value13);padding:0 var(--size-value5)}.vc-search-picker[data-v-de7056da]  .v-input__slot:hover{border-color:var(--gray-darken-2)}.vc-search-picker[data-v-de7056da]  .v-input__icon--append .v-icon{transform:rotate(0)}.vc-search-picker[data-v-de7056da]  .autocomplete--open .v-input__icon--append .v-icon{transform:rotate(180deg)}.vc-search-picker[data-v-de7056da]  .autocomplete--open .v-input__slot{border-color:var(--search-picker-border-color);outline:3px solid var(--search-picker-second-border-color)}.vc-search-picker[data-v-de7056da]  .autocomplete{height:var(--size-value13);padding-top:0;margin-top:0}.vc-search-picker[data-v-de7056da]  .autocomplete--error .v-input__slot{border-color:var(--red)}.vc-search-picker[data-v-de7056da]  .autocomplete--has-items .placeholder-text:not(:first-of-type){display:none}.vc-search-picker[data-v-de7056da]  .autocomplete--has-items.autocomplete--search-content .placeholder-text{display:none}.vc-search-picker[data-v-de7056da]  .placeholder-text{font-size:var(--font-size-small2);font-weight:var(--font-weight-medium);color:var(--gray-darken-5);margin-inline-end:var(--size-value2);text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.vc-search-picker[data-v-de7056da]  .v-text-field>.v-input__control>.v-input__slot:after,.vc-search-picker[data-v-de7056da]  .v-text-field>.v-input__control>.v-input__slot:before{content:initial}.vc-search-picker[data-v-de7056da]  .v-input__prepend-inner{margin-right:auto;padding-inline-end:var(--size-value3);height:100%;display:flex;align-items:center;margin-top:0}.vc-search-picker[data-v-de7056da]  .v-select__selections{flex-wrap:nowrap}.vc-search-picker[data-v-de7056da]  .v-select__selections input[type=text]{display:inline-block;font-size:var(--font-size-small2);color:var(--gray-darken-5)}.vc-search-picker[data-v-de7056da]  .v-list-item--active::before{content:none}.v-menu__content.vc-select-field-menu[data-v-de7056da]{top:var(--size-value4)}.v-menu__content.vc-select-field-menu .v-input.vc-checkbox[data-v-de7056da]{margin:0;padding:0}.v-menu__content.vc-select-field-menu .spinner[data-v-de7056da]{margin:0 auto;display:block}[data-v-de7056da] .v-list-item--link{font-size:var(--font-size-x-small)}[data-v-de7056da] .v-list-item--link:before{content:initial}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-de7056da";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Put here any components that need to be available to users of the package

var components$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  VcConfirmModal: __vue_component__$R,
  VcInputModal: __vue_component__$P,
  VcNoticeModal: __vue_component__$N,
  VcModalFooter: __vue_component__$T,
  VcModalHeader: __vue_component__$S,
  VcAlert: __vue_component__$M,
  VcTooltip: __vue_component__$L,
  VcIconWithTooltip: __vue_component__$K,
  VcBottomActions: __vue_component__$I,
  VcActionList: __vue_component__$H,
  VcActions: __vue_component__$G,
  VcStepsBar: __vue_component__$F,
  VcMobileWizardProgress: __vue_component__$D,
  VcProgressCircular: __vue_component__$E,
  VcChecklistItem: __vue_component__$B,
  VcListbox: __vue_component__$y,
  VcBottomSheet: __vue_component__$x,
  VcInputBottomSheet: __vue_component__$v,
  VcPopover: __vue_component__$u,
  VcInputPopover: __vue_component__$t,
  VcChip: __vue_component__$s,
  VcSearchBar: __vue_component__$z,
  VcButton: __vue_component__$W,
  VcButtonGroup: __vue_component__$r,
  VcForm: __vue_component__$Q,
  VcIcon: __vue_component__$X,
  VcLayout: __vue_component__$U,
  VcLoader: __vue_component__$q,
  VcSwitch: __vue_component__$w,
  VcListEntity: __vue_component__$p,
  VcExpansionCard: __vue_component__$o,
  VcTextField: __vue_component__$A,
  VcAvatar: __vue_component__$J,
  VcTextArea: __vue_component__$n,
  VcSelectField: __vue_component__$m,
  VcToast: __vue_component__$l,
  VcCard: __vue_component__$k,
  VcCheckbox: __vue_component__$C,
  VcFilterPanel: __vue_component__$j,
  VcFocusArea: __vue_component__$i,
  VcLink: __vue_component__$h,
  VcListItem: __vue_component__$g,
  VcGroupHeader: __vue_component__$f,
  VcEmptyState: __vue_component__$d,
  VcSvg: __vue_component__$e,
  VcBanner: __vue_component__$c,
  VcWizardCtaContainer: __vue_component__$b,
  VcWizard: __vue_component__$9,
  VcImage: __vue_component__$O,
  VcBadge: __vue_component__$8,
  VcUpsellBlock: __vue_component__$7,
  VcModalContainer: __vue_component__$V,
  VcDropzone: __vue_component__$6,
  VcRadioGroup: __vue_component__$4,
  VcRadio: __vue_component__$5,
  VcSegmentedControl: __vue_component__$3,
  VcDocItem: __vue_component__$2,
  VcTimeSince: __vue_component__$1,
  VcSearchPicker: __vue_component__
});

// Import vue components

const install = function installdesignSystem(Vue) {
  Object.entries(components$1).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
}; // Create module definition for Vue.use()

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': install,
  VcConfirmModal: __vue_component__$R,
  VcInputModal: __vue_component__$P,
  VcNoticeModal: __vue_component__$N,
  VcModalFooter: __vue_component__$T,
  VcModalHeader: __vue_component__$S,
  VcAlert: __vue_component__$M,
  VcTooltip: __vue_component__$L,
  VcIconWithTooltip: __vue_component__$K,
  VcBottomActions: __vue_component__$I,
  VcActionList: __vue_component__$H,
  VcActions: __vue_component__$G,
  VcStepsBar: __vue_component__$F,
  VcMobileWizardProgress: __vue_component__$D,
  VcProgressCircular: __vue_component__$E,
  VcChecklistItem: __vue_component__$B,
  VcListbox: __vue_component__$y,
  VcBottomSheet: __vue_component__$x,
  VcInputBottomSheet: __vue_component__$v,
  VcPopover: __vue_component__$u,
  VcInputPopover: __vue_component__$t,
  VcChip: __vue_component__$s,
  VcSearchBar: __vue_component__$z,
  VcButton: __vue_component__$W,
  VcButtonGroup: __vue_component__$r,
  VcForm: __vue_component__$Q,
  VcIcon: __vue_component__$X,
  VcLayout: __vue_component__$U,
  VcLoader: __vue_component__$q,
  VcSwitch: __vue_component__$w,
  VcListEntity: __vue_component__$p,
  VcExpansionCard: __vue_component__$o,
  VcTextField: __vue_component__$A,
  VcAvatar: __vue_component__$J,
  VcTextArea: __vue_component__$n,
  VcSelectField: __vue_component__$m,
  VcToast: __vue_component__$l,
  VcCard: __vue_component__$k,
  VcCheckbox: __vue_component__$C,
  VcFilterPanel: __vue_component__$j,
  VcFocusArea: __vue_component__$i,
  VcLink: __vue_component__$h,
  VcListItem: __vue_component__$g,
  VcGroupHeader: __vue_component__$f,
  VcEmptyState: __vue_component__$d,
  VcSvg: __vue_component__$e,
  VcBanner: __vue_component__$c,
  VcWizardCtaContainer: __vue_component__$b,
  VcWizard: __vue_component__$9,
  VcImage: __vue_component__$O,
  VcBadge: __vue_component__$8,
  VcUpsellBlock: __vue_component__$7,
  VcModalContainer: __vue_component__$V,
  VcDropzone: __vue_component__$6,
  VcRadioGroup: __vue_component__$4,
  VcRadio: __vue_component__$5,
  VcSegmentedControl: __vue_component__$3,
  VcDocItem: __vue_component__$2,
  VcTimeSince: __vue_component__$1,
  VcSearchPicker: __vue_component__
});

// iife/cjs usage extends esm default export - so import it all
// only expose one global var, with component exports exposed as properties of
// that global var (eg. plugin.component)

Object.entries(components).forEach(([componentName, component]) => {
  if (componentName !== 'default') {
    install[componentName] = component;
  }
});

export { install as default };
